var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var round$1 = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    // Fallback to 1 in case both values are `0`
    scaleX = rect.width / element.offsetWidth || 1;
    scaleY = rect.height / element.offsetHeight || 1;
  }

  return {
    width: round$1(rect.width / scaleX),
    height: round$1(rect.height / scaleY),
    top: round$1(rect.top / scaleY),
    right: round$1(rect.right / scaleX),
    bottom: round$1(rect.bottom / scaleY),
    left: round$1(rect.left / scaleX),
    x: round$1(rect.left / scaleX),
    y: round$1(rect.top / scaleY)
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(round(x * dpr) / dpr) || 0,
    y: round(round(y * dpr) / dpr) || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top) {
      sideY = bottom; // $FlowFixMe[prop-missing]

      y -= offsetParent[heightProp] - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right; // $FlowFixMe[prop-missing]

      x -= offsetParent[widthProp] - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis || checkAltAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

    if (checkMainAxis) {
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = rect.width / element.offsetWidth || 1;
  var scaleY = rect.height / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper$2 = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers$1
}); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var Popper = /*#__PURE__*/Object.freeze({
  __proto__: null,
  popperGenerator: popperGenerator,
  detectOverflow: detectOverflow,
  createPopperBase: createPopper$2,
  createPopper: createPopper,
  createPopperLite: createPopper$1,
  top: top,
  bottom: bottom,
  right: right,
  left: left,
  auto: auto,
  basePlacements: basePlacements,
  start: start,
  end: end,
  clippingParents: clippingParents,
  viewport: viewport,
  popper: popper,
  reference: reference,
  variationPlacements: variationPlacements,
  placements: placements,
  beforeRead: beforeRead,
  read: read,
  afterRead: afterRead,
  beforeMain: beforeMain,
  main: main,
  afterMain: afterMain,
  beforeWrite: beforeWrite,
  write: write,
  afterWrite: afterWrite,
  modifierPhases: modifierPhases,
  applyStyles: applyStyles$1,
  arrow: arrow$1,
  computeStyles: computeStyles$1,
  eventListeners: eventListeners,
  flip: flip$1,
  hide: hide$1,
  offset: offset$1,
  popperOffsets: popperOffsets$1,
  preventOverflow: preventOverflow$1
});

/*!
  * Bootstrap v5.1.0 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
const MAX_UID = 1000000;
const MILLISECONDS_MULTIPLIER = 1000;
const TRANSITION_END = 'transitionend'; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

const toType = obj => {
  if (obj === null || obj === undefined) {
    return `${obj}`;
  }

  return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * --------------------------------------------------------------------------
 * Public Util Api
 * --------------------------------------------------------------------------
 */


const getUID = prefix => {
  do {
    prefix += Math.floor(Math.random() * MAX_UID);
  } while (document.getElementById(prefix));

  return prefix;
};

const getSelector = element => {
  let selector = element.getAttribute('data-bs-target');

  if (!selector || selector === '#') {
    let hrefAttr = element.getAttribute('href'); // The only valid content that could double as a selector are IDs or classes,
    // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
    // `document.querySelector` will rightfully complain it is invalid.
    // See https://github.com/twbs/bootstrap/issues/32273

    if (!hrefAttr || !hrefAttr.includes('#') && !hrefAttr.startsWith('.')) {
      return null;
    } // Just in case some CMS puts out a full URL with the anchor appended


    if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
      hrefAttr = `#${hrefAttr.split('#')[1]}`;
    }

    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null;
  }

  return selector;
};

const getSelectorFromElement = element => {
  const selector = getSelector(element);

  if (selector) {
    return document.querySelector(selector) ? selector : null;
  }

  return null;
};

const getElementFromSelector = element => {
  const selector = getSelector(element);
  return selector ? document.querySelector(selector) : null;
};

const getTransitionDurationFromElement = element => {
  if (!element) {
    return 0;
  } // Get transition-duration of the element


  let {
    transitionDuration,
    transitionDelay
  } = window.getComputedStyle(element);
  const floatTransitionDuration = Number.parseFloat(transitionDuration);
  const floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

  if (!floatTransitionDuration && !floatTransitionDelay) {
    return 0;
  } // If multiple durations are defined, take the first


  transitionDuration = transitionDuration.split(',')[0];
  transitionDelay = transitionDelay.split(',')[0];
  return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};

const triggerTransitionEnd = element => {
  element.dispatchEvent(new Event(TRANSITION_END));
};

const isElement = obj => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (typeof obj.jquery !== 'undefined') {
    obj = obj[0];
  }

  return typeof obj.nodeType !== 'undefined';
};

const getElement = obj => {
  if (isElement(obj)) {
    // it's a jQuery object or a node element
    return obj.jquery ? obj[0] : obj;
  }

  if (typeof obj === 'string' && obj.length > 0) {
    return document.querySelector(obj);
  }

  return null;
};

const typeCheckConfig = (componentName, config, configTypes) => {
  Object.keys(configTypes).forEach(property => {
    const expectedTypes = configTypes[property];
    const value = config[property];
    const valueType = value && isElement(value) ? 'element' : toType(value);

    if (!new RegExp(expectedTypes).test(valueType)) {
      throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
    }
  });
};

const isVisible = element => {
  if (!isElement(element) || element.getClientRects().length === 0) {
    return false;
  }

  return getComputedStyle(element).getPropertyValue('visibility') === 'visible';
};

const isDisabled = element => {
  if (!element || element.nodeType !== Node.ELEMENT_NODE) {
    return true;
  }

  if (element.classList.contains('disabled')) {
    return true;
  }

  if (typeof element.disabled !== 'undefined') {
    return element.disabled;
  }

  return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};

const findShadowRoot = element => {
  if (!document.documentElement.attachShadow) {
    return null;
  } // Can find the shadow root otherwise it'll return the document


  if (typeof element.getRootNode === 'function') {
    const root = element.getRootNode();
    return root instanceof ShadowRoot ? root : null;
  }

  if (element instanceof ShadowRoot) {
    return element;
  } // when we don't find a shadow root


  if (!element.parentNode) {
    return null;
  }

  return findShadowRoot(element.parentNode);
};

const noop$2 = () => {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */


const reflow = element => {
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
};

const getjQuery = () => {
  const {
    jQuery
  } = window;

  if (jQuery && !document.body.hasAttribute('data-bs-no-jquery')) {
    return jQuery;
  }

  return null;
};

const DOMContentLoadedCallbacks = [];

const onDOMContentLoaded = callback => {
  if (document.readyState === 'loading') {
    // add listener on the first call when the document is in loading state
    if (!DOMContentLoadedCallbacks.length) {
      document.addEventListener('DOMContentLoaded', () => {
        DOMContentLoadedCallbacks.forEach(callback => callback());
      });
    }

    DOMContentLoadedCallbacks.push(callback);
  } else {
    callback();
  }
};

const isRTL = () => document.documentElement.dir === 'rtl';

const defineJQueryPlugin = plugin => {
  onDOMContentLoaded(() => {
    const $ = getjQuery();
    /* istanbul ignore if */

    if ($) {
      const name = plugin.NAME;
      const JQUERY_NO_CONFLICT = $.fn[name];
      $.fn[name] = plugin.jQueryInterface;
      $.fn[name].Constructor = plugin;

      $.fn[name].noConflict = () => {
        $.fn[name] = JQUERY_NO_CONFLICT;
        return plugin.jQueryInterface;
      };
    }
  });
};

const execute = callback => {
  if (typeof callback === 'function') {
    callback();
  }
};

const executeAfterTransition = (callback, transitionElement, waitForTransition = true) => {
  if (!waitForTransition) {
    execute(callback);
    return;
  }

  const durationPadding = 5;
  const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
  let called = false;

  const handler = ({
    target
  }) => {
    if (target !== transitionElement) {
      return;
    }

    called = true;
    transitionElement.removeEventListener(TRANSITION_END, handler);
    execute(callback);
  };

  transitionElement.addEventListener(TRANSITION_END, handler);
  setTimeout(() => {
    if (!called) {
      triggerTransitionEnd(transitionElement);
    }
  }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */


const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed) => {
  let index = list.indexOf(activeElement); // if the element does not exist in the list return an element depending on the direction and if cycle is allowed

  if (index === -1) {
    return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
  }

  const listLength = list.length;
  index += shouldGetNext ? 1 : -1;

  if (isCycleAllowed) {
    index = (index + listLength) % listLength;
  }

  return list[Math.max(0, Math.min(index, listLength - 1))];
};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const stripNameRegex = /\..*/;
const stripUidRegex = /::\d+$/;
const eventRegistry = {}; // Events storage

let uidEvent = 1;
const customEvents = {
  mouseenter: 'mouseover',
  mouseleave: 'mouseout'
};
const customEventsRegex = /^(mouseenter|mouseleave)/i;
const nativeEvents = new Set(['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll']);
/**
 * ------------------------------------------------------------------------
 * Private methods
 * ------------------------------------------------------------------------
 */

function getUidEvent(element, uid) {
  return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
}

function getEvent(element) {
  const uid = getUidEvent(element);
  element.uidEvent = uid;
  eventRegistry[uid] = eventRegistry[uid] || {};
  return eventRegistry[uid];
}

function bootstrapHandler(element, fn) {
  return function handler(event) {
    event.delegateTarget = element;

    if (handler.oneOff) {
      EventHandler.off(element, event.type, fn);
    }

    return fn.apply(element, [event]);
  };
}

function bootstrapDelegationHandler(element, selector, fn) {
  return function handler(event) {
    const domElements = element.querySelectorAll(selector);

    for (let {
      target
    } = event; target && target !== this; target = target.parentNode) {
      for (let i = domElements.length; i--;) {
        if (domElements[i] === target) {
          event.delegateTarget = target;

          if (handler.oneOff) {
            // eslint-disable-next-line unicorn/consistent-destructuring
            EventHandler.off(element, event.type, selector, fn);
          }

          return fn.apply(target, [event]);
        }
      }
    } // To please ESLint


    return null;
  };
}

function findHandler(events, handler, delegationSelector = null) {
  const uidEventList = Object.keys(events);

  for (let i = 0, len = uidEventList.length; i < len; i++) {
    const event = events[uidEventList[i]];

    if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
      return event;
    }
  }

  return null;
}

function normalizeParams(originalTypeEvent, handler, delegationFn) {
  const delegation = typeof handler === 'string';
  const originalHandler = delegation ? delegationFn : handler;
  let typeEvent = getTypeEvent(originalTypeEvent);
  const isNative = nativeEvents.has(typeEvent);

  if (!isNative) {
    typeEvent = originalTypeEvent;
  }

  return [delegation, originalHandler, typeEvent];
}

function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
  if (typeof originalTypeEvent !== 'string' || !element) {
    return;
  }

  if (!handler) {
    handler = delegationFn;
    delegationFn = null;
  } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
  // this prevents the handler from being dispatched the same way as mouseover or mouseout does


  if (customEventsRegex.test(originalTypeEvent)) {
    const wrapFn = fn => {
      return function (event) {
        if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) {
          return fn.call(this, event);
        }
      };
    };

    if (delegationFn) {
      delegationFn = wrapFn(delegationFn);
    } else {
      handler = wrapFn(handler);
    }
  }

  const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
  const events = getEvent(element);
  const handlers = events[typeEvent] || (events[typeEvent] = {});
  const previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);

  if (previousFn) {
    previousFn.oneOff = previousFn.oneOff && oneOff;
    return;
  }

  const uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
  const fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
  fn.delegationSelector = delegation ? handler : null;
  fn.originalHandler = originalHandler;
  fn.oneOff = oneOff;
  fn.uidEvent = uid;
  handlers[uid] = fn;
  element.addEventListener(typeEvent, fn, delegation);
}

function removeHandler(element, events, typeEvent, handler, delegationSelector) {
  const fn = findHandler(events[typeEvent], handler, delegationSelector);

  if (!fn) {
    return;
  }

  element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
  delete events[typeEvent][fn.uidEvent];
}

function removeNamespacedHandlers(element, events, typeEvent, namespace) {
  const storeElementEvent = events[typeEvent] || {};
  Object.keys(storeElementEvent).forEach(handlerKey => {
    if (handlerKey.includes(namespace)) {
      const event = storeElementEvent[handlerKey];
      removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
    }
  });
}

function getTypeEvent(event) {
  // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
  event = event.replace(stripNameRegex, '');
  return customEvents[event] || event;
}

const EventHandler = {
  on(element, event, handler, delegationFn) {
    addHandler(element, event, handler, delegationFn, false);
  },

  one(element, event, handler, delegationFn) {
    addHandler(element, event, handler, delegationFn, true);
  },

  off(element, originalTypeEvent, handler, delegationFn) {
    if (typeof originalTypeEvent !== 'string' || !element) {
      return;
    }

    const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
    const inNamespace = typeEvent !== originalTypeEvent;
    const events = getEvent(element);
    const isNamespace = originalTypeEvent.startsWith('.');

    if (typeof originalHandler !== 'undefined') {
      // Simplest case: handler is passed, remove that listener ONLY.
      if (!events || !events[typeEvent]) {
        return;
      }

      removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
      return;
    }

    if (isNamespace) {
      Object.keys(events).forEach(elementEvent => {
        removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
      });
    }

    const storeElementEvent = events[typeEvent] || {};
    Object.keys(storeElementEvent).forEach(keyHandlers => {
      const handlerKey = keyHandlers.replace(stripUidRegex, '');

      if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
        const event = storeElementEvent[keyHandlers];
        removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
      }
    });
  },

  trigger(element, event, args) {
    if (typeof event !== 'string' || !element) {
      return null;
    }

    const $ = getjQuery();
    const typeEvent = getTypeEvent(event);
    const inNamespace = event !== typeEvent;
    const isNative = nativeEvents.has(typeEvent);
    let jQueryEvent;
    let bubbles = true;
    let nativeDispatch = true;
    let defaultPrevented = false;
    let evt = null;

    if (inNamespace && $) {
      jQueryEvent = $.Event(event, args);
      $(element).trigger(jQueryEvent);
      bubbles = !jQueryEvent.isPropagationStopped();
      nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
      defaultPrevented = jQueryEvent.isDefaultPrevented();
    }

    if (isNative) {
      evt = document.createEvent('HTMLEvents');
      evt.initEvent(typeEvent, bubbles, true);
    } else {
      evt = new CustomEvent(event, {
        bubbles,
        cancelable: true
      });
    } // merge custom information in our event


    if (typeof args !== 'undefined') {
      Object.keys(args).forEach(key => {
        Object.defineProperty(evt, key, {
          get() {
            return args[key];
          }

        });
      });
    }

    if (defaultPrevented) {
      evt.preventDefault();
    }

    if (nativeDispatch) {
      element.dispatchEvent(evt);
    }

    if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
      jQueryEvent.preventDefault();
    }

    return evt;
  }

};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */
const elementMap = new Map();
var Data = {
  set(element, key, instance) {
    if (!elementMap.has(element)) {
      elementMap.set(element, new Map());
    }

    const instanceMap = elementMap.get(element); // make it clear we only want one instance per element
    // can be removed later when multiple key/instances are fine to be used

    if (!instanceMap.has(key) && instanceMap.size !== 0) {
      // eslint-disable-next-line no-console
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
      return;
    }

    instanceMap.set(key, instance);
  },

  get(element, key) {
    if (elementMap.has(element)) {
      return elementMap.get(element).get(key) || null;
    }

    return null;
  },

  remove(element, key) {
    if (!elementMap.has(element)) {
      return;
    }

    const instanceMap = elementMap.get(element);
    instanceMap.delete(key); // free up element references if there are no instances left for an element

    if (instanceMap.size === 0) {
      elementMap.delete(element);
    }
  }

};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const VERSION = '5.1.0';

class BaseComponent {
  constructor(element) {
    element = getElement(element);

    if (!element) {
      return;
    }

    this._element = element;
    Data.set(this._element, this.constructor.DATA_KEY, this);
  }

  dispose() {
    Data.remove(this._element, this.constructor.DATA_KEY);
    EventHandler.off(this._element, this.constructor.EVENT_KEY);
    Object.getOwnPropertyNames(this).forEach(propertyName => {
      this[propertyName] = null;
    });
  }

  _queueCallback(callback, element, isAnimated = true) {
    executeAfterTransition(callback, element, isAnimated);
  }
  /** Static */


  static getInstance(element) {
    return Data.get(getElement(element), this.DATA_KEY);
  }

  static getOrCreateInstance(element, config = {}) {
    return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
  }

  static get VERSION() {
    return VERSION;
  }

  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }

  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }

  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }

}

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

const enableDismissTrigger = (component, method = 'hide') => {
  const clickEvent = `click.dismiss${component.EVENT_KEY}`;
  const name = component.NAME;
  EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function (event) {
    if (['A', 'AREA'].includes(this.tagName)) {
      event.preventDefault();
    }

    if (isDisabled(this)) {
      return;
    }

    const target = getElementFromSelector(this) || this.closest(`.${name}`);
    const instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method

    instance[method]();
  });
};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$d = 'alert';
const DATA_KEY$c = 'bs.alert';
const EVENT_KEY$c = `.${DATA_KEY$c}`;
const EVENT_CLOSE = `close${EVENT_KEY$c}`;
const EVENT_CLOSED = `closed${EVENT_KEY$c}`;
const CLASS_NAME_FADE$5 = 'fade';
const CLASS_NAME_SHOW$8 = 'show';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Alert extends BaseComponent {
  // Getters
  static get NAME() {
    return NAME$d;
  } // Public


  close() {
    const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);

    if (closeEvent.defaultPrevented) {
      return;
    }

    this._element.classList.remove(CLASS_NAME_SHOW$8);

    const isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);

    this._queueCallback(() => this._destroyElement(), this._element, isAnimated);
  } // Private


  _destroyElement() {
    this._element.remove();

    EventHandler.trigger(this._element, EVENT_CLOSED);
    this.dispose();
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Alert.getOrCreateInstance(this);

      if (typeof config !== 'string') {
        return;
      }

      if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
        throw new TypeError(`No method named "${config}"`);
      }

      data[config](this);
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


enableDismissTrigger(Alert, 'close');
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Alert to jQuery only if jQuery is present
 */

defineJQueryPlugin(Alert);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$c = 'button';
const DATA_KEY$b = 'bs.button';
const EVENT_KEY$b = `.${DATA_KEY$b}`;
const DATA_API_KEY$7 = '.data-api';
const CLASS_NAME_ACTIVE$3 = 'active';
const SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const EVENT_CLICK_DATA_API$6 = `click${EVENT_KEY$b}${DATA_API_KEY$7}`;
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Button extends BaseComponent {
  // Getters
  static get NAME() {
    return NAME$c;
  } // Public


  toggle() {
    // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
    this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Button.getOrCreateInstance(this);

      if (config === 'toggle') {
        data[config]();
      }
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, event => {
  event.preventDefault();
  const button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
  const data = Button.getOrCreateInstance(button);
  data.toggle();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Button to jQuery only if jQuery is present
 */

defineJQueryPlugin(Button);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
function normalizeData(val) {
  if (val === 'true') {
    return true;
  }

  if (val === 'false') {
    return false;
  }

  if (val === Number(val).toString()) {
    return Number(val);
  }

  if (val === '' || val === 'null') {
    return null;
  }

  return val;
}

function normalizeDataKey(key) {
  return key.replace(/[A-Z]/g, chr => `-${chr.toLowerCase()}`);
}

const Manipulator = {
  setDataAttribute(element, key, value) {
    element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
  },

  removeDataAttribute(element, key) {
    element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
  },

  getDataAttributes(element) {
    if (!element) {
      return {};
    }

    const attributes = {};
    Object.keys(element.dataset).filter(key => key.startsWith('bs')).forEach(key => {
      let pureKey = key.replace(/^bs/, '');
      pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
      attributes[pureKey] = normalizeData(element.dataset[key]);
    });
    return attributes;
  },

  getDataAttribute(element, key) {
    return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
  },

  offset(element) {
    const rect = element.getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    };
  },

  position(element) {
    return {
      top: element.offsetTop,
      left: element.offsetLeft
    };
  }

};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
const NODE_TEXT = 3;
const SelectorEngine = {
  find(selector, element = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
  },

  findOne(selector, element = document.documentElement) {
    return Element.prototype.querySelector.call(element, selector);
  },

  children(element, selector) {
    return [].concat(...element.children).filter(child => child.matches(selector));
  },

  parents(element, selector) {
    const parents = [];
    let ancestor = element.parentNode;

    while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
      if (ancestor.matches(selector)) {
        parents.push(ancestor);
      }

      ancestor = ancestor.parentNode;
    }

    return parents;
  },

  prev(element, selector) {
    let previous = element.previousElementSibling;

    while (previous) {
      if (previous.matches(selector)) {
        return [previous];
      }

      previous = previous.previousElementSibling;
    }

    return [];
  },

  next(element, selector) {
    let next = element.nextElementSibling;

    while (next) {
      if (next.matches(selector)) {
        return [next];
      }

      next = next.nextElementSibling;
    }

    return [];
  },

  focusableChildren(element) {
    const focusables = ['a', 'button', 'input', 'textarea', 'select', 'details', '[tabindex]', '[contenteditable="true"]'].map(selector => `${selector}:not([tabindex^="-"])`).join(', ');
    return this.find(focusables, element).filter(el => !isDisabled(el) && isVisible(el));
  }

};

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$b = 'carousel';
const DATA_KEY$a = 'bs.carousel';
const EVENT_KEY$a = `.${DATA_KEY$a}`;
const DATA_API_KEY$6 = '.data-api';
const ARROW_LEFT_KEY = 'ArrowLeft';
const ARROW_RIGHT_KEY = 'ArrowRight';
const TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

const SWIPE_THRESHOLD = 40;
const Default$a = {
  interval: 5000,
  keyboard: true,
  slide: false,
  pause: 'hover',
  wrap: true,
  touch: true
};
const DefaultType$a = {
  interval: '(number|boolean)',
  keyboard: 'boolean',
  slide: '(boolean|string)',
  pause: '(string|boolean)',
  wrap: 'boolean',
  touch: 'boolean'
};
const ORDER_NEXT = 'next';
const ORDER_PREV = 'prev';
const DIRECTION_LEFT = 'left';
const DIRECTION_RIGHT = 'right';
const KEY_TO_DIRECTION = {
  [ARROW_LEFT_KEY]: DIRECTION_RIGHT,
  [ARROW_RIGHT_KEY]: DIRECTION_LEFT
};
const EVENT_SLIDE = `slide${EVENT_KEY$a}`;
const EVENT_SLID = `slid${EVENT_KEY$a}`;
const EVENT_KEYDOWN = `keydown${EVENT_KEY$a}`;
const EVENT_MOUSEENTER = `mouseenter${EVENT_KEY$a}`;
const EVENT_MOUSELEAVE = `mouseleave${EVENT_KEY$a}`;
const EVENT_TOUCHSTART = `touchstart${EVENT_KEY$a}`;
const EVENT_TOUCHMOVE = `touchmove${EVENT_KEY$a}`;
const EVENT_TOUCHEND = `touchend${EVENT_KEY$a}`;
const EVENT_POINTERDOWN = `pointerdown${EVENT_KEY$a}`;
const EVENT_POINTERUP = `pointerup${EVENT_KEY$a}`;
const EVENT_DRAG_START = `dragstart${EVENT_KEY$a}`;
const EVENT_LOAD_DATA_API$2 = `load${EVENT_KEY$a}${DATA_API_KEY$6}`;
const EVENT_CLICK_DATA_API$5 = `click${EVENT_KEY$a}${DATA_API_KEY$6}`;
const CLASS_NAME_CAROUSEL = 'carousel';
const CLASS_NAME_ACTIVE$2 = 'active';
const CLASS_NAME_SLIDE = 'slide';
const CLASS_NAME_END = 'carousel-item-end';
const CLASS_NAME_START = 'carousel-item-start';
const CLASS_NAME_NEXT = 'carousel-item-next';
const CLASS_NAME_PREV = 'carousel-item-prev';
const CLASS_NAME_POINTER_EVENT = 'pointer-event';
const SELECTOR_ACTIVE$1 = '.active';
const SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
const SELECTOR_ITEM = '.carousel-item';
const SELECTOR_ITEM_IMG = '.carousel-item img';
const SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
const SELECTOR_INDICATORS = '.carousel-indicators';
const SELECTOR_INDICATOR = '[data-bs-target]';
const SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const POINTER_TYPE_TOUCH = 'touch';
const POINTER_TYPE_PEN = 'pen';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Carousel extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._items = null;
    this._interval = null;
    this._activeElement = null;
    this._isPaused = false;
    this._isSliding = false;
    this.touchTimeout = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;
    this._config = this._getConfig(config);
    this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
    this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    this._pointerEvent = Boolean(window.PointerEvent);

    this._addEventListeners();
  } // Getters


  static get Default() {
    return Default$a;
  }

  static get NAME() {
    return NAME$b;
  } // Public


  next() {
    this._slide(ORDER_NEXT);
  }

  nextWhenVisible() {
    // Don't call next when the page isn't visible
    // or the carousel or its parent isn't visible
    if (!document.hidden && isVisible(this._element)) {
      this.next();
    }
  }

  prev() {
    this._slide(ORDER_PREV);
  }

  pause(event) {
    if (!event) {
      this._isPaused = true;
    }

    if (SelectorEngine.findOne(SELECTOR_NEXT_PREV, this._element)) {
      triggerTransitionEnd(this._element);
      this.cycle(true);
    }

    clearInterval(this._interval);
    this._interval = null;
  }

  cycle(event) {
    if (!event) {
      this._isPaused = false;
    }

    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }

    if (this._config && this._config.interval && !this._isPaused) {
      this._updateInterval();

      this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
    }
  }

  to(index) {
    this._activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

    const activeIndex = this._getItemIndex(this._activeElement);

    if (index > this._items.length - 1 || index < 0) {
      return;
    }

    if (this._isSliding) {
      EventHandler.one(this._element, EVENT_SLID, () => this.to(index));
      return;
    }

    if (activeIndex === index) {
      this.pause();
      this.cycle();
      return;
    }

    const order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;

    this._slide(order, this._items[index]);
  } // Private


  _getConfig(config) {
    config = { ...Default$a,
      ...Manipulator.getDataAttributes(this._element),
      ...(typeof config === 'object' ? config : {})
    };
    typeCheckConfig(NAME$b, config, DefaultType$a);
    return config;
  }

  _handleSwipe() {
    const absDeltax = Math.abs(this.touchDeltaX);

    if (absDeltax <= SWIPE_THRESHOLD) {
      return;
    }

    const direction = absDeltax / this.touchDeltaX;
    this.touchDeltaX = 0;

    if (!direction) {
      return;
    }

    this._slide(direction > 0 ? DIRECTION_RIGHT : DIRECTION_LEFT);
  }

  _addEventListeners() {
    if (this._config.keyboard) {
      EventHandler.on(this._element, EVENT_KEYDOWN, event => this._keydown(event));
    }

    if (this._config.pause === 'hover') {
      EventHandler.on(this._element, EVENT_MOUSEENTER, event => this.pause(event));
      EventHandler.on(this._element, EVENT_MOUSELEAVE, event => this.cycle(event));
    }

    if (this._config.touch && this._touchSupported) {
      this._addTouchEventListeners();
    }
  }

  _addTouchEventListeners() {
    const start = event => {
      if (this._pointerEvent && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH)) {
        this.touchStartX = event.clientX;
      } else if (!this._pointerEvent) {
        this.touchStartX = event.touches[0].clientX;
      }
    };

    const move = event => {
      // ensure swiping with one touch and not pinching
      this.touchDeltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this.touchStartX;
    };

    const end = event => {
      if (this._pointerEvent && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH)) {
        this.touchDeltaX = event.clientX - this.touchStartX;
      }

      this._handleSwipe();

      if (this._config.pause === 'hover') {
        // If it's a touch-enabled device, mouseenter/leave are fired as
        // part of the mouse compatibility events on first tap - the carousel
        // would stop cycling until user tapped out of it;
        // here, we listen for touchend, explicitly pause the carousel
        // (as if it's the second time we tap on it, mouseenter compat event
        // is NOT fired) and after a timeout (to allow for mouse compatibility
        // events to fire) we explicitly restart cycling
        this.pause();

        if (this.touchTimeout) {
          clearTimeout(this.touchTimeout);
        }

        this.touchTimeout = setTimeout(event => this.cycle(event), TOUCHEVENT_COMPAT_WAIT + this._config.interval);
      }
    };

    SelectorEngine.find(SELECTOR_ITEM_IMG, this._element).forEach(itemImg => {
      EventHandler.on(itemImg, EVENT_DRAG_START, e => e.preventDefault());
    });

    if (this._pointerEvent) {
      EventHandler.on(this._element, EVENT_POINTERDOWN, event => start(event));
      EventHandler.on(this._element, EVENT_POINTERUP, event => end(event));

      this._element.classList.add(CLASS_NAME_POINTER_EVENT);
    } else {
      EventHandler.on(this._element, EVENT_TOUCHSTART, event => start(event));
      EventHandler.on(this._element, EVENT_TOUCHMOVE, event => move(event));
      EventHandler.on(this._element, EVENT_TOUCHEND, event => end(event));
    }
  }

  _keydown(event) {
    if (/input|textarea/i.test(event.target.tagName)) {
      return;
    }

    const direction = KEY_TO_DIRECTION[event.key];

    if (direction) {
      event.preventDefault();

      this._slide(direction);
    }
  }

  _getItemIndex(element) {
    this._items = element && element.parentNode ? SelectorEngine.find(SELECTOR_ITEM, element.parentNode) : [];
    return this._items.indexOf(element);
  }

  _getItemByOrder(order, activeElement) {
    const isNext = order === ORDER_NEXT;
    return getNextActiveElement(this._items, activeElement, isNext, this._config.wrap);
  }

  _triggerSlideEvent(relatedTarget, eventDirectionName) {
    const targetIndex = this._getItemIndex(relatedTarget);

    const fromIndex = this._getItemIndex(SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element));

    return EventHandler.trigger(this._element, EVENT_SLIDE, {
      relatedTarget,
      direction: eventDirectionName,
      from: fromIndex,
      to: targetIndex
    });
  }

  _setActiveIndicatorElement(element) {
    if (this._indicatorsElement) {
      const activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE$1, this._indicatorsElement);
      activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
      activeIndicator.removeAttribute('aria-current');
      const indicators = SelectorEngine.find(SELECTOR_INDICATOR, this._indicatorsElement);

      for (let i = 0; i < indicators.length; i++) {
        if (Number.parseInt(indicators[i].getAttribute('data-bs-slide-to'), 10) === this._getItemIndex(element)) {
          indicators[i].classList.add(CLASS_NAME_ACTIVE$2);
          indicators[i].setAttribute('aria-current', 'true');
          break;
        }
      }
    }
  }

  _updateInterval() {
    const element = this._activeElement || SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

    if (!element) {
      return;
    }

    const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);

    if (elementInterval) {
      this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
      this._config.interval = elementInterval;
    } else {
      this._config.interval = this._config.defaultInterval || this._config.interval;
    }
  }

  _slide(directionOrOrder, element) {
    const order = this._directionToOrder(directionOrOrder);

    const activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

    const activeElementIndex = this._getItemIndex(activeElement);

    const nextElement = element || this._getItemByOrder(order, activeElement);

    const nextElementIndex = this._getItemIndex(nextElement);

    const isCycling = Boolean(this._interval);
    const isNext = order === ORDER_NEXT;
    const directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
    const orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;

    const eventDirectionName = this._orderToDirection(order);

    if (nextElement && nextElement.classList.contains(CLASS_NAME_ACTIVE$2)) {
      this._isSliding = false;
      return;
    }

    if (this._isSliding) {
      return;
    }

    const slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

    if (slideEvent.defaultPrevented) {
      return;
    }

    if (!activeElement || !nextElement) {
      // Some weirdness is happening, so we bail
      return;
    }

    this._isSliding = true;

    if (isCycling) {
      this.pause();
    }

    this._setActiveIndicatorElement(nextElement);

    this._activeElement = nextElement;

    const triggerSlidEvent = () => {
      EventHandler.trigger(this._element, EVENT_SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });
    };

    if (this._element.classList.contains(CLASS_NAME_SLIDE)) {
      nextElement.classList.add(orderClassName);
      reflow(nextElement);
      activeElement.classList.add(directionalClassName);
      nextElement.classList.add(directionalClassName);

      const completeCallBack = () => {
        nextElement.classList.remove(directionalClassName, orderClassName);
        nextElement.classList.add(CLASS_NAME_ACTIVE$2);
        activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
        this._isSliding = false;
        setTimeout(triggerSlidEvent, 0);
      };

      this._queueCallback(completeCallBack, activeElement, true);
    } else {
      activeElement.classList.remove(CLASS_NAME_ACTIVE$2);
      nextElement.classList.add(CLASS_NAME_ACTIVE$2);
      this._isSliding = false;
      triggerSlidEvent();
    }

    if (isCycling) {
      this.cycle();
    }
  }

  _directionToOrder(direction) {
    if (![DIRECTION_RIGHT, DIRECTION_LEFT].includes(direction)) {
      return direction;
    }

    if (isRTL()) {
      return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
    }

    return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
  }

  _orderToDirection(order) {
    if (![ORDER_NEXT, ORDER_PREV].includes(order)) {
      return order;
    }

    if (isRTL()) {
      return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }

    return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
  } // Static


  static carouselInterface(element, config) {
    const data = Carousel.getOrCreateInstance(element, config);
    let {
      _config
    } = data;

    if (typeof config === 'object') {
      _config = { ..._config,
        ...config
      };
    }

    const action = typeof config === 'string' ? config : _config.slide;

    if (typeof config === 'number') {
      data.to(config);
    } else if (typeof action === 'string') {
      if (typeof data[action] === 'undefined') {
        throw new TypeError(`No method named "${action}"`);
      }

      data[action]();
    } else if (_config.interval && _config.ride) {
      data.pause();
      data.cycle();
    }
  }

  static jQueryInterface(config) {
    return this.each(function () {
      Carousel.carouselInterface(this, config);
    });
  }

  static dataApiClickHandler(event) {
    const target = getElementFromSelector(this);

    if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) {
      return;
    }

    const config = { ...Manipulator.getDataAttributes(target),
      ...Manipulator.getDataAttributes(this)
    };
    const slideIndex = this.getAttribute('data-bs-slide-to');

    if (slideIndex) {
      config.interval = false;
    }

    Carousel.carouselInterface(target, config);

    if (slideIndex) {
      Carousel.getInstance(target).to(slideIndex);
    }

    event.preventDefault();
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, Carousel.dataApiClickHandler);
EventHandler.on(window, EVENT_LOAD_DATA_API$2, () => {
  const carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);

  for (let i = 0, len = carousels.length; i < len; i++) {
    Carousel.carouselInterface(carousels[i], Carousel.getInstance(carousels[i]));
  }
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Carousel to jQuery only if jQuery is present
 */

defineJQueryPlugin(Carousel);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$a = 'collapse';
const DATA_KEY$9 = 'bs.collapse';
const EVENT_KEY$9 = `.${DATA_KEY$9}`;
const DATA_API_KEY$5 = '.data-api';
const Default$9 = {
  toggle: true,
  parent: null
};
const DefaultType$9 = {
  toggle: 'boolean',
  parent: '(null|element)'
};
const EVENT_SHOW$5 = `show${EVENT_KEY$9}`;
const EVENT_SHOWN$5 = `shown${EVENT_KEY$9}`;
const EVENT_HIDE$5 = `hide${EVENT_KEY$9}`;
const EVENT_HIDDEN$5 = `hidden${EVENT_KEY$9}`;
const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$9}${DATA_API_KEY$5}`;
const CLASS_NAME_SHOW$7 = 'show';
const CLASS_NAME_COLLAPSE = 'collapse';
const CLASS_NAME_COLLAPSING = 'collapsing';
const CLASS_NAME_COLLAPSED = 'collapsed';
const CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const WIDTH = 'width';
const HEIGHT = 'height';
const SELECTOR_ACTIVES = '.show, .collapsing';
const SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Collapse extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._isTransitioning = false;
    this._config = this._getConfig(config);
    this._triggerArray = [];
    const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);

    for (let i = 0, len = toggleList.length; i < len; i++) {
      const elem = toggleList[i];
      const selector = getSelectorFromElement(elem);
      const filterElement = SelectorEngine.find(selector).filter(foundElem => foundElem === this._element);

      if (selector !== null && filterElement.length) {
        this._selector = selector;

        this._triggerArray.push(elem);
      }
    }

    this._initializeChildren();

    if (!this._config.parent) {
      this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
    }

    if (this._config.toggle) {
      this.toggle();
    }
  } // Getters


  static get Default() {
    return Default$9;
  }

  static get NAME() {
    return NAME$a;
  } // Public


  toggle() {
    if (this._isShown()) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    if (this._isTransitioning || this._isShown()) {
      return;
    }

    let actives = [];
    let activesData;

    if (this._config.parent) {
      const children = SelectorEngine.find(`.${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`, this._config.parent);
      actives = SelectorEngine.find(SELECTOR_ACTIVES, this._config.parent).filter(elem => !children.includes(elem)); // remove children if greater depth
    }

    const container = SelectorEngine.findOne(this._selector);

    if (actives.length) {
      const tempActiveData = actives.find(elem => container !== elem);
      activesData = tempActiveData ? Collapse.getInstance(tempActiveData) : null;

      if (activesData && activesData._isTransitioning) {
        return;
      }
    }

    const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$5);

    if (startEvent.defaultPrevented) {
      return;
    }

    actives.forEach(elemActive => {
      if (container !== elemActive) {
        Collapse.getOrCreateInstance(elemActive, {
          toggle: false
        }).hide();
      }

      if (!activesData) {
        Data.set(elemActive, DATA_KEY$9, null);
      }
    });

    const dimension = this._getDimension();

    this._element.classList.remove(CLASS_NAME_COLLAPSE);

    this._element.classList.add(CLASS_NAME_COLLAPSING);

    this._element.style[dimension] = 0;

    this._addAriaAndCollapsedClass(this._triggerArray, true);

    this._isTransitioning = true;

    const complete = () => {
      this._isTransitioning = false;

      this._element.classList.remove(CLASS_NAME_COLLAPSING);

      this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);

      this._element.style[dimension] = '';
      EventHandler.trigger(this._element, EVENT_SHOWN$5);
    };

    const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
    const scrollSize = `scroll${capitalizedDimension}`;

    this._queueCallback(complete, this._element, true);

    this._element.style[dimension] = `${this._element[scrollSize]}px`;
  }

  hide() {
    if (this._isTransitioning || !this._isShown()) {
      return;
    }

    const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$5);

    if (startEvent.defaultPrevented) {
      return;
    }

    const dimension = this._getDimension();

    this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
    reflow(this._element);

    this._element.classList.add(CLASS_NAME_COLLAPSING);

    this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);

    const triggerArrayLength = this._triggerArray.length;

    for (let i = 0; i < triggerArrayLength; i++) {
      const trigger = this._triggerArray[i];
      const elem = getElementFromSelector(trigger);

      if (elem && !this._isShown(elem)) {
        this._addAriaAndCollapsedClass([trigger], false);
      }
    }

    this._isTransitioning = true;

    const complete = () => {
      this._isTransitioning = false;

      this._element.classList.remove(CLASS_NAME_COLLAPSING);

      this._element.classList.add(CLASS_NAME_COLLAPSE);

      EventHandler.trigger(this._element, EVENT_HIDDEN$5);
    };

    this._element.style[dimension] = '';

    this._queueCallback(complete, this._element, true);
  }

  _isShown(element = this._element) {
    return element.classList.contains(CLASS_NAME_SHOW$7);
  } // Private


  _getConfig(config) {
    config = { ...Default$9,
      ...Manipulator.getDataAttributes(this._element),
      ...config
    };
    config.toggle = Boolean(config.toggle); // Coerce string values

    config.parent = getElement(config.parent);
    typeCheckConfig(NAME$a, config, DefaultType$9);
    return config;
  }

  _getDimension() {
    return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
  }

  _initializeChildren() {
    if (!this._config.parent) {
      return;
    }

    const children = SelectorEngine.find(`.${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`, this._config.parent);
    SelectorEngine.find(SELECTOR_DATA_TOGGLE$4, this._config.parent).filter(elem => !children.includes(elem)).forEach(element => {
      const selected = getElementFromSelector(element);

      if (selected) {
        this._addAriaAndCollapsedClass([element], this._isShown(selected));
      }
    });
  }

  _addAriaAndCollapsedClass(triggerArray, isOpen) {
    if (!triggerArray.length) {
      return;
    }

    triggerArray.forEach(elem => {
      if (isOpen) {
        elem.classList.remove(CLASS_NAME_COLLAPSED);
      } else {
        elem.classList.add(CLASS_NAME_COLLAPSED);
      }

      elem.setAttribute('aria-expanded', isOpen);
    });
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const _config = {};

      if (typeof config === 'string' && /show|hide/.test(config)) {
        _config.toggle = false;
      }

      const data = Collapse.getOrCreateInstance(this, _config);

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
      }
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function (event) {
  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
  if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') {
    event.preventDefault();
  }

  const selector = getSelectorFromElement(this);
  const selectorElements = SelectorEngine.find(selector);
  selectorElements.forEach(element => {
    Collapse.getOrCreateInstance(element, {
      toggle: false
    }).toggle();
  });
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Collapse to jQuery only if jQuery is present
 */

defineJQueryPlugin(Collapse);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$9 = 'dropdown';
const DATA_KEY$8 = 'bs.dropdown';
const EVENT_KEY$8 = `.${DATA_KEY$8}`;
const DATA_API_KEY$4 = '.data-api';
const ESCAPE_KEY$2 = 'Escape';
const SPACE_KEY = 'Space';
const TAB_KEY$1 = 'Tab';
const ARROW_UP_KEY = 'ArrowUp';
const ARROW_DOWN_KEY = 'ArrowDown';
const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button

const REGEXP_KEYDOWN = new RegExp(`${ARROW_UP_KEY}|${ARROW_DOWN_KEY}|${ESCAPE_KEY$2}`);
const EVENT_HIDE$4 = `hide${EVENT_KEY$8}`;
const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$8}`;
const EVENT_SHOW$4 = `show${EVENT_KEY$8}`;
const EVENT_SHOWN$4 = `shown${EVENT_KEY$8}`;
const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$8}${DATA_API_KEY$4}`;
const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY$8}${DATA_API_KEY$4}`;
const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY$8}${DATA_API_KEY$4}`;
const CLASS_NAME_SHOW$6 = 'show';
const CLASS_NAME_DROPUP = 'dropup';
const CLASS_NAME_DROPEND = 'dropend';
const CLASS_NAME_DROPSTART = 'dropstart';
const CLASS_NAME_NAVBAR = 'navbar';
const SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]';
const SELECTOR_MENU = '.dropdown-menu';
const SELECTOR_NAVBAR_NAV = '.navbar-nav';
const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
const Default$8 = {
  offset: [0, 2],
  boundary: 'clippingParents',
  reference: 'toggle',
  display: 'dynamic',
  popperConfig: null,
  autoClose: true
};
const DefaultType$8 = {
  offset: '(array|string|function)',
  boundary: '(string|element)',
  reference: '(string|element|object)',
  display: 'string',
  popperConfig: '(null|object|function)',
  autoClose: '(boolean|string)'
};
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Dropdown extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._popper = null;
    this._config = this._getConfig(config);
    this._menu = this._getMenuElement();
    this._inNavbar = this._detectNavbar();
  } // Getters


  static get Default() {
    return Default$8;
  }

  static get DefaultType() {
    return DefaultType$8;
  }

  static get NAME() {
    return NAME$9;
  } // Public


  toggle() {
    return this._isShown() ? this.hide() : this.show();
  }

  show() {
    if (isDisabled(this._element) || this._isShown(this._menu)) {
      return;
    }

    const relatedTarget = {
      relatedTarget: this._element
    };
    const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, relatedTarget);

    if (showEvent.defaultPrevented) {
      return;
    }

    const parent = Dropdown.getParentFromElement(this._element); // Totally disable Popper for Dropdowns in Navbar

    if (this._inNavbar) {
      Manipulator.setDataAttribute(this._menu, 'popper', 'none');
    } else {
      this._createPopper(parent);
    } // If this is a touch-enabled device we add extra
    // empty mouseover listeners to the body's immediate children;
    // only needed because of broken event delegation on iOS
    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


    if ('ontouchstart' in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) {
      [].concat(...document.body.children).forEach(elem => EventHandler.on(elem, 'mouseover', noop$2));
    }

    this._element.focus();

    this._element.setAttribute('aria-expanded', true);

    this._menu.classList.add(CLASS_NAME_SHOW$6);

    this._element.classList.add(CLASS_NAME_SHOW$6);

    EventHandler.trigger(this._element, EVENT_SHOWN$4, relatedTarget);
  }

  hide() {
    if (isDisabled(this._element) || !this._isShown(this._menu)) {
      return;
    }

    const relatedTarget = {
      relatedTarget: this._element
    };

    this._completeHide(relatedTarget);
  }

  dispose() {
    if (this._popper) {
      this._popper.destroy();
    }

    super.dispose();
  }

  update() {
    this._inNavbar = this._detectNavbar();

    if (this._popper) {
      this._popper.update();
    }
  } // Private


  _completeHide(relatedTarget) {
    const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4, relatedTarget);

    if (hideEvent.defaultPrevented) {
      return;
    } // If this is a touch-enabled device we remove the extra
    // empty mouseover listeners we added for iOS support


    if ('ontouchstart' in document.documentElement) {
      [].concat(...document.body.children).forEach(elem => EventHandler.off(elem, 'mouseover', noop$2));
    }

    if (this._popper) {
      this._popper.destroy();
    }

    this._menu.classList.remove(CLASS_NAME_SHOW$6);

    this._element.classList.remove(CLASS_NAME_SHOW$6);

    this._element.setAttribute('aria-expanded', 'false');

    Manipulator.removeDataAttribute(this._menu, 'popper');
    EventHandler.trigger(this._element, EVENT_HIDDEN$4, relatedTarget);
  }

  _getConfig(config) {
    config = { ...this.constructor.Default,
      ...Manipulator.getDataAttributes(this._element),
      ...config
    };
    typeCheckConfig(NAME$9, config, this.constructor.DefaultType);

    if (typeof config.reference === 'object' && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') {
      // Popper virtual elements require a getBoundingClientRect method
      throw new TypeError(`${NAME$9.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
    }

    return config;
  }

  _createPopper(parent) {
    if (typeof Popper === 'undefined') {
      throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
    }

    let referenceElement = this._element;

    if (this._config.reference === 'parent') {
      referenceElement = parent;
    } else if (isElement(this._config.reference)) {
      referenceElement = getElement(this._config.reference);
    } else if (typeof this._config.reference === 'object') {
      referenceElement = this._config.reference;
    }

    const popperConfig = this._getPopperConfig();

    const isDisplayStatic = popperConfig.modifiers.find(modifier => modifier.name === 'applyStyles' && modifier.enabled === false);
    this._popper = createPopper(referenceElement, this._menu, popperConfig);

    if (isDisplayStatic) {
      Manipulator.setDataAttribute(this._menu, 'popper', 'static');
    }
  }

  _isShown(element = this._element) {
    return element.classList.contains(CLASS_NAME_SHOW$6);
  }

  _getMenuElement() {
    return SelectorEngine.next(this._element, SELECTOR_MENU)[0];
  }

  _getPlacement() {
    const parentDropdown = this._element.parentNode;

    if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) {
      return PLACEMENT_RIGHT;
    }

    if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) {
      return PLACEMENT_LEFT;
    } // We need to trim the value because custom properties can also include spaces


    const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';

    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) {
      return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
    }

    return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
  }

  _detectNavbar() {
    return this._element.closest(`.${CLASS_NAME_NAVBAR}`) !== null;
  }

  _getOffset() {
    const {
      offset
    } = this._config;

    if (typeof offset === 'string') {
      return offset.split(',').map(val => Number.parseInt(val, 10));
    }

    if (typeof offset === 'function') {
      return popperData => offset(popperData, this._element);
    }

    return offset;
  }

  _getPopperConfig() {
    const defaultBsPopperConfig = {
      placement: this._getPlacement(),
      modifiers: [{
        name: 'preventOverflow',
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: 'offset',
        options: {
          offset: this._getOffset()
        }
      }]
    }; // Disable Popper if we have a static display

    if (this._config.display === 'static') {
      defaultBsPopperConfig.modifiers = [{
        name: 'applyStyles',
        enabled: false
      }];
    }

    return { ...defaultBsPopperConfig,
      ...(typeof this._config.popperConfig === 'function' ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig)
    };
  }

  _selectMenuItem({
    key,
    target
  }) {
    const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(isVisible);

    if (!items.length) {
      return;
    } // if target isn't included in items (e.g. when expanding the dropdown)
    // allow cycling to get the last item in case key equals ARROW_UP_KEY


    getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Dropdown.getOrCreateInstance(this, config);

      if (typeof config !== 'string') {
        return;
      }

      if (typeof data[config] === 'undefined') {
        throw new TypeError(`No method named "${config}"`);
      }

      data[config]();
    });
  }

  static clearMenus(event) {
    if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1)) {
      return;
    }

    const toggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE$3);

    for (let i = 0, len = toggles.length; i < len; i++) {
      const context = Dropdown.getInstance(toggles[i]);

      if (!context || context._config.autoClose === false) {
        continue;
      }

      if (!context._isShown()) {
        continue;
      }

      const relatedTarget = {
        relatedTarget: context._element
      };

      if (event) {
        const composedPath = event.composedPath();
        const isMenuTarget = composedPath.includes(context._menu);

        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) {
          continue;
        } // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu


        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) {
          continue;
        }

        if (event.type === 'click') {
          relatedTarget.clickEvent = event;
        }
      }

      context._completeHide(relatedTarget);
    }
  }

  static getParentFromElement(element) {
    return getElementFromSelector(element) || element.parentNode;
  }

  static dataApiKeydownHandler(event) {
    // If not input/textarea:
    //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
    // If input/textarea:
    //  - If space key => not a dropdown command
    //  - If key is other than escape
    //    - If key is not up or down => not a dropdown command
    //    - If trigger inside the menu => not a dropdown command
    if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY$2 && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) {
      return;
    }

    const isActive = this.classList.contains(CLASS_NAME_SHOW$6);

    if (!isActive && event.key === ESCAPE_KEY$2) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (isDisabled(this)) {
      return;
    }

    const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0];
    const instance = Dropdown.getOrCreateInstance(getToggleButton);

    if (event.key === ESCAPE_KEY$2) {
      instance.hide();
      return;
    }

    if (event.key === ARROW_UP_KEY || event.key === ARROW_DOWN_KEY) {
      if (!isActive) {
        instance.show();
      }

      instance._selectMenuItem(event);

      return;
    }

    if (!isActive || event.key === SPACE_KEY) {
      Dropdown.clearMenus();
    }
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
  event.preventDefault();
  Dropdown.getOrCreateInstance(this).toggle();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Dropdown to jQuery only if jQuery is present
 */

defineJQueryPlugin(Dropdown);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const SELECTOR_STICKY_CONTENT = '.sticky-top';

class ScrollBarHelper {
  constructor() {
    this._element = document.body;
  }

  getWidth() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
  }

  hide() {
    const width = this.getWidth();

    this._disableOverFlow(); // give padding to element to balance the hidden scrollbar width


    this._setElementAttributes(this._element, 'paddingRight', calculatedValue => calculatedValue + width); // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth


    this._setElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight', calculatedValue => calculatedValue + width);

    this._setElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight', calculatedValue => calculatedValue - width);
  }

  _disableOverFlow() {
    this._saveInitialAttribute(this._element, 'overflow');

    this._element.style.overflow = 'hidden';
  }

  _setElementAttributes(selector, styleProp, callback) {
    const scrollbarWidth = this.getWidth();

    const manipulationCallBack = element => {
      if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) {
        return;
      }

      this._saveInitialAttribute(element, styleProp);

      const calculatedValue = window.getComputedStyle(element)[styleProp];
      element.style[styleProp] = `${callback(Number.parseFloat(calculatedValue))}px`;
    };

    this._applyManipulationCallback(selector, manipulationCallBack);
  }

  reset() {
    this._resetElementAttributes(this._element, 'overflow');

    this._resetElementAttributes(this._element, 'paddingRight');

    this._resetElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight');

    this._resetElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight');
  }

  _saveInitialAttribute(element, styleProp) {
    const actualValue = element.style[styleProp];

    if (actualValue) {
      Manipulator.setDataAttribute(element, styleProp, actualValue);
    }
  }

  _resetElementAttributes(selector, styleProp) {
    const manipulationCallBack = element => {
      const value = Manipulator.getDataAttribute(element, styleProp);

      if (typeof value === 'undefined') {
        element.style.removeProperty(styleProp);
      } else {
        Manipulator.removeDataAttribute(element, styleProp);
        element.style[styleProp] = value;
      }
    };

    this._applyManipulationCallback(selector, manipulationCallBack);
  }

  _applyManipulationCallback(selector, callBack) {
    if (isElement(selector)) {
      callBack(selector);
    } else {
      SelectorEngine.find(selector, this._element).forEach(callBack);
    }
  }

  isOverflowing() {
    return this.getWidth() > 0;
  }

}

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
const Default$7 = {
  className: 'modal-backdrop',
  isVisible: true,
  // if false, we use the backdrop helper without adding any element to the dom
  isAnimated: false,
  rootElement: 'body',
  // give the choice to place backdrop under different elements
  clickCallback: null
};
const DefaultType$7 = {
  className: 'string',
  isVisible: 'boolean',
  isAnimated: 'boolean',
  rootElement: '(element|string)',
  clickCallback: '(function|null)'
};
const NAME$8 = 'backdrop';
const CLASS_NAME_FADE$4 = 'fade';
const CLASS_NAME_SHOW$5 = 'show';
const EVENT_MOUSEDOWN = `mousedown.bs.${NAME$8}`;

class Backdrop {
  constructor(config) {
    this._config = this._getConfig(config);
    this._isAppended = false;
    this._element = null;
  }

  show(callback) {
    if (!this._config.isVisible) {
      execute(callback);
      return;
    }

    this._append();

    if (this._config.isAnimated) {
      reflow(this._getElement());
    }

    this._getElement().classList.add(CLASS_NAME_SHOW$5);

    this._emulateAnimation(() => {
      execute(callback);
    });
  }

  hide(callback) {
    if (!this._config.isVisible) {
      execute(callback);
      return;
    }

    this._getElement().classList.remove(CLASS_NAME_SHOW$5);

    this._emulateAnimation(() => {
      this.dispose();
      execute(callback);
    });
  } // Private


  _getElement() {
    if (!this._element) {
      const backdrop = document.createElement('div');
      backdrop.className = this._config.className;

      if (this._config.isAnimated) {
        backdrop.classList.add(CLASS_NAME_FADE$4);
      }

      this._element = backdrop;
    }

    return this._element;
  }

  _getConfig(config) {
    config = { ...Default$7,
      ...(typeof config === 'object' ? config : {})
    }; // use getElement() with the default "body" to get a fresh Element on each instantiation

    config.rootElement = getElement(config.rootElement);
    typeCheckConfig(NAME$8, config, DefaultType$7);
    return config;
  }

  _append() {
    if (this._isAppended) {
      return;
    }

    this._config.rootElement.append(this._getElement());

    EventHandler.on(this._getElement(), EVENT_MOUSEDOWN, () => {
      execute(this._config.clickCallback);
    });
    this._isAppended = true;
  }

  dispose() {
    if (!this._isAppended) {
      return;
    }

    EventHandler.off(this._element, EVENT_MOUSEDOWN);

    this._element.remove();

    this._isAppended = false;
  }

  _emulateAnimation(callback) {
    executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
  }

}

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
const Default$6 = {
  trapElement: null,
  // The element to trap focus inside of
  autofocus: true
};
const DefaultType$6 = {
  trapElement: 'element',
  autofocus: 'boolean'
};
const NAME$7 = 'focustrap';
const DATA_KEY$7 = 'bs.focustrap';
const EVENT_KEY$7 = `.${DATA_KEY$7}`;
const EVENT_FOCUSIN$1 = `focusin${EVENT_KEY$7}`;
const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$7}`;
const TAB_KEY = 'Tab';
const TAB_NAV_FORWARD = 'forward';
const TAB_NAV_BACKWARD = 'backward';

class FocusTrap {
  constructor(config) {
    this._config = this._getConfig(config);
    this._isActive = false;
    this._lastTabNavDirection = null;
  }

  activate() {
    const {
      trapElement,
      autofocus
    } = this._config;

    if (this._isActive) {
      return;
    }

    if (autofocus) {
      trapElement.focus();
    }

    EventHandler.off(document, EVENT_KEY$7); // guard against infinite focus loop

    EventHandler.on(document, EVENT_FOCUSIN$1, event => this._handleFocusin(event));
    EventHandler.on(document, EVENT_KEYDOWN_TAB, event => this._handleKeydown(event));
    this._isActive = true;
  }

  deactivate() {
    if (!this._isActive) {
      return;
    }

    this._isActive = false;
    EventHandler.off(document, EVENT_KEY$7);
  } // Private


  _handleFocusin(event) {
    const {
      target
    } = event;
    const {
      trapElement
    } = this._config;

    if (target === document || target === trapElement || trapElement.contains(target)) {
      return;
    }

    const elements = SelectorEngine.focusableChildren(trapElement);

    if (elements.length === 0) {
      trapElement.focus();
    } else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) {
      elements[elements.length - 1].focus();
    } else {
      elements[0].focus();
    }
  }

  _handleKeydown(event) {
    if (event.key !== TAB_KEY) {
      return;
    }

    this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
  }

  _getConfig(config) {
    config = { ...Default$6,
      ...(typeof config === 'object' ? config : {})
    };
    typeCheckConfig(NAME$7, config, DefaultType$6);
    return config;
  }

}

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$6 = 'modal';
const DATA_KEY$6 = 'bs.modal';
const EVENT_KEY$6 = `.${DATA_KEY$6}`;
const DATA_API_KEY$3 = '.data-api';
const ESCAPE_KEY$1 = 'Escape';
const Default$5 = {
  backdrop: true,
  keyboard: true,
  focus: true
};
const DefaultType$5 = {
  backdrop: '(boolean|string)',
  keyboard: 'boolean',
  focus: 'boolean'
};
const EVENT_HIDE$3 = `hide${EVENT_KEY$6}`;
const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$6}`;
const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$6}`;
const EVENT_SHOW$3 = `show${EVENT_KEY$6}`;
const EVENT_SHOWN$3 = `shown${EVENT_KEY$6}`;
const EVENT_RESIZE = `resize${EVENT_KEY$6}`;
const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$6}`;
const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$6}`;
const EVENT_MOUSEUP_DISMISS = `mouseup.dismiss${EVENT_KEY$6}`;
const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$6}`;
const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$6}${DATA_API_KEY$3}`;
const CLASS_NAME_OPEN = 'modal-open';
const CLASS_NAME_FADE$3 = 'fade';
const CLASS_NAME_SHOW$4 = 'show';
const CLASS_NAME_STATIC = 'modal-static';
const SELECTOR_DIALOG = '.modal-dialog';
const SELECTOR_MODAL_BODY = '.modal-body';
const SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Modal extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._config = this._getConfig(config);
    this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
    this._backdrop = this._initializeBackDrop();
    this._focustrap = this._initializeFocusTrap();
    this._isShown = false;
    this._ignoreBackdropClick = false;
    this._isTransitioning = false;
    this._scrollBar = new ScrollBarHelper();
  } // Getters


  static get Default() {
    return Default$5;
  }

  static get NAME() {
    return NAME$6;
  } // Public


  toggle(relatedTarget) {
    return this._isShown ? this.hide() : this.show(relatedTarget);
  }

  show(relatedTarget) {
    if (this._isShown || this._isTransitioning) {
      return;
    }

    const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
      relatedTarget
    });

    if (showEvent.defaultPrevented) {
      return;
    }

    this._isShown = true;

    if (this._isAnimated()) {
      this._isTransitioning = true;
    }

    this._scrollBar.hide();

    document.body.classList.add(CLASS_NAME_OPEN);

    this._adjustDialog();

    this._setEscapeEvent();

    this._setResizeEvent();

    EventHandler.on(this._dialog, EVENT_MOUSEDOWN_DISMISS, () => {
      EventHandler.one(this._element, EVENT_MOUSEUP_DISMISS, event => {
        if (event.target === this._element) {
          this._ignoreBackdropClick = true;
        }
      });
    });

    this._showBackdrop(() => this._showElement(relatedTarget));
  }

  hide() {
    if (!this._isShown || this._isTransitioning) {
      return;
    }

    const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);

    if (hideEvent.defaultPrevented) {
      return;
    }

    this._isShown = false;

    const isAnimated = this._isAnimated();

    if (isAnimated) {
      this._isTransitioning = true;
    }

    this._setEscapeEvent();

    this._setResizeEvent();

    this._focustrap.deactivate();

    this._element.classList.remove(CLASS_NAME_SHOW$4);

    EventHandler.off(this._element, EVENT_CLICK_DISMISS);
    EventHandler.off(this._dialog, EVENT_MOUSEDOWN_DISMISS);

    this._queueCallback(() => this._hideModal(), this._element, isAnimated);
  }

  dispose() {
    [window, this._dialog].forEach(htmlElement => EventHandler.off(htmlElement, EVENT_KEY$6));

    this._backdrop.dispose();

    this._focustrap.deactivate();

    super.dispose();
  }

  handleUpdate() {
    this._adjustDialog();
  } // Private


  _initializeBackDrop() {
    return new Backdrop({
      isVisible: Boolean(this._config.backdrop),
      // 'static' option will be translated to true, and booleans will keep their value
      isAnimated: this._isAnimated()
    });
  }

  _initializeFocusTrap() {
    return new FocusTrap({
      trapElement: this._element
    });
  }

  _getConfig(config) {
    config = { ...Default$5,
      ...Manipulator.getDataAttributes(this._element),
      ...(typeof config === 'object' ? config : {})
    };
    typeCheckConfig(NAME$6, config, DefaultType$5);
    return config;
  }

  _showElement(relatedTarget) {
    const isAnimated = this._isAnimated();

    const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);

    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
      // Don't move modal's DOM position
      document.body.append(this._element);
    }

    this._element.style.display = 'block';

    this._element.removeAttribute('aria-hidden');

    this._element.setAttribute('aria-modal', true);

    this._element.setAttribute('role', 'dialog');

    this._element.scrollTop = 0;

    if (modalBody) {
      modalBody.scrollTop = 0;
    }

    if (isAnimated) {
      reflow(this._element);
    }

    this._element.classList.add(CLASS_NAME_SHOW$4);

    const transitionComplete = () => {
      if (this._config.focus) {
        this._focustrap.activate();
      }

      this._isTransitioning = false;
      EventHandler.trigger(this._element, EVENT_SHOWN$3, {
        relatedTarget
      });
    };

    this._queueCallback(transitionComplete, this._dialog, isAnimated);
  }

  _setEscapeEvent() {
    if (this._isShown) {
      EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, event => {
        if (this._config.keyboard && event.key === ESCAPE_KEY$1) {
          event.preventDefault();
          this.hide();
        } else if (!this._config.keyboard && event.key === ESCAPE_KEY$1) {
          this._triggerBackdropTransition();
        }
      });
    } else {
      EventHandler.off(this._element, EVENT_KEYDOWN_DISMISS$1);
    }
  }

  _setResizeEvent() {
    if (this._isShown) {
      EventHandler.on(window, EVENT_RESIZE, () => this._adjustDialog());
    } else {
      EventHandler.off(window, EVENT_RESIZE);
    }
  }

  _hideModal() {
    this._element.style.display = 'none';

    this._element.setAttribute('aria-hidden', true);

    this._element.removeAttribute('aria-modal');

    this._element.removeAttribute('role');

    this._isTransitioning = false;

    this._backdrop.hide(() => {
      document.body.classList.remove(CLASS_NAME_OPEN);

      this._resetAdjustments();

      this._scrollBar.reset();

      EventHandler.trigger(this._element, EVENT_HIDDEN$3);
    });
  }

  _showBackdrop(callback) {
    EventHandler.on(this._element, EVENT_CLICK_DISMISS, event => {
      if (this._ignoreBackdropClick) {
        this._ignoreBackdropClick = false;
        return;
      }

      if (event.target !== event.currentTarget) {
        return;
      }

      if (this._config.backdrop === true) {
        this.hide();
      } else if (this._config.backdrop === 'static') {
        this._triggerBackdropTransition();
      }
    });

    this._backdrop.show(callback);
  }

  _isAnimated() {
    return this._element.classList.contains(CLASS_NAME_FADE$3);
  }

  _triggerBackdropTransition() {
    const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);

    if (hideEvent.defaultPrevented) {
      return;
    }

    const {
      classList,
      scrollHeight,
      style
    } = this._element;
    const isModalOverflowing = scrollHeight > document.documentElement.clientHeight; // return if the following background transition hasn't yet completed

    if (!isModalOverflowing && style.overflowY === 'hidden' || classList.contains(CLASS_NAME_STATIC)) {
      return;
    }

    if (!isModalOverflowing) {
      style.overflowY = 'hidden';
    }

    classList.add(CLASS_NAME_STATIC);

    this._queueCallback(() => {
      classList.remove(CLASS_NAME_STATIC);

      if (!isModalOverflowing) {
        this._queueCallback(() => {
          style.overflowY = '';
        }, this._dialog);
      }
    }, this._dialog);

    this._element.focus();
  } // ----------------------------------------------------------------------
  // the following methods are used to handle overflowing modals
  // ----------------------------------------------------------------------


  _adjustDialog() {
    const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

    const scrollbarWidth = this._scrollBar.getWidth();

    const isBodyOverflowing = scrollbarWidth > 0;

    if (!isBodyOverflowing && isModalOverflowing && !isRTL() || isBodyOverflowing && !isModalOverflowing && isRTL()) {
      this._element.style.paddingLeft = `${scrollbarWidth}px`;
    }

    if (isBodyOverflowing && !isModalOverflowing && !isRTL() || !isBodyOverflowing && isModalOverflowing && isRTL()) {
      this._element.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  _resetAdjustments() {
    this._element.style.paddingLeft = '';
    this._element.style.paddingRight = '';
  } // Static


  static jQueryInterface(config, relatedTarget) {
    return this.each(function () {
      const data = Modal.getOrCreateInstance(this, config);

      if (typeof config !== 'string') {
        return;
      }

      if (typeof data[config] === 'undefined') {
        throw new TypeError(`No method named "${config}"`);
      }

      data[config](relatedTarget);
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
  const target = getElementFromSelector(this);

  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  EventHandler.one(target, EVENT_SHOW$3, showEvent => {
    if (showEvent.defaultPrevented) {
      // only register focus restorer if modal will actually get shown
      return;
    }

    EventHandler.one(target, EVENT_HIDDEN$3, () => {
      if (isVisible(this)) {
        this.focus();
      }
    });
  });
  const data = Modal.getOrCreateInstance(target);
  data.toggle(this);
});
enableDismissTrigger(Modal);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Modal to jQuery only if jQuery is present
 */

defineJQueryPlugin(Modal);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$5 = 'offcanvas';
const DATA_KEY$5 = 'bs.offcanvas';
const EVENT_KEY$5 = `.${DATA_KEY$5}`;
const DATA_API_KEY$2 = '.data-api';
const EVENT_LOAD_DATA_API$1 = `load${EVENT_KEY$5}${DATA_API_KEY$2}`;
const ESCAPE_KEY = 'Escape';
const Default$4 = {
  backdrop: true,
  keyboard: true,
  scroll: false
};
const DefaultType$4 = {
  backdrop: 'boolean',
  keyboard: 'boolean',
  scroll: 'boolean'
};
const CLASS_NAME_SHOW$3 = 'show';
const CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const OPEN_SELECTOR = '.offcanvas.show';
const EVENT_SHOW$2 = `show${EVENT_KEY$5}`;
const EVENT_SHOWN$2 = `shown${EVENT_KEY$5}`;
const EVENT_HIDE$2 = `hide${EVENT_KEY$5}`;
const EVENT_HIDDEN$2 = `hidden${EVENT_KEY$5}`;
const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$5}${DATA_API_KEY$2}`;
const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$5}`;
const SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Offcanvas extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._config = this._getConfig(config);
    this._isShown = false;
    this._backdrop = this._initializeBackDrop();
    this._focustrap = this._initializeFocusTrap();

    this._addEventListeners();
  } // Getters


  static get NAME() {
    return NAME$5;
  }

  static get Default() {
    return Default$4;
  } // Public


  toggle(relatedTarget) {
    return this._isShown ? this.hide() : this.show(relatedTarget);
  }

  show(relatedTarget) {
    if (this._isShown) {
      return;
    }

    const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$2, {
      relatedTarget
    });

    if (showEvent.defaultPrevented) {
      return;
    }

    this._isShown = true;
    this._element.style.visibility = 'visible';

    this._backdrop.show();

    if (!this._config.scroll) {
      new ScrollBarHelper().hide();
    }

    this._element.removeAttribute('aria-hidden');

    this._element.setAttribute('aria-modal', true);

    this._element.setAttribute('role', 'dialog');

    this._element.classList.add(CLASS_NAME_SHOW$3);

    const completeCallBack = () => {
      if (!this._config.scroll) {
        this._focustrap.activate();
      }

      EventHandler.trigger(this._element, EVENT_SHOWN$2, {
        relatedTarget
      });
    };

    this._queueCallback(completeCallBack, this._element, true);
  }

  hide() {
    if (!this._isShown) {
      return;
    }

    const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$2);

    if (hideEvent.defaultPrevented) {
      return;
    }

    this._focustrap.deactivate();

    this._element.blur();

    this._isShown = false;

    this._element.classList.remove(CLASS_NAME_SHOW$3);

    this._backdrop.hide();

    const completeCallback = () => {
      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._element.style.visibility = 'hidden';

      if (!this._config.scroll) {
        new ScrollBarHelper().reset();
      }

      EventHandler.trigger(this._element, EVENT_HIDDEN$2);
    };

    this._queueCallback(completeCallback, this._element, true);
  }

  dispose() {
    this._backdrop.dispose();

    this._focustrap.deactivate();

    super.dispose();
  } // Private


  _getConfig(config) {
    config = { ...Default$4,
      ...Manipulator.getDataAttributes(this._element),
      ...(typeof config === 'object' ? config : {})
    };
    typeCheckConfig(NAME$5, config, DefaultType$4);
    return config;
  }

  _initializeBackDrop() {
    return new Backdrop({
      className: CLASS_NAME_BACKDROP,
      isVisible: this._config.backdrop,
      isAnimated: true,
      rootElement: this._element.parentNode,
      clickCallback: () => this.hide()
    });
  }

  _initializeFocusTrap() {
    return new FocusTrap({
      trapElement: this._element
    });
  }

  _addEventListeners() {
    EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, event => {
      if (this._config.keyboard && event.key === ESCAPE_KEY) {
        this.hide();
      }
    });
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Offcanvas.getOrCreateInstance(this, config);

      if (typeof config !== 'string') {
        return;
      }

      if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
        throw new TypeError(`No method named "${config}"`);
      }

      data[config](this);
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
  const target = getElementFromSelector(this);

  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  if (isDisabled(this)) {
    return;
  }

  EventHandler.one(target, EVENT_HIDDEN$2, () => {
    // focus on trigger when it is closed
    if (isVisible(this)) {
      this.focus();
    }
  }); // avoid conflict when clicking a toggler of an offcanvas, while another is open

  const allReadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);

  if (allReadyOpen && allReadyOpen !== target) {
    Offcanvas.getInstance(allReadyOpen).hide();
  }

  const data = Offcanvas.getOrCreateInstance(target);
  data.toggle(this);
});
EventHandler.on(window, EVENT_LOAD_DATA_API$1, () => SelectorEngine.find(OPEN_SELECTOR).forEach(el => Offcanvas.getOrCreateInstance(el).show()));
enableDismissTrigger(Offcanvas);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

defineJQueryPlugin(Offcanvas);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
const uriAttrs = new Set(['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href']);
const ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
 */

const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/i;
/**
 * A pattern that matches safe data URLs. Only matches image, video and audio types.
 *
 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
 */

const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

const allowedAttribute = (attr, allowedAttributeList) => {
  const attrName = attr.nodeName.toLowerCase();

  if (allowedAttributeList.includes(attrName)) {
    if (uriAttrs.has(attrName)) {
      return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
    }

    return true;
  }

  const regExp = allowedAttributeList.filter(attrRegex => attrRegex instanceof RegExp); // Check if a regular expression validates the attribute.

  for (let i = 0, len = regExp.length; i < len; i++) {
    if (regExp[i].test(attrName)) {
      return true;
    }
  }

  return false;
};

const DefaultAllowlist = {
  // Global attributes allowed on any supplied element below.
  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
  a: ['target', 'href', 'title', 'rel'],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  div: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
};
function sanitizeHtml(unsafeHtml, allowList, sanitizeFn) {
  if (!unsafeHtml.length) {
    return unsafeHtml;
  }

  if (sanitizeFn && typeof sanitizeFn === 'function') {
    return sanitizeFn(unsafeHtml);
  }

  const domParser = new window.DOMParser();
  const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
  const allowlistKeys = Object.keys(allowList);
  const elements = [].concat(...createdDocument.body.querySelectorAll('*'));

  for (let i = 0, len = elements.length; i < len; i++) {
    const el = elements[i];
    const elName = el.nodeName.toLowerCase();

    if (!allowlistKeys.includes(elName)) {
      el.remove();
      continue;
    }

    const attributeList = [].concat(...el.attributes);
    const allowedAttributes = [].concat(allowList['*'] || [], allowList[elName] || []);
    attributeList.forEach(attr => {
      if (!allowedAttribute(attr, allowedAttributes)) {
        el.removeAttribute(attr.nodeName);
      }
    });
  }

  return createdDocument.body.innerHTML;
}

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$4 = 'tooltip';
const DATA_KEY$4 = 'bs.tooltip';
const EVENT_KEY$4 = `.${DATA_KEY$4}`;
const CLASS_PREFIX$1 = 'bs-tooltip';
const DISALLOWED_ATTRIBUTES = new Set(['sanitize', 'allowList', 'sanitizeFn']);
const DefaultType$3 = {
  animation: 'boolean',
  template: 'string',
  title: '(string|element|function)',
  trigger: 'string',
  delay: '(number|object)',
  html: 'boolean',
  selector: '(string|boolean)',
  placement: '(string|function)',
  offset: '(array|string|function)',
  container: '(string|element|boolean)',
  fallbackPlacements: 'array',
  boundary: '(string|element)',
  customClass: '(string|function)',
  sanitize: 'boolean',
  sanitizeFn: '(null|function)',
  allowList: 'object',
  popperConfig: '(null|object|function)'
};
const AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top',
  RIGHT: isRTL() ? 'left' : 'right',
  BOTTOM: 'bottom',
  LEFT: isRTL() ? 'right' : 'left'
};
const Default$3 = {
  animation: true,
  template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-arrow"></div>' + '<div class="tooltip-inner"></div>' + '</div>',
  trigger: 'hover focus',
  title: '',
  delay: 0,
  html: false,
  selector: false,
  placement: 'top',
  offset: [0, 0],
  container: false,
  fallbackPlacements: ['top', 'right', 'bottom', 'left'],
  boundary: 'clippingParents',
  customClass: '',
  sanitize: true,
  sanitizeFn: null,
  allowList: DefaultAllowlist,
  popperConfig: null
};
const Event$2 = {
  HIDE: `hide${EVENT_KEY$4}`,
  HIDDEN: `hidden${EVENT_KEY$4}`,
  SHOW: `show${EVENT_KEY$4}`,
  SHOWN: `shown${EVENT_KEY$4}`,
  INSERTED: `inserted${EVENT_KEY$4}`,
  CLICK: `click${EVENT_KEY$4}`,
  FOCUSIN: `focusin${EVENT_KEY$4}`,
  FOCUSOUT: `focusout${EVENT_KEY$4}`,
  MOUSEENTER: `mouseenter${EVENT_KEY$4}`,
  MOUSELEAVE: `mouseleave${EVENT_KEY$4}`
};
const CLASS_NAME_FADE$2 = 'fade';
const CLASS_NAME_MODAL = 'modal';
const CLASS_NAME_SHOW$2 = 'show';
const HOVER_STATE_SHOW = 'show';
const HOVER_STATE_OUT = 'out';
const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const SELECTOR_MODAL = `.${CLASS_NAME_MODAL}`;
const EVENT_MODAL_HIDE = 'hide.bs.modal';
const TRIGGER_HOVER = 'hover';
const TRIGGER_FOCUS = 'focus';
const TRIGGER_CLICK = 'click';
const TRIGGER_MANUAL = 'manual';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Tooltip extends BaseComponent {
  constructor(element, config) {
    if (typeof Popper === 'undefined') {
      throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
    }

    super(element); // private

    this._isEnabled = true;
    this._timeout = 0;
    this._hoverState = '';
    this._activeTrigger = {};
    this._popper = null; // Protected

    this._config = this._getConfig(config);
    this.tip = null;

    this._setListeners();
  } // Getters


  static get Default() {
    return Default$3;
  }

  static get NAME() {
    return NAME$4;
  }

  static get Event() {
    return Event$2;
  }

  static get DefaultType() {
    return DefaultType$3;
  } // Public


  enable() {
    this._isEnabled = true;
  }

  disable() {
    this._isEnabled = false;
  }

  toggleEnabled() {
    this._isEnabled = !this._isEnabled;
  }

  toggle(event) {
    if (!this._isEnabled) {
      return;
    }

    if (event) {
      const context = this._initializeOnDelegatedTarget(event);

      context._activeTrigger.click = !context._activeTrigger.click;

      if (context._isWithActiveTrigger()) {
        context._enter(null, context);
      } else {
        context._leave(null, context);
      }
    } else {
      if (this.getTipElement().classList.contains(CLASS_NAME_SHOW$2)) {
        this._leave(null, this);

        return;
      }

      this._enter(null, this);
    }
  }

  dispose() {
    clearTimeout(this._timeout);
    EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);

    if (this.tip) {
      this.tip.remove();
    }

    if (this._popper) {
      this._popper.destroy();
    }

    super.dispose();
  }

  show() {
    if (this._element.style.display === 'none') {
      throw new Error('Please use show on visible elements');
    }

    if (!(this.isWithContent() && this._isEnabled)) {
      return;
    }

    const showEvent = EventHandler.trigger(this._element, this.constructor.Event.SHOW);
    const shadowRoot = findShadowRoot(this._element);
    const isInTheDom = shadowRoot === null ? this._element.ownerDocument.documentElement.contains(this._element) : shadowRoot.contains(this._element);

    if (showEvent.defaultPrevented || !isInTheDom) {
      return;
    }

    const tip = this.getTipElement();
    const tipId = getUID(this.constructor.NAME);
    tip.setAttribute('id', tipId);

    this._element.setAttribute('aria-describedby', tipId);

    if (this._config.animation) {
      tip.classList.add(CLASS_NAME_FADE$2);
    }

    const placement = typeof this._config.placement === 'function' ? this._config.placement.call(this, tip, this._element) : this._config.placement;

    const attachment = this._getAttachment(placement);

    this._addAttachmentClass(attachment);

    const {
      container
    } = this._config;
    Data.set(tip, this.constructor.DATA_KEY, this);

    if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
      container.append(tip);
      EventHandler.trigger(this._element, this.constructor.Event.INSERTED);
    }

    if (this._popper) {
      this._popper.update();
    } else {
      this._popper = createPopper(this._element, tip, this._getPopperConfig(attachment));
    }

    tip.classList.add(CLASS_NAME_SHOW$2);

    const customClass = this._resolvePossibleFunction(this._config.customClass);

    if (customClass) {
      tip.classList.add(...customClass.split(' '));
    } // If this is a touch-enabled device we add extra
    // empty mouseover listeners to the body's immediate children;
    // only needed because of broken event delegation on iOS
    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


    if ('ontouchstart' in document.documentElement) {
      [].concat(...document.body.children).forEach(element => {
        EventHandler.on(element, 'mouseover', noop$2);
      });
    }

    const complete = () => {
      const prevHoverState = this._hoverState;
      this._hoverState = null;
      EventHandler.trigger(this._element, this.constructor.Event.SHOWN);

      if (prevHoverState === HOVER_STATE_OUT) {
        this._leave(null, this);
      }
    };

    const isAnimated = this.tip.classList.contains(CLASS_NAME_FADE$2);

    this._queueCallback(complete, this.tip, isAnimated);
  }

  hide() {
    if (!this._popper) {
      return;
    }

    const tip = this.getTipElement();

    const complete = () => {
      if (this._isWithActiveTrigger()) {
        return;
      }

      if (this._hoverState !== HOVER_STATE_SHOW) {
        tip.remove();
      }

      this._cleanTipClass();

      this._element.removeAttribute('aria-describedby');

      EventHandler.trigger(this._element, this.constructor.Event.HIDDEN);

      if (this._popper) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    const hideEvent = EventHandler.trigger(this._element, this.constructor.Event.HIDE);

    if (hideEvent.defaultPrevented) {
      return;
    }

    tip.classList.remove(CLASS_NAME_SHOW$2); // If this is a touch-enabled device we remove the extra
    // empty mouseover listeners we added for iOS support

    if ('ontouchstart' in document.documentElement) {
      [].concat(...document.body.children).forEach(element => EventHandler.off(element, 'mouseover', noop$2));
    }

    this._activeTrigger[TRIGGER_CLICK] = false;
    this._activeTrigger[TRIGGER_FOCUS] = false;
    this._activeTrigger[TRIGGER_HOVER] = false;
    const isAnimated = this.tip.classList.contains(CLASS_NAME_FADE$2);

    this._queueCallback(complete, this.tip, isAnimated);

    this._hoverState = '';
  }

  update() {
    if (this._popper !== null) {
      this._popper.update();
    }
  } // Protected


  isWithContent() {
    return Boolean(this.getTitle());
  }

  getTipElement() {
    if (this.tip) {
      return this.tip;
    }

    const element = document.createElement('div');
    element.innerHTML = this._config.template;
    const tip = element.children[0];
    this.setContent(tip);
    tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
    this.tip = tip;
    return this.tip;
  }

  setContent(tip) {
    this._sanitizeAndSetContent(tip, this.getTitle(), SELECTOR_TOOLTIP_INNER);
  }

  _sanitizeAndSetContent(template, content, selector) {
    const templateElement = SelectorEngine.findOne(selector, template);

    if (!content && templateElement) {
      templateElement.remove();
      return;
    } // we use append for html objects to maintain js events


    this.setElementContent(templateElement, content);
  }

  setElementContent(element, content) {
    if (element === null) {
      return;
    }

    if (isElement(content)) {
      content = getElement(content); // content is a DOM node or a jQuery

      if (this._config.html) {
        if (content.parentNode !== element) {
          element.innerHTML = '';
          element.append(content);
        }
      } else {
        element.textContent = content.textContent;
      }

      return;
    }

    if (this._config.html) {
      if (this._config.sanitize) {
        content = sanitizeHtml(content, this._config.allowList, this._config.sanitizeFn);
      }

      element.innerHTML = content;
    } else {
      element.textContent = content;
    }
  }

  getTitle() {
    const title = this._element.getAttribute('data-bs-original-title') || this._config.title;

    return this._resolvePossibleFunction(title);
  }

  updateAttachment(attachment) {
    if (attachment === 'right') {
      return 'end';
    }

    if (attachment === 'left') {
      return 'start';
    }

    return attachment;
  } // Private


  _initializeOnDelegatedTarget(event, context) {
    return context || this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
  }

  _getOffset() {
    const {
      offset
    } = this._config;

    if (typeof offset === 'string') {
      return offset.split(',').map(val => Number.parseInt(val, 10));
    }

    if (typeof offset === 'function') {
      return popperData => offset(popperData, this._element);
    }

    return offset;
  }

  _resolvePossibleFunction(content) {
    return typeof content === 'function' ? content.call(this._element) : content;
  }

  _getPopperConfig(attachment) {
    const defaultBsPopperConfig = {
      placement: attachment,
      modifiers: [{
        name: 'flip',
        options: {
          fallbackPlacements: this._config.fallbackPlacements
        }
      }, {
        name: 'offset',
        options: {
          offset: this._getOffset()
        }
      }, {
        name: 'preventOverflow',
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: 'arrow',
        options: {
          element: `.${this.constructor.NAME}-arrow`
        }
      }, {
        name: 'onChange',
        enabled: true,
        phase: 'afterWrite',
        fn: data => this._handlePopperPlacementChange(data)
      }],
      onFirstUpdate: data => {
        if (data.options.placement !== data.placement) {
          this._handlePopperPlacementChange(data);
        }
      }
    };
    return { ...defaultBsPopperConfig,
      ...(typeof this._config.popperConfig === 'function' ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig)
    };
  }

  _addAttachmentClass(attachment) {
    this.getTipElement().classList.add(`${this._getBasicClassPrefix()}-${this.updateAttachment(attachment)}`);
  }

  _getAttachment(placement) {
    return AttachmentMap[placement.toUpperCase()];
  }

  _setListeners() {
    const triggers = this._config.trigger.split(' ');

    triggers.forEach(trigger => {
      if (trigger === 'click') {
        EventHandler.on(this._element, this.constructor.Event.CLICK, this._config.selector, event => this.toggle(event));
      } else if (trigger !== TRIGGER_MANUAL) {
        const eventIn = trigger === TRIGGER_HOVER ? this.constructor.Event.MOUSEENTER : this.constructor.Event.FOCUSIN;
        const eventOut = trigger === TRIGGER_HOVER ? this.constructor.Event.MOUSELEAVE : this.constructor.Event.FOCUSOUT;
        EventHandler.on(this._element, eventIn, this._config.selector, event => this._enter(event));
        EventHandler.on(this._element, eventOut, this._config.selector, event => this._leave(event));
      }
    });

    this._hideModalHandler = () => {
      if (this._element) {
        this.hide();
      }
    };

    EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);

    if (this._config.selector) {
      this._config = { ...this._config,
        trigger: 'manual',
        selector: ''
      };
    } else {
      this._fixTitle();
    }
  }

  _fixTitle() {
    const title = this._element.getAttribute('title');

    const originalTitleType = typeof this._element.getAttribute('data-bs-original-title');

    if (title || originalTitleType !== 'string') {
      this._element.setAttribute('data-bs-original-title', title || '');

      if (title && !this._element.getAttribute('aria-label') && !this._element.textContent) {
        this._element.setAttribute('aria-label', title);
      }

      this._element.setAttribute('title', '');
    }
  }

  _enter(event, context) {
    context = this._initializeOnDelegatedTarget(event, context);

    if (event) {
      context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
    }

    if (context.getTipElement().classList.contains(CLASS_NAME_SHOW$2) || context._hoverState === HOVER_STATE_SHOW) {
      context._hoverState = HOVER_STATE_SHOW;
      return;
    }

    clearTimeout(context._timeout);
    context._hoverState = HOVER_STATE_SHOW;

    if (!context._config.delay || !context._config.delay.show) {
      context.show();
      return;
    }

    context._timeout = setTimeout(() => {
      if (context._hoverState === HOVER_STATE_SHOW) {
        context.show();
      }
    }, context._config.delay.show);
  }

  _leave(event, context) {
    context = this._initializeOnDelegatedTarget(event, context);

    if (event) {
      context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
    }

    if (context._isWithActiveTrigger()) {
      return;
    }

    clearTimeout(context._timeout);
    context._hoverState = HOVER_STATE_OUT;

    if (!context._config.delay || !context._config.delay.hide) {
      context.hide();
      return;
    }

    context._timeout = setTimeout(() => {
      if (context._hoverState === HOVER_STATE_OUT) {
        context.hide();
      }
    }, context._config.delay.hide);
  }

  _isWithActiveTrigger() {
    for (const trigger in this._activeTrigger) {
      if (this._activeTrigger[trigger]) {
        return true;
      }
    }

    return false;
  }

  _getConfig(config) {
    const dataAttributes = Manipulator.getDataAttributes(this._element);
    Object.keys(dataAttributes).forEach(dataAttr => {
      if (DISALLOWED_ATTRIBUTES.has(dataAttr)) {
        delete dataAttributes[dataAttr];
      }
    });
    config = { ...this.constructor.Default,
      ...dataAttributes,
      ...(typeof config === 'object' && config ? config : {})
    };
    config.container = config.container === false ? document.body : getElement(config.container);

    if (typeof config.delay === 'number') {
      config.delay = {
        show: config.delay,
        hide: config.delay
      };
    }

    if (typeof config.title === 'number') {
      config.title = config.title.toString();
    }

    if (typeof config.content === 'number') {
      config.content = config.content.toString();
    }

    typeCheckConfig(NAME$4, config, this.constructor.DefaultType);

    if (config.sanitize) {
      config.template = sanitizeHtml(config.template, config.allowList, config.sanitizeFn);
    }

    return config;
  }

  _getDelegateConfig() {
    const config = {};

    for (const key in this._config) {
      if (this.constructor.Default[key] !== this._config[key]) {
        config[key] = this._config[key];
      }
    } // In the future can be replaced with:
    // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
    // `Object.fromEntries(keysWithDifferentValues)`


    return config;
  }

  _cleanTipClass() {
    const tip = this.getTipElement();
    const basicClassPrefixRegex = new RegExp(`(^|\\s)${this._getBasicClassPrefix()}\\S+`, 'g');
    const tabClass = tip.getAttribute('class').match(basicClassPrefixRegex);

    if (tabClass !== null && tabClass.length > 0) {
      tabClass.map(token => token.trim()).forEach(tClass => tip.classList.remove(tClass));
    }
  }

  _getBasicClassPrefix() {
    return CLASS_PREFIX$1;
  }

  _handlePopperPlacementChange(popperData) {
    const {
      state
    } = popperData;

    if (!state) {
      return;
    }

    this.tip = state.elements.popper;

    this._cleanTipClass();

    this._addAttachmentClass(this._getAttachment(state.placement));
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Tooltip.getOrCreateInstance(this, config);

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
      }
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Tooltip to jQuery only if jQuery is present
 */


defineJQueryPlugin(Tooltip);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$3 = 'popover';
const DATA_KEY$3 = 'bs.popover';
const EVENT_KEY$3 = `.${DATA_KEY$3}`;
const CLASS_PREFIX = 'bs-popover';
const Default$2 = { ...Tooltip.Default,
  placement: 'right',
  offset: [0, 8],
  trigger: 'click',
  content: '',
  template: '<div class="popover" role="tooltip">' + '<div class="popover-arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div>' + '</div>'
};
const DefaultType$2 = { ...Tooltip.DefaultType,
  content: '(string|element|function)'
};
const Event$1 = {
  HIDE: `hide${EVENT_KEY$3}`,
  HIDDEN: `hidden${EVENT_KEY$3}`,
  SHOW: `show${EVENT_KEY$3}`,
  SHOWN: `shown${EVENT_KEY$3}`,
  INSERTED: `inserted${EVENT_KEY$3}`,
  CLICK: `click${EVENT_KEY$3}`,
  FOCUSIN: `focusin${EVENT_KEY$3}`,
  FOCUSOUT: `focusout${EVENT_KEY$3}`,
  MOUSEENTER: `mouseenter${EVENT_KEY$3}`,
  MOUSELEAVE: `mouseleave${EVENT_KEY$3}`
};
const SELECTOR_TITLE = '.popover-header';
const SELECTOR_CONTENT = '.popover-body';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Popover extends Tooltip {
  // Getters
  static get Default() {
    return Default$2;
  }

  static get NAME() {
    return NAME$3;
  }

  static get Event() {
    return Event$1;
  }

  static get DefaultType() {
    return DefaultType$2;
  } // Overrides


  isWithContent() {
    return this.getTitle() || this._getContent();
  }

  setContent(tip) {
    this._sanitizeAndSetContent(tip, this.getTitle(), SELECTOR_TITLE);

    this._sanitizeAndSetContent(tip, this._getContent(), SELECTOR_CONTENT);
  } // Private


  _getContent() {
    return this._resolvePossibleFunction(this._config.content);
  }

  _getBasicClassPrefix() {
    return CLASS_PREFIX;
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Popover.getOrCreateInstance(this, config);

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
      }
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Popover to jQuery only if jQuery is present
 */


defineJQueryPlugin(Popover);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$2 = 'scrollspy';
const DATA_KEY$2 = 'bs.scrollspy';
const EVENT_KEY$2 = `.${DATA_KEY$2}`;
const DATA_API_KEY$1 = '.data-api';
const Default$1 = {
  offset: 10,
  method: 'auto',
  target: ''
};
const DefaultType$1 = {
  offset: 'number',
  method: 'string',
  target: '(string|element)'
};
const EVENT_ACTIVATE = `activate${EVENT_KEY$2}`;
const EVENT_SCROLL = `scroll${EVENT_KEY$2}`;
const EVENT_LOAD_DATA_API = `load${EVENT_KEY$2}${DATA_API_KEY$1}`;
const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const CLASS_NAME_ACTIVE$1 = 'active';
const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
const SELECTOR_NAV_LINKS = '.nav-link';
const SELECTOR_NAV_ITEMS = '.nav-item';
const SELECTOR_LIST_ITEMS = '.list-group-item';
const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}, .${CLASS_NAME_DROPDOWN_ITEM}`;
const SELECTOR_DROPDOWN$1 = '.dropdown';
const SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const METHOD_OFFSET = 'offset';
const METHOD_POSITION = 'position';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class ScrollSpy extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._scrollElement = this._element.tagName === 'BODY' ? window : this._element;
    this._config = this._getConfig(config);
    this._offsets = [];
    this._targets = [];
    this._activeTarget = null;
    this._scrollHeight = 0;
    EventHandler.on(this._scrollElement, EVENT_SCROLL, () => this._process());
    this.refresh();

    this._process();
  } // Getters


  static get Default() {
    return Default$1;
  }

  static get NAME() {
    return NAME$2;
  } // Public


  refresh() {
    const autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
    const offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
    const offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
    this._offsets = [];
    this._targets = [];
    this._scrollHeight = this._getScrollHeight();
    const targets = SelectorEngine.find(SELECTOR_LINK_ITEMS, this._config.target);
    targets.map(element => {
      const targetSelector = getSelectorFromElement(element);
      const target = targetSelector ? SelectorEngine.findOne(targetSelector) : null;

      if (target) {
        const targetBCR = target.getBoundingClientRect();

        if (targetBCR.width || targetBCR.height) {
          return [Manipulator[offsetMethod](target).top + offsetBase, targetSelector];
        }
      }

      return null;
    }).filter(item => item).sort((a, b) => a[0] - b[0]).forEach(item => {
      this._offsets.push(item[0]);

      this._targets.push(item[1]);
    });
  }

  dispose() {
    EventHandler.off(this._scrollElement, EVENT_KEY$2);
    super.dispose();
  } // Private


  _getConfig(config) {
    config = { ...Default$1,
      ...Manipulator.getDataAttributes(this._element),
      ...(typeof config === 'object' && config ? config : {})
    };
    config.target = getElement(config.target) || document.documentElement;
    typeCheckConfig(NAME$2, config, DefaultType$1);
    return config;
  }

  _getScrollTop() {
    return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
  }

  _getScrollHeight() {
    return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  }

  _getOffsetHeight() {
    return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
  }

  _process() {
    const scrollTop = this._getScrollTop() + this._config.offset;

    const scrollHeight = this._getScrollHeight();

    const maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

    if (this._scrollHeight !== scrollHeight) {
      this.refresh();
    }

    if (scrollTop >= maxScroll) {
      const target = this._targets[this._targets.length - 1];

      if (this._activeTarget !== target) {
        this._activate(target);
      }

      return;
    }

    if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
      this._activeTarget = null;

      this._clear();

      return;
    }

    for (let i = this._offsets.length; i--;) {
      const isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

      if (isActiveTarget) {
        this._activate(this._targets[i]);
      }
    }
  }

  _activate(target) {
    this._activeTarget = target;

    this._clear();

    const queries = SELECTOR_LINK_ITEMS.split(',').map(selector => `${selector}[data-bs-target="${target}"],${selector}[href="${target}"]`);
    const link = SelectorEngine.findOne(queries.join(','), this._config.target);
    link.classList.add(CLASS_NAME_ACTIVE$1);

    if (link.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
      SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, link.closest(SELECTOR_DROPDOWN$1)).classList.add(CLASS_NAME_ACTIVE$1);
    } else {
      SelectorEngine.parents(link, SELECTOR_NAV_LIST_GROUP$1).forEach(listGroup => {
        // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        SelectorEngine.prev(listGroup, `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`).forEach(item => item.classList.add(CLASS_NAME_ACTIVE$1)); // Handle special case when .nav-link is inside .nav-item

        SelectorEngine.prev(listGroup, SELECTOR_NAV_ITEMS).forEach(navItem => {
          SelectorEngine.children(navItem, SELECTOR_NAV_LINKS).forEach(item => item.classList.add(CLASS_NAME_ACTIVE$1));
        });
      });
    }

    EventHandler.trigger(this._scrollElement, EVENT_ACTIVATE, {
      relatedTarget: target
    });
  }

  _clear() {
    SelectorEngine.find(SELECTOR_LINK_ITEMS, this._config.target).filter(node => node.classList.contains(CLASS_NAME_ACTIVE$1)).forEach(node => node.classList.remove(CLASS_NAME_ACTIVE$1));
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = ScrollSpy.getOrCreateInstance(this, config);

      if (typeof config !== 'string') {
        return;
      }

      if (typeof data[config] === 'undefined') {
        throw new TypeError(`No method named "${config}"`);
      }

      data[config]();
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(window, EVENT_LOAD_DATA_API, () => {
  SelectorEngine.find(SELECTOR_DATA_SPY).forEach(spy => new ScrollSpy(spy));
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .ScrollSpy to jQuery only if jQuery is present
 */

defineJQueryPlugin(ScrollSpy);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME$1 = 'tab';
const DATA_KEY$1 = 'bs.tab';
const EVENT_KEY$1 = `.${DATA_KEY$1}`;
const DATA_API_KEY = '.data-api';
const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
const EVENT_CLICK_DATA_API = `click${EVENT_KEY$1}${DATA_API_KEY}`;
const CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
const CLASS_NAME_ACTIVE = 'active';
const CLASS_NAME_FADE$1 = 'fade';
const CLASS_NAME_SHOW$1 = 'show';
const SELECTOR_DROPDOWN = '.dropdown';
const SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const SELECTOR_ACTIVE = '.active';
const SELECTOR_ACTIVE_UL = ':scope > li > .active';
const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]';
const SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const SELECTOR_DROPDOWN_ACTIVE_CHILD = ':scope > .dropdown-menu .active';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Tab extends BaseComponent {
  // Getters
  static get NAME() {
    return NAME$1;
  } // Public


  show() {
    if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(CLASS_NAME_ACTIVE)) {
      return;
    }

    let previous;
    const target = getElementFromSelector(this._element);

    const listElement = this._element.closest(SELECTOR_NAV_LIST_GROUP);

    if (listElement) {
      const itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
      previous = SelectorEngine.find(itemSelector, listElement);
      previous = previous[previous.length - 1];
    }

    const hideEvent = previous ? EventHandler.trigger(previous, EVENT_HIDE$1, {
      relatedTarget: this._element
    }) : null;
    const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$1, {
      relatedTarget: previous
    });

    if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
      return;
    }

    this._activate(this._element, listElement);

    const complete = () => {
      EventHandler.trigger(previous, EVENT_HIDDEN$1, {
        relatedTarget: this._element
      });
      EventHandler.trigger(this._element, EVENT_SHOWN$1, {
        relatedTarget: previous
      });
    };

    if (target) {
      this._activate(target, target.parentNode, complete);
    } else {
      complete();
    }
  } // Private


  _activate(element, container, callback) {
    const activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? SelectorEngine.find(SELECTOR_ACTIVE_UL, container) : SelectorEngine.children(container, SELECTOR_ACTIVE);
    const active = activeElements[0];
    const isTransitioning = callback && active && active.classList.contains(CLASS_NAME_FADE$1);

    const complete = () => this._transitionComplete(element, active, callback);

    if (active && isTransitioning) {
      active.classList.remove(CLASS_NAME_SHOW$1);

      this._queueCallback(complete, element, true);
    } else {
      complete();
    }
  }

  _transitionComplete(element, active, callback) {
    if (active) {
      active.classList.remove(CLASS_NAME_ACTIVE);
      const dropdownChild = SelectorEngine.findOne(SELECTOR_DROPDOWN_ACTIVE_CHILD, active.parentNode);

      if (dropdownChild) {
        dropdownChild.classList.remove(CLASS_NAME_ACTIVE);
      }

      if (active.getAttribute('role') === 'tab') {
        active.setAttribute('aria-selected', false);
      }
    }

    element.classList.add(CLASS_NAME_ACTIVE);

    if (element.getAttribute('role') === 'tab') {
      element.setAttribute('aria-selected', true);
    }

    reflow(element);

    if (element.classList.contains(CLASS_NAME_FADE$1)) {
      element.classList.add(CLASS_NAME_SHOW$1);
    }

    let parent = element.parentNode;

    if (parent && parent.nodeName === 'LI') {
      parent = parent.parentNode;
    }

    if (parent && parent.classList.contains(CLASS_NAME_DROPDOWN_MENU)) {
      const dropdownElement = element.closest(SELECTOR_DROPDOWN);

      if (dropdownElement) {
        SelectorEngine.find(SELECTOR_DROPDOWN_TOGGLE, dropdownElement).forEach(dropdown => dropdown.classList.add(CLASS_NAME_ACTIVE));
      }

      element.setAttribute('aria-expanded', true);
    }

    if (callback) {
      callback();
    }
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Tab.getOrCreateInstance(this);

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`);
        }

        data[config]();
      }
    });
  }

}
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  if (isDisabled(this)) {
    return;
  }

  const data = Tab.getOrCreateInstance(this);
  data.show();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Tab to jQuery only if jQuery is present
 */

defineJQueryPlugin(Tab);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */
/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'toast';
const DATA_KEY = 'bs.toast';
const EVENT_KEY = `.${DATA_KEY}`;
const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
const EVENT_HIDE = `hide${EVENT_KEY}`;
const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
const EVENT_SHOW = `show${EVENT_KEY}`;
const EVENT_SHOWN = `shown${EVENT_KEY}`;
const CLASS_NAME_FADE = 'fade';
const CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility

const CLASS_NAME_SHOW = 'show';
const CLASS_NAME_SHOWING = 'showing';
const DefaultType = {
  animation: 'boolean',
  autohide: 'boolean',
  delay: 'number'
};
const Default = {
  animation: true,
  autohide: true,
  delay: 5000
};
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Toast extends BaseComponent {
  constructor(element, config) {
    super(element);
    this._config = this._getConfig(config);
    this._timeout = null;
    this._hasMouseInteraction = false;
    this._hasKeyboardInteraction = false;

    this._setListeners();
  } // Getters


  static get DefaultType() {
    return DefaultType;
  }

  static get Default() {
    return Default;
  }

  static get NAME() {
    return NAME;
  } // Public


  show() {
    const showEvent = EventHandler.trigger(this._element, EVENT_SHOW);

    if (showEvent.defaultPrevented) {
      return;
    }

    this._clearTimeout();

    if (this._config.animation) {
      this._element.classList.add(CLASS_NAME_FADE);
    }

    const complete = () => {
      this._element.classList.remove(CLASS_NAME_SHOWING);

      EventHandler.trigger(this._element, EVENT_SHOWN);

      this._maybeScheduleHide();
    };

    this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated


    reflow(this._element);

    this._element.classList.add(CLASS_NAME_SHOW);

    this._element.classList.add(CLASS_NAME_SHOWING);

    this._queueCallback(complete, this._element, this._config.animation);
  }

  hide() {
    if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
      return;
    }

    const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);

    if (hideEvent.defaultPrevented) {
      return;
    }

    const complete = () => {
      this._element.classList.add(CLASS_NAME_HIDE); // @deprecated


      this._element.classList.remove(CLASS_NAME_SHOWING);

      this._element.classList.remove(CLASS_NAME_SHOW);

      EventHandler.trigger(this._element, EVENT_HIDDEN);
    };

    this._element.classList.add(CLASS_NAME_SHOWING);

    this._queueCallback(complete, this._element, this._config.animation);
  }

  dispose() {
    this._clearTimeout();

    if (this._element.classList.contains(CLASS_NAME_SHOW)) {
      this._element.classList.remove(CLASS_NAME_SHOW);
    }

    super.dispose();
  } // Private


  _getConfig(config) {
    config = { ...Default,
      ...Manipulator.getDataAttributes(this._element),
      ...(typeof config === 'object' && config ? config : {})
    };
    typeCheckConfig(NAME, config, this.constructor.DefaultType);
    return config;
  }

  _maybeScheduleHide() {
    if (!this._config.autohide) {
      return;
    }

    if (this._hasMouseInteraction || this._hasKeyboardInteraction) {
      return;
    }

    this._timeout = setTimeout(() => {
      this.hide();
    }, this._config.delay);
  }

  _onInteraction(event, isInteracting) {
    switch (event.type) {
      case 'mouseover':
      case 'mouseout':
        this._hasMouseInteraction = isInteracting;
        break;

      case 'focusin':
      case 'focusout':
        this._hasKeyboardInteraction = isInteracting;
        break;
    }

    if (isInteracting) {
      this._clearTimeout();

      return;
    }

    const nextElement = event.relatedTarget;

    if (this._element === nextElement || this._element.contains(nextElement)) {
      return;
    }

    this._maybeScheduleHide();
  }

  _setListeners() {
    EventHandler.on(this._element, EVENT_MOUSEOVER, event => this._onInteraction(event, true));
    EventHandler.on(this._element, EVENT_MOUSEOUT, event => this._onInteraction(event, false));
    EventHandler.on(this._element, EVENT_FOCUSIN, event => this._onInteraction(event, true));
    EventHandler.on(this._element, EVENT_FOCUSOUT, event => this._onInteraction(event, false));
  }

  _clearTimeout() {
    clearTimeout(this._timeout);
    this._timeout = null;
  } // Static


  static jQueryInterface(config) {
    return this.each(function () {
      const data = Toast.getOrCreateInstance(this, config);

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`);
        }

        data[config](this);
      }
    });
  }

}

enableDismissTrigger(Toast);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Toast to jQuery only if jQuery is present
 */

defineJQueryPlugin(Toast);

/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
(function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
})();
var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

function makeIconMasking (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      explicitMaskId = _ref.maskId,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles$1 = namespace.styles,
    shims = namespace.shims;
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles$1, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles$1;
  reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();

namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
});

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

({
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
});
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
});
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
});

namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

namespace.styles;

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());

    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule(function (module) {
(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();

    acc[prop] = value;

    return acc;
  }, {});
}

function classToObject(cls) {
  return cls.split(/\s+/).reduce(function (acc, c) {
    acc[c] = true;

    return acc;
  }, {});
}

function combineClassObjects() {
  for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }

  return objs.reduce(function (acc, obj) {
    if (Array.isArray(obj)) {
      acc = acc.concat(obj);
    } else {
      acc.push(obj);
    }

    return acc;
  }, []);
}

function convert(h, element) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var children = (element.children || []).map(convert.bind(null, h));

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc['class'] = classToObject(val);
        break;
      case 'style':
        acc['style'] = styleToObject(val);
        break;
      default:
        acc.attrs[key] = val;
    }

    return acc;
  }, { 'class': {}, style: {}, attrs: {} });

  var _data$class = data.class,
      dClass = _data$class === undefined ? {} : _data$class,
      _data$style = data.style,
      dStyle = _data$style === undefined ? {} : _data$style,
      _data$attrs = data.attrs,
      dAttrs = _data$attrs === undefined ? {} : _data$attrs,
      remainingData = objectWithoutProperties(data, ['class', 'style', 'attrs']);


  if (typeof element === 'string') {
    return element;
  } else {
    return h(element.tag, _extends({
      class: combineClassObjects(mixins.class, dClass),
      style: _extends({}, mixins.style, dStyle),
      attrs: _extends({}, mixins.attrs, dAttrs)
    }, remainingData, {
      props: props
    }), children);
  }
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-inverse': props.inverse,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes);

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon$$1) {

  if (icon$$1 === null) {
    return null;
  }

  if ((typeof icon$$1 === 'undefined' ? 'undefined' : _typeof(icon$$1)) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }

  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return { prefix: icon$$1[0], iconName: icon$$1[1] };
  }

  if (typeof icon$$1 === 'string') {
    return { prefix: 'fas', iconName: icon$$1 };
  }
}

var FontAwesomeIcon = {
  name: 'FontAwesomeIcon',

  functional: true,

  props: {
    border: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flip: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['horizontal', 'vertical', 'both'].indexOf(value) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['right', 'left'].indexOf(value) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function validator(value) {
        return [90, 180, 270].indexOf(parseInt(value, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(value) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },

  render: function render(createElement, context) {
    var props = context.props;
    var iconArgs = props.icon,
        maskArgs = props.mask,
        symbol = props.symbol,
        title = props.title;

    var icon$$1 = normalizeIconArgs(iconArgs);
    var classes = objectWithKey('classes', classList(props));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
    var renderedIcon = icon(icon$$1, _extends({}, classes, transform, mask, { symbol: symbol, title: title }));

    if (!renderedIcon) {
      return log('Could not find one or more icon(s)', icon$$1, mask);
    }

    var abstract = renderedIcon.abstract;

    var convertCurry = convert.bind(null, createElement);

    return convertCurry(abstract[0], {}, context.data);
  }
};

/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var faCaretRight = {
  prefix: 'fas',
  iconName: 'caret-right',
  icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"]
};
var faSignOutAlt = {
  prefix: 'fas',
  iconName: 'sign-out-alt',
  icon: [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"]
};
var faUserCircle = {
  prefix: 'fas',
  iconName: 'user-circle',
  icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"]
};

//
/* add icons to the library */

library.add(faUserCircle, faSignOutAlt);
var script$6 = {
  name: "PiwebMenuUsuario",
  components: {
    FontAwesomeIcon
  },
  props: {
    usuario: {
      type: Object,
      default: () => {
        return {
          nomeCompleto: "Nome Sobrenome"
        };
      }
    },
    fnLogout: {
      type: Function,
      default: () => {
        alert("Logout!");
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle mt-2 mt-lg-0 mb-lg-0 py-1 py-lg-3",
    attrs: {
      "href": "#",
      "id": "navbarDropdown",
      "role": "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user-circle",
      "aria-label": "Menu usuário",
      "title": "Menu usuário"
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-end",
    attrs: {
      "aria-labelledby": "navbarDropdown"
    }
  }, [_c('li', [_c('p', {
    staticClass: "dropdown-item-text"
  }, [_vm._v(_vm._s(_vm.usuario.nomeCompleto))])]), _vm._v(" "), _vm._t("after-nome-usuario"), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("before-logout"), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.fnLogout
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sign-out-alt",
      "aria-label": "Sair",
      "title": "Sair"
    }
  }), _vm._v("\n        Sair\n      ")], 1)])], 2)]);
};

var __vue_staticRenderFns__$6 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', [_c('hr', {
    staticClass: "dropdown-divider"
  })]);
}];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-3c7ba905_0", {
    source: ".navbar-nav .dropdown-menu[data-v-3c7ba905]{min-width:20em}.navbar-light .navbar-nav .nav-link[data-v-3c7ba905]:focus,.navbar-light .navbar-nav .nav-link[data-v-3c7ba905]:hover{color:rgba(0,0,0,.7)}.navbar-nav .nav-link[data-v-3c7ba905]:focus,.navbar-nav .nav-link[data-v-3c7ba905]:hover{background-color:#e7e7e7}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-3c7ba905";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

var PiwebMenuUsuario = __vue_component__$a;

//
/* add icons to the library */

library.add(faCaretRight);
var script$5 = {
  name: "PiwebSubmenuItem",
  components: {
    PiwebSubmenuItem,
    FontAwesomeIcon
  },
  props: {
    menu: {
      type: Array,
      require: true
    }
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    staticClass: "dropdown-menu dropdown-submenu-left"
  }, _vm._l(_vm.menu, function (item) {
    return _c('li', {
      key: item.label
    }, [item.subitens ? [_c('a', {
      staticClass: "nav-link"
    }, [_c('span', {
      staticClass: "ms-3"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n          "), _c('font-awesome-icon', {
      staticStyle: {
        "padding-right": "-1em",
        "float": "right"
      },
      attrs: {
        "icon": "caret-right",
        "aria-label": "Abre submenu",
        "title": "Abre submenu"
      }
    })], 1)]), _vm._v(" "), _c('piweb-submenu-item', {
      staticClass: "ms-3",
      attrs: {
        "menu": item.subitens
      }
    })] : item.label ? _c(_vm.linkType, {
      tag: "component",
      staticClass: "nav-link",
      attrs: {
        "aria-current": "page",
        "to": item.link ? item.link : '/#',
        "href": item.link ? item.link : '/#'
      }
    }, [_c('span', {
      staticClass: "ms-3"
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])]) : _c('hr', {
      staticClass: "dropdown-divider"
    })], 2);
  }), 0);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-2fb96516_0", {
    source: ".navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-nav .nav-link:focus,.navbar-nav .nav-link:hover{background-color:#e7e7e7}.dropdown-menu li{position:relative}.dropdown-menu .dropdown-submenu{display:none;position:absolute;left:100%;top:-5px}.dropdown-menu .dropdown-submenu-left{right:100%;left:auto;top:-5px}.dropdown-menu>li:hover>.dropdown-submenu,.dropdown-menu>li:hover>.dropdown-submenu-left{display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var PiwebSubmenuItem = __vue_component__$9;

//
/* add icons to the library */

library.add(faCaretRight);
var script$4 = {
  name: "PiwebMenuItem",
  components: {
    PiwebSubmenuItem,
    FontAwesomeIcon
  },
  props: {
    menu: {
      type: Object,
      default: () => {
        return {
          label: "Teste",
          subitens: {}
        };
      }
    }
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    },

    id() {
      return "navbarDropdown-" + this.menu.label.replace(" ", "_");
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle mt-2 mt-lg-0 mb-lg-0 py-1 py-lg-3",
    attrs: {
      "href": "#",
      "id": _vm.id,
      "role": "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.menu.label) + "\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": _vm.id
    }
  }, _vm._l(_vm.menu.subitens, function (item) {
    return _c('li', {
      key: item.label
    }, [item.subitens ? [_c('a', {
      staticClass: "nav-link"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n          "), _c('font-awesome-icon', {
      staticStyle: {
        "padding-right": "-1em",
        "float": "right"
      },
      attrs: {
        "icon": "caret-right",
        "aria-label": "Abre submenu",
        "title": "Abre submenu"
      }
    })], 1), _vm._v(" "), _c('piweb-submenu-item', {
      attrs: {
        "menu": item.subitens
      }
    })] : item.label ? _c(_vm.linkType, {
      tag: "component",
      staticClass: "nav-link",
      attrs: {
        "aria-current": "page",
        "href": item.link ? item.link : '/#',
        "to": item.link ? item.link : '/#'
      }
    }, [_vm._v(_vm._s(item.label))]) : _c('hr', {
      staticClass: "dropdown-divider"
    })], 2);
  }), 0)]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-a22d6672_0", {
    source: ".navbar-light .navbar-nav .nav-link[data-v-a22d6672]:focus,.navbar-light .navbar-nav .nav-link[data-v-a22d6672]:hover{color:rgba(0,0,0,.7)}.navbar-nav .nav-link[data-v-a22d6672]:focus,.navbar-nav .nav-link[data-v-a22d6672]:hover{background-color:#e7e7e7}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-a22d6672";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var PiwebMenuItem = __vue_component__$8;

//
var script$3 = {
  name: "Topo",
  components: {
    PiwebMenuUsuario,
    PiwebMenuItem
  },
  props: {
    siglaSistema: {
      type: String,
      default: "SIGLA"
    },
    nomeSistema: {
      type: String,
      default: "Nome completo"
    },
    urlHome: {
      type: String,
      default: "/"
    },
    itensMenu: {
      type: Array,
      default: () => []
    },
    usuario: {
      type: Object,
      default: () => {
        return {
          nomeCompleto: "Nome Sobrenome"
        };
      }
    },
    fnLogout: {
      type: Function,
      default: () => {
        alert("Logout!");
      }
    }
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    }

  },
  methods: {
    menuHasSubmenu(menu) {
      return Object.keys(menu).includes("subitens");
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "navbar-brand d-none d-sm-inline-block",
    attrs: {
      "href": _vm.urlHome
    }
  }, [_vm._v(_vm._s(_vm.nomeSistema) + " - "), _c('small', [_vm._v(_vm._s(_vm.siglaSistema))])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand d-inline-block d-sm-none",
    attrs: {
      "href": _vm.urlHome
    }
  }, [_vm._v(_vm._s(_vm.siglaSistema))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse w-100 order-3 collapse2 collapse show",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ms-auto mb-2 mb-lg-0"
  }, [_vm._t("before-items"), _vm._v(" "), _vm._l(_vm.itensMenu, function (item) {
    return _c('li', {
      key: item.label,
      staticClass: "nav-item"
    }, [_vm.menuHasSubmenu(item) ? _c('piweb-menu-item', {
      attrs: {
        "menu": item
      }
    }) : _c(_vm.linkType, {
      tag: "component",
      staticClass: "nav-link mt-2 mt-lg-0 py-1 py-lg-3",
      attrs: {
        "aria-current": "page",
        "href": item.link ? item.link : '/#',
        "to": item.link ? item.link : '/#'
      }
    }, [_vm._v(_vm._s(item.label))])], 1);
  }), _vm._v(" "), _vm._t("after-items"), _vm._v(" "), Object.keys(_vm.usuario).length ? _c('piweb-menu-usuario', {
    attrs: {
      "usuario": _vm.usuario,
      "fnLogout": _vm.fnLogout
    },
    scopedSlots: _vm._u([{
      key: "after-nome-usuario",
      fn: function () {
        return [_vm._t("menu-usuario-after-nome-usuario")];
      },
      proxy: true
    }, {
      key: "before-logout",
      fn: function () {
        return [_vm._t("menu-usuario-before-logout")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e(), _vm._v(" "), _vm._t("after-menu-usuario")], 2)])])]);
};

var __vue_staticRenderFns__$3 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]);
}];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-401335d6_0", {
    source: ".navbar-brand[data-v-401335d6]{font-family:DINPro-Medium,Arial,sans-serif}nav.navbar[data-v-401335d6]{font-family:DINPro-Regular,Arial,sans-serif;background-color:#f8f8f8;border-bottom:1px solid #e7e7e7;color:#666;padding:0}@media (max-width:1000px){nav.navbar[data-v-401335d6]{min-height:10vh!important}}.navbar-nav .dropdown-menu[data-v-401335d6]{width:20em}.navbar-light .navbar-nav .nav-link[data-v-401335d6]:focus,.navbar-light .navbar-nav .nav-link[data-v-401335d6]:hover,.router-link-active[data-v-401335d6],.router-link-exact-active[data-v-401335d6]{color:rgba(0,0,0,.7)}.navbar-nav .nav-link[data-v-401335d6]:focus,.navbar-nav .nav-link[data-v-401335d6]:hover{background-color:#e7e7e7}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-401335d6";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var __vue_component__$7 = __vue_component__$6;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  props: {
    versao: {
      type: String,
      default: "0.0.0"
    }
  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('footer', {
    staticClass: "footer mt-auto"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row d-none d-sm-flex"
  }, [_c('div', {
    staticClass: "col-6 versao"
  }, [_vm._v("Versão: " + _vm._s(_vm.versao))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])]);
};

var __vue_staticRenderFns__$2 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('div', {
    staticClass: "logo"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "row d-sm-none"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('div', {
    staticClass: "logo"
  })])]);
}];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-0ed16698_0", {
    source: ".footer[data-v-0ed16698]{width:100%;line-height:60px;background-color:#fff;color:#000;padding-bottom:6px;font-family:DINPro-Regular,Arial,sans-serif}@media (max-width:1000px){.footer[data-v-0ed16698]{height:10vh!important}}.footer .logo[data-v-0ed16698]{height:50px;width:160px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%22761.945%22 height%3D%22266.197%22 overflow%3D%22visible%22%3E%3Cpath fill%3D%22%23F2F1F2%22 d%3D%22M105.84 254.857c-10.311-.128-20.121-2.313-30.745-6.864l-.317 2.219c-.047.372-.283.69-.619.854-.153.088-.33.127-.496.127-.2 0-.395-.053-.565-.154l-5.414-3.073c-7.693-4.159-14.046-8.948-21.219-15.983-5.884-6.346-10.582-12.914-14.816-20.678-3.025-6.001-5.459-12.234-7.818-18.273-1.299-3.313-2.646-6.748-4.062-10.101-1.286-2.772-2.383-4.791-3.676-6.682-1.583-1.927-2.747-3.197-4.45-4.975a1.145 1.145 0 01-.112-1.442c.213-.304.569-.464.927-.464.159 0 .317.021.465.092 6.867 3.068 11.52 5.489 16.631 9.577.29-1.819.521-3.665.743-5.466.162-1.342.322-2.683.519-4.024.06-.43.377-.802.796-.928.11-.025.225-.058.326-.058.32 0 .628.151.85.402 3.883 4.396 6.096 8.456 7.916 14.488l.076.269c2.077 7.386 4.045 14.354 7.869 21.116 4.916 7.871 11.296 14.507 21.323 22.135l1.674 1.198c.321-.6.637-1.198.957-1.805a1.15 1.15 0 01.682-.545.872.872 0 01.32-.051c.195 0 .379.051.545.141 11.129 6.135 20.815 9.1 31.424 9.594h.55c11.309 0 22.109-3.05 33.99-9.594.175-.09.357-.141.555-.141.107 0 .208.01.323.051.285.088.529.273.673.535.326.613.646 1.211.974 1.803 7.13-5.238 12.406-9.91 17.022-15.053 6.203-7.506 9.989-15.156 13.039-26.381 1.512-5.574 3.058-10.563 6.611-15.255l2.201-2.506c.224-.251.539-.402.854-.402.108 0 .216.032.322.058.428.126.733.498.797.928.2 1.357.374 2.722.541 4.086.213 1.775.442 3.585.736 5.377 5.979-4.808 11.643-7.968 16.875-9.419a1.09 1.09 0 01.294-.039c.396 0 .769.214.981.556a1.132 1.132 0 01-.172 1.373c-3.58 3.652-5.95 6.56-8.212 11.482-1.423 3.349-2.751 6.833-4.053 10.216-1.19 3.109-2.42 6.312-3.726 9.446-5.139 11.649-11.126 20.961-18.876 29.318-6.268 6.142-13.004 11.221-21.238 16.022l-5.478 2.842a1.153 1.153 0 01-.517.121c-.158 0-.318-.025-.469-.089a1.145 1.145 0 01-.633-.759l-.539-2.056c-11.147 4.663-21.406 6.843-32.187 6.843l-.972-.009z%22%2F%3E%3Cpath fill%3D%22%23FFF%22 d%3D%22M106.814 266.197c9.863 0 19.271-1.56 29.064-4.881 1.515.625 3.112.953 4.756.953 1.99 0 3.97-.487 5.742-1.408l5.485-2.839a9.88 9.88 0 00.486-.277c9.057-5.265 16.521-10.907 23.467-17.713.13-.127.252-.26.375-.389 8.625-9.309 15.278-19.619 20.934-32.451.028-.073.056-.136.083-.211 1.349-3.218 2.585-6.459 3.86-9.75 1.232-3.225 2.502-6.546 3.833-9.686 1.574-3.381 3.117-5.255 5.918-8.119 3.972-4.031 4.725-10.244 1.867-15.058%22%2F%3E%3Cpath fill%3D%22%23FFF%22 d%3D%22M212.684 164.369a12.517 12.517 0 00-10.751-6.153c-1.088 0-2.188.154-3.32.455a45.56 45.56 0 00-7.044 2.625 12.392 12.392 0 00-5.657-3.542 12.304 12.304 0 00-5.9-.283l.004-72.365c0-2.513-.741-4.925-2.132-6.981a15.251 15.251 0 002.069-3.551c1.604-3.855 1.505-8.011-.139-11.678a12.462 12.462 0 005.271-4.725l1.502-.98a12.594 12.594 0 004.073-4.405l7.146-12.992c3.245-5.909 1.11-13.458-4.751-16.809l-5.09-2.919a11.943 11.943 0 00-2.137-.95 11.89 11.89 0 00-2.282-1.341l-7.985-3.636a13.062 13.062 0 00-2.498-.833 11.988 11.988 0 00-2.368-1.204l-7.221-2.742a15.741 15.741 0 00-1.201-.388 12.718 12.718 0 00-2.096-.795l-11.836-3.33a11.717 11.717 0 00-1.699-.339 12.944 12.944 0 00-1.512-.408l-7.884-1.566a12.844 12.844 0 00-4.657-.052A12.495 12.495 0 00127.203.85c-9.198-.611-9.198-.611-9.601-.611-.136 0-.272.007-.407.007a12.903 12.903 0 00-3.812-.178l-13.255.101c-.605 0-1.191.047-1.784.141-.422-.044-.855-.07-1.284-.07-.438 0-.438 0-9.161.629a12.406 12.406 0 00-5.33 1.628 12.803 12.803 0 00-2.732-.299c-.788 0-1.579.079-2.486.25l-7.754 1.58c-.43.085-.852.202-1.27.336-.771.082-1.517.238-2.221.447L54.567 8.259c-.55.168-1.091.375-1.609.605a13.16 13.16 0 00-1.672.507l-7.736 2.926a12.279 12.279 0 00-3.182 1.785 12.546 12.546 0 00-3.158 1.012l-6.866 3.257c-.703.327-1.354.72-1.964 1.155-.638.233-1.272.51-1.87.855l-5.009 2.79c-6.003 3.356-8.162 10.967-4.812 16.957l5.285 9.488c.623 1.253 1.293 2.399 1.893 3.417a38 38 0 01.731 1.277 12.524 12.524 0 006.741 5.663l.527.574c.663.691 1.39 1.308 2.182 1.832-1.562 3.608-1.712 7.891-.224 11.95.107.289.224.563.345.833a16.223 16.223 0 002.21 3.565 12.484 12.484 0 00-1.776 6.39l-.007 72.426a12.852 12.852 0 00-2.658-.284 12.61 12.61 0 00-3.577.521 12.394 12.394 0 00-5.757 3.696 169.188 169.188 0 00-5.109-2.373 12.424 12.424 0 00-5.038-1.065 12.49 12.49 0 00-10.189 5.292c-3.425 4.857-2.927 11.507 1.187 15.804 1.401 1.456 2.333 2.472 3.537 3.911.794 1.216 1.535 2.601 2.41 4.497 1.346 3.17 2.63 6.457 3.874 9.645 2.451 6.277 4.986 12.766 8.256 19.24.054.102.11.216.165.321 4.704 8.625 9.935 15.912 16.461 22.95.124.133.245.255.376.39 7.932 7.786 15.017 13.12 23.648 17.81l5.368 3.046a12.496 12.496 0 0011.083.568c9.095 3.066 17.87 4.594 27.139 4.706%22%2F%3E%3Cpath fill%3D%22%23F2F1F2%22 d%3D%22M63.731 83.747l.7-.351 2.71-1.312 1.358-.638 2.06-.895 2.767-1.123 2.119-.803 1.425-.499 2.164-.713 2.169-.653.754-.2 2.31-.545 3.079-.651 1.557-.285 1.538-.266 3.105-.454 2.342-.28.785-.075 2.334-.212 3.153-.209 1.579-.063 2.366-.066 1.827.007 1.844.059 1.855.103 1.886.155.953.096 2.862.332 2.872.424 1.938.331 1.903.354 1.905.375 3.763.833 1.86.447 1.827.466 2.667.703.581.179 2.385.771 2.333.833 1.708.654 1.715.68 2.239.961 1.136.506 2.202 1.023H63.731zm123.704-50.929l-5.064-2.893a1.142 1.142 0 00-.564-.146c-.105 0-.215.021-.318.049a1.108 1.108 0 00-.685.576l-1.418 2.79-1.187-.624 1.229-3.029a1.134 1.134 0 00-.573-1.455l-7.982-3.626a1.115 1.115 0 00-.462-.099 1.13 1.13 0 00-.413.072 1.15 1.15 0 00-.635.604l-6.03 13.952a1.313 1.313 0 00-.089.457l.004 1.695-.426-.188a1.038 1.038 0 00-.87-.017.906.906 0 00-.3.171 1.127 1.127 0 00-.656-.983l-.9-.416 1.154-.965c.132-.115.245-.27.313-.438l5.752-14.123a1.085 1.085 0 00-.012-.879 1.083 1.083 0 00-.625-.609l-7.178-2.722a1.204 1.204 0 00-.405-.07c-.454 0-.87.26-1.048.705l-.857 2.121.699-2.211a1.107 1.107 0 00-.089-.882 1.086 1.086 0 00-.687-.545l-11.821-3.326a1.322 1.322 0 00-.307-.041c-.197 0-.399.052-.575.159a1.166 1.166 0 00-.527.714l-.662 2.684.592-2.707a1.133 1.133 0 00-.885-1.353l-7.944-1.578c-.068-.009-.141-.019-.218-.019-.217 0-.44.061-.635.189a1.133 1.133 0 00-.478.725l-2.841 14.91c-.031.148-.018.308.007.456l.332 1.45-1.883-.324a.845.845 0 00-.206-.022c-.51 0-.975.354-1.093.884l-.651 2.807-.191-.031.46-2.853a1.13 1.13 0 00-.211-.853 1.157 1.157 0 00-.752-.449l-1.374-.193.12-.142c.146-.168.229-.368.247-.592l1.882-16.169a1.14 1.14 0 00-1.054-1.262s-8.811-.585-8.843-.585a1.11 1.11 0 00-.753.292 1.143 1.143 0 00-.371.806l-.09 2.881-.518-.033-.021-2.615.021-.106a1.1 1.1 0 00-.129-.826 1.347 1.347 0 00-.341-.408 1.155 1.155 0 00-.971-.197l-.108.026-14.133.11c-.308 0-.595.125-.806.346-.219.229-.33.522-.32.833l.134 2.935-.828.038-.179-3.014a1.201 1.201 0 00-.382-.792 1.184 1.184 0 00-.755-.277c-.023 0-8.351.597-8.351.597a1.172 1.172 0 00-.796.406 1.114 1.114 0 00-.251.844l1.672 15.963c.013.195.085.381.195.536l.37.529-1.948.294a1.142 1.142 0 00-.954 1.272l.373 2.735-.277.032-.442-2.965a1.114 1.114 0 00-.457-.76 1.106 1.106 0 00-.661-.216c-.076 0-.134.014-.197.016l-1.775.309.195-.751c.041-.162.047-.324.021-.492l-2.808-15.458a1.19 1.19 0 00-.487-.741 1.083 1.083 0 00-.628-.19c-.076 0-.155.007-.235.023l-7.75 1.578a1.178 1.178 0 00-.718.489c-.176.26-.223.574-.157.864l.673 3.029-.13.023-.75-3.052a1.153 1.153 0 00-.537-.711 1.123 1.123 0 00-.559-.153c-.118 0-.226.02-.327.042L57.8 19.123c-.285.09-.529.29-.671.553-.146.26-.178.576-.089.861l.873 2.912-.063.026-1.091-2.847a1.137 1.137 0 00-1.063-.723c-.127 0-.268.021-.4.07l-7.719 2.921c-.285.108-.51.317-.635.602a1.154 1.154 0 00-.025.866l5.776 14.772c.061.16.171.318.301.438l.366.315c-.515.263-.75.874-.534 1.418l1.139 2.885-.307.148-1.481-2.897a1.127 1.127 0 00-1.004-.618 1.1 1.1 0 00-.487.113c-.02-.059-.045-.113-.069-.175l-.597-1.241-3.008-6.364-.172-.386-1.358-2.857a64.365 64.365 0 00-1.263-2.702l-.642-1.336a1.133 1.133 0 00-.64-.585 1.295 1.295 0 00-.388-.066 1.18 1.18 0 00-.48.108l-6.876 3.258a1.145 1.145 0 00-.542 1.503l1.211 2.626-1.021.547-1.237-2.523a1.137 1.137 0 00-1.016-.628c-.189 0-.382.04-.55.139l-5.014 2.799a1.124 1.124 0 00-.431 1.535l5.482 9.845c.023.042.04.087.059.13.442.891.979 1.795 1.51 2.714.289.489.572.98.849 1.475.157.271.415.468.722.541l2.192.525 2.729 2.952c.219.233.525.365.836.365.133 0 .275-.026.411-.076l1.627-.642 1.378 1.035 4.876 10.148-3.824 2.044a.886.886 0 00-.166.11c-1.284 1.009-1.387 3.067-.802 4.662.438.957 1.216 2.227 2.942 2.227.316 0 .63-.045.943-.094l1.458 2.477c.927 1.54 1.849 3.1 2.758 4.637-.701.798-1.104 1.762-1.149 2.794a4.6 4.6 0 00.251 1.505l-4.603.007a1.14 1.14 0 00-1.138 1.136l-.016 92.313c.021 33.582 31.87 54.375 61.373 54.375 15.153 0 30.44-5.382 41.932-14.76 12.547-10.232 19.451-24.305 19.446-39.615l.012-92.313c0-.299-.122-.593-.334-.809a1.137 1.137 0 00-.794-.327h-4.782c.064-.322.107-.682.085-1.105-.207-1.583-.943-2.096-1.676-2.536 1.434-2.507 2.866-5.014 4.299-7.526.005.015.009.015.021.015.159.047.332.068.503.068 1.292 0 2.888-1.228 3.487-2.672.572-1.376.246-2.831-1.032-4.089l-.766-.563c-.529-.345-1.059-.676-1.595-1.013-.731-.457-1.432-.889-2.116-1.355l5.861-10.515 1.3-.527 3.115.595a1.133 1.133 0 001.203-.55l1.124-1.988 3.766-2.486c.16-.106.29-.237.384-.402l7.131-12.965a1.14 1.14 0 00-.43-1.539%22%2F%3E%3Cpath fill%3D%22%23020304%22 d%3D%22M105.84 254.857c-10.311-.128-20.121-2.313-30.745-6.864l-.317 2.219c-.047.372-.283.69-.619.854-.153.088-.33.127-.496.127-.2 0-.395-.053-.565-.154l-5.414-3.073c-7.693-4.159-14.046-8.948-21.219-15.983-5.884-6.346-10.582-12.914-14.816-20.678-3.025-6.001-5.459-12.234-7.818-18.273-1.299-3.313-2.646-6.748-4.062-10.101-1.286-2.772-2.383-4.791-3.676-6.682-1.583-1.927-2.747-3.197-4.45-4.975a1.145 1.145 0 01-.112-1.442c.213-.304.569-.464.927-.464.159 0 .317.021.465.092 6.867 3.068 11.52 5.489 16.631 9.577.29-1.819.521-3.665.743-5.466.162-1.342.322-2.683.519-4.024.06-.43.377-.802.796-.928.11-.025.225-.058.326-.058.32 0 .628.151.85.402 3.883 4.396 6.096 8.456 7.916 14.488l.076.269c2.077 7.386 4.045 14.354 7.869 21.116 4.916 7.871 11.296 14.507 21.323 22.135l1.674 1.198c.321-.6.637-1.198.957-1.805a1.15 1.15 0 01.682-.545.872.872 0 01.32-.051c.195 0 .379.051.545.141 11.129 6.135 20.815 9.1 31.424 9.594h.55c11.309 0 22.109-3.05 33.99-9.594.175-.09.357-.141.555-.141.107 0 .208.01.323.051.285.088.529.273.673.535.326.613.646 1.211.974 1.803 7.13-5.238 12.406-9.91 17.022-15.053 6.203-7.506 9.989-15.156 13.039-26.381 1.512-5.574 3.058-10.563 6.611-15.255l2.201-2.506c.224-.251.539-.402.854-.402.108 0 .216.032.322.058.428.126.733.498.797.928.2 1.357.374 2.722.541 4.086.213 1.775.442 3.585.736 5.377 5.979-4.808 11.643-7.968 16.875-9.419a1.09 1.09 0 01.294-.039c.396 0 .769.214.981.556a1.132 1.132 0 01-.172 1.373c-3.58 3.652-5.95 6.56-8.212 11.482-1.423 3.349-2.751 6.833-4.053 10.216-1.19 3.109-2.42 6.312-3.726 9.446-5.139 11.649-11.126 20.961-18.876 29.318-6.268 6.142-13.004 11.221-21.238 16.022l-5.478 2.842a1.153 1.153 0 01-.517.121c-.158 0-.318-.025-.469-.089a1.145 1.145 0 01-.633-.759l-.539-2.056c-11.147 4.663-21.406 6.843-32.187 6.843l-.972-.009z%22%2F%3E%3Cpath fill%3D%22%23EC2427%22 d%3D%22M139.361 228.435c-21.004 11.551-42.391 12.226-64.505-.025l-7.545 13.776c24.698 13.663 51.54 15.074 79.633.094l-7.583-13.845z%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M63.731 83.747l.7-.351 2.71-1.312 1.358-.638 2.06-.895 2.767-1.123 2.119-.803 1.425-.499 2.164-.713 2.169-.653.754-.2 2.31-.545 3.079-.651 1.557-.285 1.538-.266 3.105-.454 2.342-.28.785-.075 2.334-.212 3.153-.209 1.579-.063 2.366-.066 1.827.007 1.844.059 1.855.103 1.886.155.953.096 2.862.332 2.872.424 1.938.331 1.903.354 1.905.375 3.763.833 1.86.447 1.827.466 2.667.703.581.179 2.385.771 2.333.833 1.708.654 1.715.68 2.239.961 1.136.506 2.202 1.023H63.731zm123.704-50.929l-5.064-2.893a1.142 1.142 0 00-.564-.146c-.105 0-.215.021-.318.049a1.108 1.108 0 00-.685.576l-1.418 2.79-1.187-.624 1.229-3.029a1.134 1.134 0 00-.573-1.455l-7.982-3.626a1.115 1.115 0 00-.462-.099 1.13 1.13 0 00-.413.072 1.15 1.15 0 00-.635.604l-6.03 13.952a1.313 1.313 0 00-.089.457l.004 1.695-.426-.188a1.038 1.038 0 00-.87-.017.906.906 0 00-.3.171 1.127 1.127 0 00-.656-.983l-.9-.416 1.154-.965c.132-.115.245-.27.313-.438l5.752-14.123a1.085 1.085 0 00-.012-.879 1.083 1.083 0 00-.625-.609l-7.178-2.722a1.204 1.204 0 00-.405-.07c-.454 0-.87.26-1.048.705l-.857 2.121.699-2.211a1.107 1.107 0 00-.089-.882 1.086 1.086 0 00-.687-.545l-11.821-3.326a1.322 1.322 0 00-.307-.041c-.197 0-.399.052-.575.159a1.166 1.166 0 00-.527.714l-.662 2.684.592-2.707a1.133 1.133 0 00-.885-1.353l-7.944-1.578c-.068-.009-.141-.019-.218-.019-.217 0-.44.061-.635.189a1.133 1.133 0 00-.478.725l-2.841 14.91c-.031.148-.018.308.007.456l.332 1.45-1.883-.324a.845.845 0 00-.206-.022c-.51 0-.975.354-1.093.884l-.651 2.807-.191-.031.46-2.853a1.13 1.13 0 00-.211-.853 1.157 1.157 0 00-.752-.449l-1.374-.193.12-.142c.146-.168.229-.368.247-.592l1.882-16.169a1.14 1.14 0 00-1.054-1.262s-8.811-.585-8.843-.585a1.11 1.11 0 00-.753.292 1.143 1.143 0 00-.371.806l-.09 2.881-.518-.033-.021-2.615.021-.106a1.1 1.1 0 00-.129-.826 1.347 1.347 0 00-.341-.408 1.155 1.155 0 00-.971-.197l-.108.026-14.133.11c-.308 0-.595.125-.806.346-.219.229-.33.522-.32.833l.134 2.935-.828.038-.179-3.014a1.201 1.201 0 00-.382-.792 1.184 1.184 0 00-.755-.277c-.023 0-8.351.597-8.351.597a1.172 1.172 0 00-.796.406 1.114 1.114 0 00-.251.844l1.672 15.963c.013.195.085.381.195.536l.37.529-1.948.294a1.142 1.142 0 00-.954 1.272l.373 2.735-.277.032-.442-2.965a1.114 1.114 0 00-.457-.76 1.106 1.106 0 00-.661-.216c-.076 0-.134.014-.197.016l-1.775.309.195-.751c.041-.162.047-.324.021-.492l-2.808-15.458a1.19 1.19 0 00-.487-.741 1.083 1.083 0 00-.628-.19c-.076 0-.155.007-.235.023l-7.75 1.578a1.178 1.178 0 00-.718.489c-.176.26-.223.574-.157.864l.673 3.029-.13.023-.75-3.052a1.153 1.153 0 00-.537-.711 1.123 1.123 0 00-.559-.153c-.118 0-.226.02-.327.042L57.8 19.123c-.285.09-.529.29-.671.553-.146.26-.178.576-.089.861l.873 2.912-.063.026-1.091-2.847a1.137 1.137 0 00-1.063-.723c-.127 0-.268.021-.4.07l-7.719 2.921c-.285.108-.51.317-.635.602a1.154 1.154 0 00-.025.866l5.776 14.772c.061.16.171.318.301.438l.366.315c-.515.263-.75.874-.534 1.418l1.139 2.885-.307.148-1.481-2.897a1.127 1.127 0 00-1.004-.618 1.1 1.1 0 00-.487.113c-.02-.059-.045-.113-.069-.175l-.597-1.241-3.008-6.364-.172-.386-1.358-2.857a64.365 64.365 0 00-1.263-2.702l-.642-1.336a1.133 1.133 0 00-.64-.585 1.295 1.295 0 00-.388-.066 1.18 1.18 0 00-.48.108l-6.876 3.258a1.145 1.145 0 00-.542 1.503l1.211 2.626-1.021.547-1.237-2.523a1.137 1.137 0 00-1.016-.628c-.189 0-.382.04-.55.139l-5.014 2.799a1.124 1.124 0 00-.431 1.535l5.482 9.845c.023.042.04.087.059.13.442.891.979 1.795 1.51 2.714.289.489.572.98.849 1.475.157.271.415.468.722.541l2.192.525 2.729 2.952c.219.233.525.365.836.365.133 0 .275-.026.411-.076l1.627-.642 1.378 1.035 4.876 10.148-3.824 2.044a.886.886 0 00-.166.11c-1.284 1.009-1.387 3.067-.802 4.662.438.957 1.216 2.227 2.942 2.227.316 0 .63-.045.943-.094l1.458 2.477c.927 1.54 1.849 3.1 2.758 4.637-.701.798-1.104 1.762-1.149 2.794a4.6 4.6 0 00.251 1.505l-4.603.007a1.14 1.14 0 00-1.138 1.136l-.016 92.313c.021 33.582 31.87 54.375 61.373 54.375 15.153 0 30.44-5.382 41.932-14.76 12.547-10.232 19.451-24.305 19.446-39.615l.012-92.313c0-.299-.122-.593-.334-.809a1.137 1.137 0 00-.794-.327h-4.782c.064-.322.107-.682.085-1.105-.207-1.583-.943-2.096-1.676-2.536 1.434-2.507 2.866-5.014 4.299-7.526.005.015.009.015.021.015.159.047.332.068.503.068 1.292 0 2.888-1.228 3.487-2.672.572-1.376.246-2.831-1.032-4.089l-.766-.563c-.529-.345-1.059-.676-1.595-1.013-.731-.457-1.432-.889-2.116-1.355l5.861-10.515 1.3-.527 3.115.595a1.133 1.133 0 001.203-.55l1.124-1.988 3.766-2.486c.16-.106.29-.237.384-.402l7.131-12.965a1.14 1.14 0 00-.43-1.539%22%2F%3E%3Cpath fill%3D%22%23FFF%22 d%3D%22M106.044 42.361l.042 1.573.083 5.094 3.528-.012.07-11.341-.176-.341-.209-.235-.139-.141-.257-.167-.308-.148-.277-.076-.149-.021h-.79l-.24.041-.451.157-.214.096-.332.229-.188.221-.073.217zM140.167 47.049l-.33 1.536-1.117 4.978 3.434.815 2.731-11.012-.09-.371-.146-.283-.106-.159-.201-.231-.262-.207-.259-.143-.141-.048-.768-.186-.247-.028-.466.047-.241.049-.381.139-.224.175-.126.193zM71.043 47.549l.449 1.497 1.388 4.912 3.419-.926-2.861-10.979-.254-.284-.269-.172-.166-.094-.288-.103-.338-.065h-.297l-.137.027-.776.2-.223.091-.388.281-.19.147-.265.299-.126.27-.011.224z%22%2F%3E%3Cpath fill%3D%22%23EC2427%22 d%3D%22M71.524 247.893c-47.357-24.118-43.435-66.921-57.479-76.219 5.525 3.641 6.362 1.765 16.731 10.815 1.245-5.955 1.099-7.435 1.665-11.132 12.412 13.063 1.057 32.446 39.242 59.114-2.067 3.854-4.139 7.706-6.206 11.556.296.165.47.294.771.445 1.427 1.928 3.326 3.706 5.276 5.421M142.359 248.102c47.814-24.077 43.818-67.103 57.911-76.418-5.525 3.633-6.364 1.752-16.744 10.806-1.248-5.955-1.109-7.435-1.649-11.132-12.429 13.063-1.064 32.453-39.265 59.135 2.096 3.853 4.194 7.713 6.306 11.578l-1.188.63c-1.589 1.947-3.6 3.608-5.371 5.401%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M65.462 241.998c2.287 1.094 5.264 2.813 8.272 4.104l-.397 3.335c-1.974-2.334-6.805-5.992-7.875-7.439M148.918 242.023c-2.462 1.183-5.468 2.219-8.833 3.819l.908 3.393c2.038-2.359 6.567-5.489 7.925-7.212%22%2F%3E%3Cpath fill%3D%22%23FED406%22 d%3D%22M154.955 78.221l4.163 1.923.018-.042.042-.079.047-.081.044-.067.045-.078.04-.081.038-.075.042-.078.049-.07.042-.085.056-.078.036-.072.054-.078.049-.077.047-.069.042-.079.054-.069.064-.122.08-.105.031-.081.054-.074.044-.076.042-.078.052-.075.035-.063.038-.085.029-.029-4.239-2.22-1.138 2.343zM53.3 77.505l1.148 1.95 3.827-1.787-.99-2.136-3.985 1.973zm92.261-3.266l.087.03.283.101.287.114.292.108.292.108.272.11.282.123.296.104.285.113.277.116.278.12.299.11.262.113.296.118.277.12.271.13.31.112.263.116.292.124.275.121.28.119.277.13.285.122.269.118.287.125.275.129.273.117.285.137.27.127.273.122.274.13.092.032 1.158-2.375-.094-.047-.285-.144-.276-.141-.276-.137-.283-.14-.282-.127-.279-.144-.287-.132-.283-.141-.28-.122-.283-.137-.29-.134-.27-.136-.296-.13-.28-.132-.29-.124-.281-.132-.292-.129-.29-.126-.292-.13-.285-.112-.294-.127-.282-.122-.294-.125-.287-.115-.296-.121-.283-.115-.286-.124-.285-.121-.303-.12-.289-.109-.081-.032-1.02 2.684zm-78.516-2.91l-.296.118-.298.106-.296.122-.307.121-.296.124-.303.111-.298.122-.308.11-.294.127-.294.12-.296.123-.301.131-.292.121-.301.115-.297.146-.303.116-.287.135-.306.125-.282.132-.303.131-.301.136-.286.123-.298.128-.287.125-.296.15-.294.134-.299.126-.282.134-.296.144-.294.137-.097.034 1.007 2.15.099-.052.296-.119.284-.135.296-.11.29-.144.29-.13.294-.124.296-.123.285-.126.298-.127.294-.123.292-.128.292-.116.299-.124.296-.13.301-.11.276-.12.313-.127.308-.115.282-.127.301-.11.298-.116.29-.119.301-.13.301-.105.29-.108.301-.113.307-.111.301-.115.292-.104.305-.11.085-.031-.956-2.338-.116.043zm-7.531-.912l-.268.128-.264.125-.276.13-.26.125-.268.137-.263.133-.271.132-.26.132-.278.137-.258.131-.271.13-.254.136-.27.131-.262.136-.272.13-.262.144-.277.133-.249.137-.264.141-.258.142-.273.136-.258.144-.254.142-.271.128-.27.148-.251.136-.269.142-.263.144-.256.141-.336.176 1.356 2.253 7.969-3.831-1.244-2.559-.075.03zm91.523 2.081l.134.047 3.342 1.548 3.321 1.679 2.927 1.571.408-.727.705-1.223.299-.566-2.936-1.701-3.317-1.786-3.346-1.66-.183-.089-1.354 2.907zM49.585 71.217l.039.087.057.094.052.093.052.071.054.104.051.09.169.28.049.088.059.089.074.134.075.15.053.083.054.099.047.084.061.096.065.085.045.099.056.101.054.083.101.186.047.094.067.082.047.094.059.097 4.17-2.227-1.317-2.498-4.34 2.162zm108.635.379l1.43.783 2.961 1.7.626-1.096.66-1.122.349-.604-3.446-1.771-1.298-.643-1.282 2.753zm-22.137-.563l.072.014.294.09.285.081.29.087.29.086.273.083.301.089.27.085.309.096.272.094.285.091.287.092.294.092.277.101.28.092.298.099.285.094.278.094.276.101.283.097.285.094.283.105.286.097.283.112.29.099.278.099.285.105.281.09.273.121.278.101.284.097.074.025 1.008-2.705-.084-.036-.283-.113-.278-.103-.286-.11-.28-.112-.296-.107-.283-.104-.287-.105-.282-.113-.292-.103-.279-.104-.292-.114-.283-.097-.292-.092-.285-.112-.281-.097-.297-.112-.294-.094-.279-.097-.294-.094-.287-.103-.289-.087-.285-.092-.289-.099-.296-.092-.285-.101-.299-.084-.292-.092-.294-.085-.282-.09-.302-.087-.091-.027-.869 2.86zM78.01 67.722l-.336.091-.346.092-.332.099-.338.089-.325.101-.335.104-.338.099-.325.094-.346.106-.32.102-.331.104-.332.103-.332.106-.336.105-.338.114-.317.099-.339.107-.325.124-.326.097-.336.11-.33.114-.321.117-.33.113-.323.114-.324.112-.339.12-.33.127-.32.11-.333.125-.325.119-.12.041.957 2.356.132-.054.322-.112.322-.108.308-.116.33-.11.32-.115.321-.107.313-.115.323-.094.332-.11.319-.11.313-.104.332-.099.326-.108.313-.099.317-.099.328-.113.324-.089.327-.096.328-.104.326-.097.334-.094.316-.096.321-.087.332-.11.323-.079.326-.089.323-.101.336-.083.319-.099.325-.081.113-.032-.725-2.538-.128.034zm25.419-.26l-.827.042-.848.049-.817.042-.826.063-.824.062-.819.063-.828.085-.811.068-.812.085-.824.097-.811.089-.797.101-.812.108-.81.105-.804.13-.816.113-.8.136-.79.128-.81.142-.806.148-.797.141-.792.153-.814.174-.788.155-.819.179-.797.178-.807.182-.797.19-.809.191-.793.209-.82.202-.8.2-.738.229-.746.228-.745.233-.741.229-.722.242-.739.245-.748.25-.727.251-.725.245-.736.265-.729.26-.718.268-.728.264-.725.272-.727.278-.725.29-.729.272-.709.283-.72.296-.712.292-.713.298-.713.294-.721.31-.711.299-.705.306-.711.315-.708.315-.708.322-.705.318-.703.319-.704.325-.703.334-.146.086-.147.095-.132.107-.12.124-.108.123-.106.133-.068.13-.085.144-.061.15-.063.157-.041.161-.033.162-.034.173-.015.159v.35l.015.173.027.166.026.167.054.175.049.168.056.158.056.157.09.154.068.14.094.141.097.137.101.108.118.116.11.108.13.092.086.052h2.597l.585-.334.659-.379.649-.359.656-.355.647-.372.654-.341.646-.357.675-.339.653-.348.659-.33.665-.343.661-.319.685-.316.665-.317.682-.316.678-.303.677-.31.671-.296.679-.282.706-.292.663-.282.704-.272.689-.275.701-.254.687-.269.708-.256.689-.247.71-.24.704-.227.709-.24.705-.217.718-.216.779-.217.783-.218.783-.207.77-.198.79-.193.776-.184.78-.175.798-.169.774-.162.783-.161.795-.148.79-.144.774-.133.799-.129.786-.126.79-.116.794-.108.801-.112.776-.094.797-.09.801-.087.788-.087.8-.077.79-.071.806-.07.795-.059.81-.057.802-.046.807-.044.79-.042.819-.033.804-.043.94-.004h.949l.957.019.953.017.957.031.962.056.961.052.979.079.962.069.974.089.979.108.983.108.972.112.966.13.979.139.974.15.976.135.969.162.981.171.959.174.964.182.974.18.95.198.958.195.95.21.958.209.931.211.938.222.924.227.938.231.918.242.902.231.743.216.729.202.731.217.732.223.708.238.716.229.704.245.708.249.705.258.702.251.696.256.691.275.68.278.687.282.693.264.673.301.68.287.685.296.677.308.679.301.668.309.678.314.665.318.673.305.67.334.675.317.665.338.677.325.668.331.663.346.678.334.633.323h3.306l.04-.052.106-.127.116-.117.092-.094.094-.105.075-.085.092-.076.068-.083.071-.087.052-.081.056-.094.049-.094.038-.122.027-.127.038-.155.02-.158-.02-.224-.056-.205-.05-.188-.103-.174-.114-.167-.129-.148-.141-.129-.15-.125-.153-.11-.179-.094-.141-.087-.15-.081-.134-.081-.11-.063-.104-.069-.07-.051-.682-.337-.702-.333-.71-.354-.727-.331-.716-.332-.709-.336-.712-.313-.723-.327-.72-.328-.708-.308-.725-.314-.718-.309-.722-.31-.721-.301-.729-.303-.72-.297-.733-.291-.727-.283-.719-.285-.741-.287-.725-.272-.736-.271-.743-.268-.729-.273-.751-.261-.739-.26-.736-.251-.752-.253-.752-.243-.756-.242-.745-.245-.767-.235-.997-.263-1.009-.278-1.008-.263-1.019-.254-1.002-.235-1.001-.247-1.014-.216-.983-.222-1.004-.207-1.009-.202-1.008-.184-1.005-.184-.997-.162-1.019-.167-.997-.155-1.019-.142-1.002-.131-1-.125-1.019-.108-1.01-.117-1.017-.092-1.032-.09-1.017-.078-1.012-.07-1.032-.052-1.028-.069-1.028-.032-1.039-.036-1.037-.023-1.035-.013-1.05-.007-1.026.005zm38.815 1.524l2.231.808 3.351 1.315 2.41 1.043 1.373-2.921-2.401-1.086-3.418-1.406-2.573-.974-.973 3.221zm-15.862-.375l.083.021.291.057.287.056.296.058.304.058.289.07.289.056.283.069.299.061.294.074.28.067.303.061.278.076.305.065.283.09.298.063.29.078.292.063.294.081.301.077.268.071.304.08.274.08.29.083.303.074.29.087.287.07.285.078.28.087.289.072.282.083.083.023.87-2.862-.094-.026-.294-.093-.292-.078-.296-.08-.292-.094-.306-.068-.304-.087-.299-.083-.285-.081-.301-.078-.296-.075-.305-.083-.306-.085-.294-.068-.287-.073-.316-.086-.303-.071-.287-.074-.313-.069-.294-.067-.298-.076-.303-.063-.292-.068-.301-.066-.318-.063-.294-.061-.294-.074-.317-.056-.294-.063-.312-.061-.296-.062-.099-.011-.562 2.916zm-55.209-2.957l-.357.125-.365.126-.357.13-.359.137-.348.139-.372.129-.353.127-.353.146-.363.139-.364.134-.357.129-.356.148-.357.137-.357.141-.358.146-.353.132-.353.14-.364.156-.344.148-.363.141-.343.15-.364.144-.345.145-.358.168-.346.148-.357.148-.341.153-.35.164-.344.163-.353.155-.148.065 1.262 2.592.144-.059.346-.15.338-.148.339-.141.351-.142.341-.146.343-.139.341-.141.353-.136.339-.141.338-.137.354-.141.346-.132.346-.135.346-.127.346-.137.357-.129.341-.127.355-.129.343-.129.353-.13.344-.122.351-.121.348-.132.357-.129.351-.129.348-.115.356-.125.348-.11.348-.132.35-.115.153-.049-1.017-2.933-.157.063zm17.987-.438l-.346.062-.332.061-.333.067-.339.069-.343.054-.354.061-.322.078-.336.054-.343.068-.332.073-.346.068-.329.069-.337.076-.334.068-.343.066-.32.077-.343.066-.334.08-.331.069-.341.083-.341.076-.323.078-.343.08-.33.087-.333.08-.336.075-.334.097-.327.089-.341.081-.331.09-.118.027.741 2.554.125-.031.332-.086.322-.078.325-.085.329-.083.327-.074.332-.075.327-.083.319-.074.334-.072.336-.08.315-.068.343-.074.32-.061.331-.075.332-.069.328-.065.327-.068.343-.064.319-.068.332-.069.334-.059.319-.061.341-.068.336-.066.334-.05.314-.061.341-.061.323-.056.346-.067.325-.054.113-.019-.537-2.679-.133.02zm-24.97-.761l-.32.119-.314.137-.318.134-.321.132-.312.126-.312.13-.316.146-.317.122-.323.132-.319.132-.303.14-.309.144-.312.132-.31.139-.318.146-.303.141-.334.132-.31.143-.306.144-.304.144-.314.146-.308.141-.32.141-.308.144-.306.142-.318.152-.308.155-.296.134-.316.15-.308.157-.107.042 1.302 2.484.123-.049.292-.148.294-.148.296-.148.299-.146.298-.146.303-.148.29-.144.298-.139.294-.148.296-.137.316-.15.301-.148.29-.127.305-.144.308-.138.302-.141.301-.134.313-.142.292-.128.31-.137.304-.134.301-.13.308-.133.303-.13.303-.136.313-.122.308-.125.296-.12.308-.123.315-.129.106-.04-.979-2.524-.119.033zm84.215 2.426l.105.045.302.127.308.124.294.137.287.123.314.129.301.137.292.132.304.124.286.134.311.146.294.139.303.127.29.148.303.138.282.139.299.141.301.141.285.146.296.132.292.152.299.151.296.148.285.139.29.152.296.153.294.141.276.148.305.155.276.155.283.15.092.052 1.284-2.725-.12-.045-.292-.15-.296-.134-.296-.148-.297-.141-.301-.141-.31-.148-.287-.144-.31-.148-.301-.144-.296-.133-.301-.148-.302-.146-.308-.139-.299-.137-.308-.139-.307-.134-.306-.141-.301-.131-.303-.148-.305-.132-.296-.13-.323-.14-.287-.123-.322-.13-.304-.138-.308-.118-.292-.128-.314-.127-.311-.115-.315-.139-.096-.031-1.011 2.61zm-33.983.045l.146.02.364.04.372.025.357.042.37.04.362.025.355.049.36.033.374.045.358.045.364.036.364.051.351.047.355.049.369.047.358.044.362.052.35.057.368.054.348.052.374.054.354.047.357.067.357.054.357.069.365.047.353.065.365.059.355.058.355.064.37.068.141.029.562-2.933-.141-.017-.375-.08-.375-.054-.372-.067-.371-.065-.37-.061-.372-.061-.357-.058-.379-.063-.369-.061-.368-.054-.375-.056-.372-.047-.375-.054-.358-.058-.376-.049-.364-.052-.369-.042-.379-.048-.368-.042-.377-.042-.363-.033-.368-.063-.375-.031-.37-.033-.38-.043-.381-.026-.362-.05-.37-.031-.379-.037-.371-.034-.161-.009-.23 2.92zm-12.324-3.097l-.391.014-.384.022-.397.031-.385.025-.391.019-.393.031-.386.029-.386.032-.388.033-.391.035-.393.03-.388.038-.388.044-.386.029-.386.037-.402.038-.379.049-.384.04-.387.045-.396.033-.382.054-.388.037-.386.064-.393.045-.391.049-.379.054-.393.047-.391.056-.375.049-.391.059-.309.052.553 2.69.174-.018.377-.062.377-.042.377-.059.379-.037.371-.047.386-.049.381-.047.376-.047.379-.04.378-.045.379-.031.381-.038.369-.048.384-.033.376-.042.381-.029.382-.027.372-.041.388-.031.369-.025.376-.038.391-.018.375-.029.386-.031.38-.021.379-.025.383-.026.379-.024.388-.027h.374l.17-.016-.13-2.823-.181.006zm5.273-.108h-2.048l-.341.007-.343.007-.339.014-.343.008-.353.011-.341.009h-.125l.132 2.83.123-.004.326-.018.332-.004.336-.014.343-.014h.334l.332-.012h1.689l.334.012h.336l.336.009.338.005.332.014.336.013.339.014.343.002.337.018.338.018.326.016.339.021.336.017.332.023.332.017.324.025.346.026.341.028.323.033.11.007.222-2.926-.271-.011-.357-.012-.338-.026-.332-.009-.348-.023-.339-.008-.334-.014-.346-.014-.339-.02-.353-.009-.341-.009-.341-.009-.339-.011-.343-.008-.333-.007-.343-.014h-.341l-.343-.007h-.333zm24.564 2.184l.108.033.315.081.306.068.316.094.301.076.314.083.321.081.298.081.313.092.313.075.318.096.317.087.302.075.324.094.313.094.301.078.317.099.313.087.303.097.308.084.32.099.305.099.313.094.301.099.309.085.31.11.303.099.311.099.296.108.314.104.303.105.085.038.985-3.223-.04-.02-.308-.11-.301-.094-.314-.113-.308-.083-.31-.113-.313-.096-.308-.094-.294-.104-.313-.101-.311-.099-.31-.085-.317-.099-.315-.099-.296-.097-.296-.094-.323-.094-.308-.092-.315-.091-.303-.094-.307-.087-.315-.09-.308-.094-.309-.08-.314-.084-.316-.099-.31-.083-.306-.092-.32-.079-.319-.078-.303-.085-.322-.092-.085-.023-.739 3.367zm-50.179-3.384l-.334.089-.306.078-.33.073-.317.101-.31.078-.327.081-.313.094-.317.084-.325.087-.315.092-.315.081-.324.093-.308.099-.318.078-.322.101-.318.092-.315.087-.316.101-.314.085-.309.101-.319.092-.31.096-.318.091-.303.109-.323.096-.326.097-.311.101-.308.105-.323.097-.306.099-.099.037 1.002 2.929.097-.028.314-.083.292-.099.318-.085.291-.094.311-.09.294-.091.313-.085.301-.092.307-.087.303-.083.301-.081.303-.099.308-.087.292-.075.311-.092.303-.078.308-.087.296-.083.312-.083.312-.083.299-.082.306-.078.307-.087.301-.07.312-.083.301-.07.31-.078.3-.087.314-.079.313-.062.101-.03-.656-3.168-.098.015zm56.9.789l.083.025.308.101.296.083.307.103.305.092.272.096.292.099.313.09.294.101.29.112.292.09.294.103.294.108.294.099.296.105.287.116.292.096.298.126.294.105.294.104.279.114.304.108.288.117.29.107.292.122.282.112.294.116.283.12.289.105.279.123.294.112.083.031 1.01-2.602-.099-.035-.304-.121-.296-.115-.303-.108-.287-.115-.317-.123-.289-.115-.299-.121-.298-.103-.312-.117-.296-.118-.294-.106-.308-.115-.29-.105-.303-.119-.313-.105-.287-.108-.303-.11-.302-.101-.308-.109-.303-.113-.296-.099-.303-.104-.306-.11-.302-.101-.308-.101-.298-.116-.311-.099-.287-.106-.314-.092-.303-.11-.092-.016-.731 2.697zm-18.102.432l.13.026.341.028.344.047.353.053.338.037.339.057.346.057.343.047.348.052.348.049.343.061.35.047.339.065.35.056.346.06.348.065.346.063.343.071.339.07.355.061.347.071.342.068.347.078.331.08.341.076.343.065.332.083.355.079.33.081.336.081.327.094.115.023.748-3.36-.22-.045-.352-.083-.35-.083-.339-.075-.362-.069-.343-.08-.359-.08-.341-.068-.353-.081-.356-.07-.339-.076-.364-.07-.344-.071-.35-.065-.341-.065-.37-.076-.341-.068-.346-.062-.357-.063-.357-.063-.341-.061-.348-.058-.358-.059-.359-.063-.353-.049-.343-.059-.358-.058-.357-.046-.339-.045-.366-.044-.348-.054-.139-.006-.39 3.424zM75.69 60.325l-.353.122-.35.106-.353.118-.348.105-.363.122-.343.111-.348.115-.357.112-.334.121-.364.122-.351.121-.346.117-.348.132-.344.117-.348.121-.348.124-.359.125-.332.136-.35.127-.353.13-.334.128-.348.121-.348.128-.336.135-.356.136-.346.13-.339.136-.357.13-.341.136-.346.137-.14.054.969 2.523.134-.056.341-.127.348-.129.339-.129.324-.132.356-.122.333-.135.336-.124.332-.12.35-.131.33-.116.343-.122.346-.112.343-.138.332-.116.343-.113.339-.127.334-.101.346-.112.341-.12.35-.123.346-.11.348-.106.336-.116.346-.106.339-.108.345-.108.344-.109.348-.101.348-.106.35-.099.134-.042-.769-2.718-.141.036zm18.477-.073l-.38.042-.377.049-.383.061-.381.042-.376.064-.384.057-.365.049-.384.063-.372.054-.384.057-.384.069-.38.061-.363.063-.386.071-.367.07-.388.077-.365.055-.384.08-.377.069-.375.075-.375.073-.374.072-.368.069-.391.088-.371.083-.372.068-.378.087-.363.071-.386.092-.373.08-.161.042.646 3.17.157-.031.364-.065.377-.083.362-.08.358-.077.364-.071.37-.07.371-.07.375-.074.366-.068.358-.076.369-.072.37-.064.366-.061.375-.063.364-.063.365-.067.369-.065.372-.061.369-.049.375-.074.355-.054.379-.054.366-.054.379-.049.355-.049.384-.054.374-.042.362-.057.381-.036.366-.049.168-.016-.388-3.323-.176.018zm14.228-.821l-.062 3.431.175.011.361.004.365.002.369.014.377.004.367.022.362.014.37.019.369.007.37.02.366.019.376.017.371.025.365.028.359.021.37.026.374.023.37.033.364.023.367.029.374.032.358.031.377.038.354.025.371.047.363.033.377.029.368.042.355.038.379.049.369.036.146.021.386-3.434-.16-.021-.372-.049-.388-.031-.369-.05-.386-.035-.381-.042-.384-.036-.364-.033-.386-.038-.374-.025-.378-.04-.377-.019-.374-.044-.388-.02-.371-.03-.379-.012-.379-.029-.378-.031-.379-.016-.376-.031-.378-.021-.379-.014-.377-.002-.381-.026-.38-.019-.384-.011-.388-.013h-.365l-.387-.019-.388-.004-.37-.02h-.162zm-2.245-.014h-.796l-.402.011-.401.002-.399.02-.395.011-.407.012-.402.004-.388.027-.408.018-.397.022-.399.025-.404.021-.388.023-.411.031-.393.04-.415.016-.397.038-.391.034-.399.036-.397.04-.395.031-.397.049-.398.037-.406.042-.396.049-.388.05-.188.02.39 3.33.168-.006.383-.049.38-.047.39-.028.384-.042.388-.031.388-.035.369-.04.383-.031.391-.027.393-.024.381-.03.391-.028.388-.025.379-.017.393-.028.369-.017.395-.019.386-.021.386-.014.39-.007.388-.014.388-.004.381-.015H105l.383-.019h2.098l.041-3.422H106.946l-.402-.007-.394.008zm21.737 1.16l.113.032.332.069.319.056.334.073.327.066.313.068.332.076.33.079.326.067.318.074.333.071.339.075.307.085.339.085.328.072.316.09.331.085.316.07.317.097.33.081.325.085.329.093.318.081.325.092.317.089.325.084.322.097.309.087.333.104.315.094.319.087.108.028.737-2.712-.137-.049-.323-.105-.319-.092-.328-.106-.334-.096-.326-.097-.313-.096-.332-.099-.321-.099-.332-.087-.332-.099-.332-.077-.329-.099-.325-.085-.33-.092-.333-.087-.316-.088-.341-.08-.339-.087-.324-.09-.33-.077-.332-.076-.334-.081-.336-.087-.333-.069-.328-.08-.327-.076-.333-.087-.33-.072-.334-.076-.332-.075-.12-.024-.547 2.91zM56.33 58.122l-1.35.611-2.675 1.284-1.34.638-.983.491 1.196 2.461 1.367-.654 1.773-.83 1.764-.776 1.726-.788 1.501-.615-1.809-2.332-1.17.51zm98.522 1.791l.225.083.246.09.225.103.238.101.247.104.238.085.249.094.233.108.232.096.235.097.24.105.238.099.238.099.233.099.241.108.24.101.24.116.229.094.242.105.223.108.25.094.229.108.235.101.235.105.243.111.472.2.471.211.282.132 1.418-2.529-.007-.014-.233-.104-.226-.087-.218-.105-.235-.094-.207-.096-.229-.092-.233-.11-.22-.094-.224-.101-.232-.09-.247-.105-.415-.19-.238-.09-.216-.092-.457-.19-.223-.092-.233-.101-.449-.195-.227-.084-.225-.099-.224-.094-.225-.092-.233-.099-.219-.092-.218-.085-.237-.105-.229-.094-.063-.027-1.725 2.385zm-67.314-2.608l-.357.087-.37.08-.346.064-.369.086-.36.073-.353.075-.366.087-.365.087-.353.08-.353.082-.37.083-.366.08-.348.084-.354.096-.357.083-.371.094-.358.087-.348.087-.366.097-.346.101-.361.088-.35.087-.353.113-.37.094-.348.096-.348.101-.362.107-.351.105-.356.101-.355.104-.162.042.786 2.716.134-.023.354-.103.344-.107.353-.086.343-.099.346-.087.346-.092.348-.096.361-.083.346-.097.35-.082.355-.085.346-.09.35-.072.341-.085.367-.085.341-.085.362-.072.348-.063.357-.085.356-.081.348-.063.341-.075.359-.083.353-.071.358-.073.357-.061.346-.062.357-.082.353-.064.36-.063.134-.023-.567-3.002-.141.033zm-28.517-.36l-.701.299 1.082 1.403-.186-1.798-.195.096zm95.746 1.606l.99-1.363-.844-.339-.146 1.702zm8.424.838l.651.296 1.508-2.726-.936-.417-1.223 2.847zm-112.38-2.728l-1.407.646-1.019.508 1.225 2.549.985-.489 1.349-.635.438-.211-1.223-2.541-.348.173zm64.794 2.215l.179.014.369.038.37.038.364.034.386.03.364.045.384.028.367.045.367.042.37.038.373.049.363.045.373.042.37.047.371.051.37.05.377.042.359.056.367.056.38.054.365.054.371.06.37.059.371.054.377.056.365.065.366.064.368.063.361.068.364.062.37.068.167.031.549-2.95-.161-.034-.377-.083-.379-.08-.383-.08-.377-.073-.38-.07-.375-.069-.372-.077-.397-.068-.373-.076-.398-.054-.378-.073-.39-.063-.377-.061-.393-.056-.375-.063-.399-.054-.384-.063-.385-.042-.379-.05-.397-.056-.383-.042-.388-.056-.386-.04-.381-.045-.382-.038-.391-.037-.396-.042-.373-.038-.393-.023-.37-.033-.164-.016-.151 3.157zm-14.208-3.368l-.431.036-.404.038-.433.021-.421.04-.42.036-.435.027-.421.042-.416.038-.424.042-.423.042-.428.045-.431.035-.411.052-.431.047-.426.049-.435.047-.42.059-.426.051-.411.061-.429.063-.426.054-.416.056-.423.071-.418.063-.419.074-.431.068-.406.076-.419.077-.404.073-.416.079-.206.052.567 2.994.188-.037.4-.069.406-.067.408-.067.4-.065.399-.063.414-.061.403-.06.418-.056.406-.054.41-.054.404-.051.421-.047.414-.056.402-.038.412-.051.42-.043.408-.035.413-.052.4-.035.419-.036.414-.04.412-.036.416-.025.399-.036.41-.023.418-.028.402-.036.417-.023.399-.029.409-.021.188-.007-.162-3.213-.194.006zm5.245-.193l-.399.007H105.44l-.407.006-.402.011-.4.016-.408.015-.389.007-.394.027-.395.026-.178.009.153 3.22h.173l.39-.026.393-.012.396-.022.382-.007.397-.014.391-.016.403-.02h.781l.393-.011.395-.007h1.181l.404.007.386.011h.399l.388.007.393.013.39.016.395.014.395.013.397.021.395.021.393.013.393.034.393.02.379.028.402.029.39.023.16.02.141-3.162-.19-.009-.402-.031-.381-.03-.402-.024-.404-.021-.397-.029-.409-.025-.401-.022-.402-.021-.404-.019-.402-.017-.408-.027-.407-.007-.395-.015-.399-.009-.421-.018h-.4l-.406-.006h-.408l-.397-.007h-.411zm-51.666-.576l-1.393.616-1.38.646-.251.127 1.214 2.519 1.477-.691 1.331-.623.99-.435-1.754-2.268-.234.109zm102.131 2.072l.101.038.362.153.182.075.184.078.16.075.186.076.188.065.18.08.179.076.181.083.169.067.195.077.167.071.181.082.177.073.19.08.178.076.174.072.186.081.171.08.186.07.17.083.185.072.193.069.174.079.169.08.188.076.184.079.155.052 1.203-2.817-.111-.042-.142-.061-.183-.078-.294-.123-.32-.14-.153-.062-.155-.063-.17-.061-.146-.066-.16-.075-.173-.063-.141-.055-.168-.061-.167-.068-.15-.061-.155-.062-.166-.065-.16-.073-.15-.057-.162-.065-.161-.07-.153-.06-.162-.061-.15-.065-.162-.063-.156-.066-.16-.07-.162-.066-1.806 2.521zM56.352 54.125l-.327.157 1.742 2.253.325-.133-1.019-2.587-.721.31zm99.743 2.277l.188.065 1.802-2.498-.833-.332-1.157 2.765zm-98.224-2.93l1.02 2.585.24-.107-.284-2.89-.976.412zm85.385 2.192l.153.041.332.123.332.11.355.11.332.121.33.108.343.117.335.119.338.11.332.115.343.111.339.135.339.109.325.122.35.118.327.122.335.112.33.134.339.121.35.133.323.118.331.129.334.125.341.122.332.13.327.134.333.126.334.13.33.119.336.137.33.137.333.123.01.011.265-2.966-.512-.184-.313-.124-.33-.115-.321-.132-.325-.123-.332-.12-.321-.123-.32-.122-.326-.119-.323-.109-.334-.128-.319-.125-.339-.11-.325-.123-.317-.11-.339-.122-.323-.118-.324-.115-.323-.115-.334-.106-.319-.117-.334-.115-.339-.116-.323-.108-.335-.106-.323-.108-.323-.113-.337-.11-.334-.097-.334-.104-.103-.047-.714 2.718zm11.737.298l.292.113 1.152-2.745-1.185-.452-.259 3.084zm-85.384-3.137l-1.324.451-1.308.485-1.326.487-1.327.507-1.322.525-1.331.543-1.329.545-.301.119.301 3.009.95-.395 1.732-.689 1.703-.654 1.714-.638 1.695-.628 1.712-.56 1.409-.494-.781-2.921-.867.308zm89.826.743l.026.007.202.087.216.077.215.104.204.076.217.083.209.086.2.087.2.074.229.105.2.075.22.092.215.092.202.087.213.075.207.094.204.076.212.094.202.086.229.083.202.094.202.076.211.094.211.09.203.09.216.083.198.094.222.092.211.082.202.087.205.096.036.012 1.27-2.292-.172-.081-.195-.089-.207-.092-.197-.079-.202-.092-.198-.087-.195-.087-.409-.178-.381-.172-.186-.085-.211-.084-.395-.17-.188-.089-.205-.084-.21-.085-.198-.087-.388-.167-.204-.094-.205-.08-.184-.075-.209-.089-.2-.092-.188-.076-.207-.094-.442-.187-1.635 2.257zM51.937 51.609l-1.418.678-1.425.674-1.414.708-1.028.534 1.364 2.836 1.024-.509 1.407-.653 1.396-.666 1.378-.637 1.387-.628.056-.018-2.049-2.646-.678.327zm51.88-.976l-.833.04-.833.028-.828.044-.824.047-.824.056-.832.052-.828.062-.828.068-.814.08-.835.084-.808.076-.826.097-.821.099-.82.105-.821.11-.807.108-.828.123-.802.132-.814.129-.813.139-.814.148-.813.148-.821.155-.81.167-.815.167-.817.179-.792.183-.81.184-.82.205-.807.19-.804.21-.381.105-.667.2-.46.135-.464.138-.472.139-.458.148-.457.134-.456.13-.451.144-.466.144-.451.138-.458.144-.455.144-.444.146-.458.148-.449.148-.449.142-.464.146-.44.167-.458.139-.447.153-.457.163-.447.141-.446.163-.458.146-.44.167-.459.156-.454.167-.451.162-.456.17-.453.162-.456.174-.447.176-.55.205-.556.235-.55.226-.541.223-.543.229-.545.229-.532.234-.539.23-.545.238-.543.238-.532.238-.527.232-.543.242-.524.25-.539.235-.521.249-.543.24-.516.259-.527.256-.524.256-.529.256-.534.257-.514.254-.539.261-.509.261-.527.271-.526.263-.522.271-.518.274-.526.269-.522.274-.5.267-.031.03-.025.024-.033.045-.033.045-.048.057-.021.056-.038.069-.027.059-.029.07-.029.083-.023.07-.014.087-.029.081-.014.092-.009.086-.026.092-.011.094v.195l-.019.094v.198l.019.097v.104l.004.096.014.099.02.087.021.101.002.09.038.101.027.074.022.083.063.139.078.146.072.13.076.112.072.099.071.103.077.075.087.074.076.065.065.06.068.035.081.044.083.031.077.023.074.026.082.012.089.018.085.004h.173l.099-.018.09-.004.101-.019.09-.02.116-.019.108-.02.099-.027.105-.026.121-.039.105-.018.113-.03.096-.015.431-.232.447-.22.456-.235.454-.218.464-.237.451-.211.447-.231.454-.222.459-.223.465-.216.455-.219.463-.227.46-.211.453-.216.46-.217.458-.205.462-.229.456-.213.464-.202.456-.214.46-.217.473-.202.456-.202.464-.214.456-.201.471-.207.47-.197.466-.216.454-.198.478-.204.46-.206.469-.198.331-.133.349-.125.338-.13.33-.128.336-.137.346-.124.332-.123.33-.141.338-.122.335-.123.341-.134.33-.122.341-.13.336-.126.332-.123.339-.119.333-.125.346-.119.339-.127.334-.122.334-.111.344-.128.341-.118.334-.122.343-.123.343-.12.334-.11.348-.123.334-.113.335-.121.354-.108.328-.124.983-.292.972-.276.969-.27.981-.278.979-.265.983-.249.974-.251.979-.24.976-.223.988-.226.979-.214.99-.204.985-.212 1.005-.188.979-.177 1.003-.184.985-.169.994-.153.987-.156 1.006-.148 1-.124 1.004-.132 1.004-.115 1.001-.101 1.012-.094 1.008-.094 1.003-.074 1.006-.065 1.012-.063 1.019-.059 1.011-.04 1.012-.024 3.535.013.572.03.568.022.563.042.559.035.567.031.555.038.565.051.559.035.55.052.565.049.55.047.56.054.555.055.557.054.541.059.561.063.552.073.552.065.567.068.541.076.555.072.563.081.548.076.548.084.55.089.563.085.555.092.548.101.556.085.562.093.561.116.555.096.47.101.468.104.456.112.466.114.465.104.466.117.46.108.455.121.47.115.444.11.464.118.46.128.462.119.454.124.458.116.458.129.459.127.444.134.461.126.455.129.465.134.445.124.456.146.45.134.465.137.449.136.453.141.46.141.451.148.447.137.464.152.458.139.765.275.769.294.753.279.759.292.76.294.757.29.763.31.75.292.745.309.753.299.759.324.741.32.748.31.758.323.734.322.743.327.736.334.745.334.736.341.741.331.739.344.729.346.733.343.739.355.725.35.734.357.733.365.716.364.738.353.725.37.721.376.678.337.054.015.076-.015.099-.007.105-.018.097-.033.125-.047.12-.042.115-.068.111-.063.128-.085.12-.077.115-.092.11-.099.106-.105.106-.115.089-.129.097-.12.084-.123.066-.138.065-.132.047-.155.038-.137.012-.148.011-.157-.011-.159-.012-.16-.038-.171-.063-.161-.073-.168-.097-.184-.126-.184-.125-.162-.021-.014-.067-.056-.119-.071-.127-.084-.151-.102-.171-.108-.186-.119-.198-.135-.388-.253-.289-.186-.24-.165-.247-.167-.276-.162-.251-.171-.256-.177-.254-.158-.251-.163-.25-.173-.24-.157-.233-.148-.216-.15-.21-.135-.198-.134-.176-.119-.167-.116-.141-.092-.12-.099-.085-.057-.082-.067-.049-.042-.506-.229-.552-.245-.546-.25-.567-.238-.539-.242-.555-.249-.563-.249-.562-.223-.543-.235-.567-.245-.562-.231-.541-.227-.57-.233-.559-.217-.567-.232-.555-.227-.565-.218-.557-.224-.569-.221-.555-.215-.579-.204-.563-.222-.57-.205-.577-.213-.554-.202-.57-.198-.568-.209-.577-.195-.569-.193-.571-.197-.57-.198-.585-.193-1.178-.376-.431-.13-.452-.124-.444-.139-.438-.123-.433-.126-.435-.125-.434-.12-.435-.127-.445-.115-.428-.125-.426-.124-.44-.116-.438-.12-.425-.125-.44-.11-.426-.115-.44-.118-.444-.12-.431-.115-.435-.107-.442-.099-.438-.131-.438-.094-.451-.11-.442-.114-.438-.101-.465-.103-.44-.099-.457-.101-.456-.115-.465-.094-.45-.089-.754-.137-.755-.137-.762-.128-.734-.121-.763-.124-.743-.114-.746-.104-.743-.101-.736-.099-.741-.096-.743-.082-.731-.087-.751-.081-.736-.068-.743-.073-.727-.061-.75-.068-.736-.049-.74-.044-.743-.054-.741-.033-.731-.042-.749-.036-.743-.025-.746-.031-.754-.016-.742-.012-.75-.026-.757-.007-.76-.007h-1.732v-.02l-.61.022zm42.866 2.3l.911.317 2.491.857 1.232.451 1.268.48 1.246.477.31.127.273-3.083-.807-.305-1.35-.476-1.284-.47-1.29-.44-1.302-.453-.835-.263-.863 2.781zM65.935 50.28l-1.362.489-1.347.53-1.374.532-1.369.548-.799.339.272 2.87.038-.011 1.353-.565 1.338-.534 1.331-.521 1.329-.516 1.333-.494.781-.278-.957-2.597-.567.208zm100.019 2.18l.489.222 1.021.456 1.045-1.867 1.408-.581-.425-.224-.612-.322-.613-.294-.922-.451-1.391 3.061zm-21.783-.353l.941.296.745.253.868-2.772-.913-.3-.898-.284-.743 2.807zm-97.188-2.709l-1.228.608-1.197.626-.597.314 1.776 1.351.536 1.12 1.016-.527 1.435-.708.045-.016-1.501-2.911-.285.143zm82.567 2.624l.825.184 1.708.376 1.724.411 1.723.438 1.307.343.287-1.304.339-1.455-1.306-.343-1.747-.448-1.759-.418-1.726-.409-.816-.175-.559 2.8zm25.784-.042l1.213.461 1.343.519.712.29 1.653-2.283-1.178-.489-1.394-.549-1.383-.541-.735-.286-.231 2.878zm-86.701-2.669l-1.322.458.965 2.604 1.061-.371.917-.313-.719-2.671-.902.293zm-11.069-.177l-1.42.585-1.395.61-1.317.582 2.046 2.656.523-.237 1.407-.595 1.351-.579-.346-3.38-.849.358zm67.482 2.049l.263.042 1.677.305 1.692.316h.025l.561-2.809h-.069l-1.708-.348-.923-.171-1.518 2.665zm27.746-.141l1.107.4.586.224.235-2.876-.972-.369-.956 2.621zm-65.623-2.833l-1.739.332-1.738.351-1.745.388-1.744.397-1.737.449-1.329.372.011.061.407 1.651.309 1.301.369-.094 1.656-.433 1.672-.395 1.649-.377 1.681-.339 1.656-.319 1.656-.292.79-.139-1.497-2.971-.327.057zm37.447 1.986l1.051-1.842-1.362-.229.311 2.071zm-75.158-1.992l-1.407.685 1.505 2.902.579-.294 1.437-.66.516-.251-2.049-2.644-.581.262zm10.913-.223l-1.115.458.332 3.369.566-.224 1.376-.566.078-.01-1.115-3.066-.122.039zm28.554-.069l-.543.094 1.068 2.091.397-2.333-.922.148zm72.662 2.679l2.019.864 1.418.595.136.059 1.4-3.074-.792-.379-1.275-.566-.825-.359-2.081 2.86zm-42.891-.303l.044.014 1.627.175 1.625.223 1.67.249.195.02-.456-3.001-.99-.155-1.691-.24-1.65-.211-.08-.019-.294 2.945zm-24.529-3.103l-1.749.203-1.665.23-.581 3.33 1.349-.202 1.649-.213 1.667-.188 1.324-.13-.308-3.196-1.686.166zm41.705 2.524l.492.117 1.295.351.229-.953.429-1.854-1.41-.364-.32-.085-.715 2.788zm-24.629.034l1.113.054 1.573.08 1.596.114 1.604.131.711.076.301-2.949-.718-.076-1.656-.164-1.661-.148-1.62-.099-1.23-.087-.013 3.068zm-8.211-3.162l-1.783.049-.902.049-.871.041-.889.067-.877.071-.985.087.298 3.189 1.143-.094 1.669-.103 1.663-.087 1.677-.054 1.245-.049-.036-1.326-.018-1.68v-.19l-1.334.03zm-25.412 0l-1.407.388.108.482.41 1.535.178.68 1.338-.375.527-.131-.68-2.698-.474.119zm-24.816.117l-.011-.012-.849.384-1.102.5 2.04 2.644.087-.042 1.43-.629.653-.29-1.194-3.067-1.054.512zm105.699 2.623l.89.357 1.383.57 2.085-2.886-.929-.406-.884-.393-.021.041-1.244-.577-1.28 3.294zm-13.367-.853l.95.292 1.27.418 1.295.428 1.304.449 1.3.444.729.258.941-2.633-.741-.278-1.381-.485-1.35-.484-1.357-.442-2.239-.729-.721 2.762zm-18.119-.744l.633.121 1.726.336 1.733.38 1.739.408 1.769.42.421.094.698-2.77-.637-.17-1.802-.425-1.807-.401-1.766-.368-1.205-.243-1.502 2.618zm-59.543-2.295l-1.425.467-1.436.505-1.416.509-1.418.525-.477.192 1.107 3.058.506-.193 1.358-.525 1.36-.494 1.348-.499 1.361-.482.962-.313-.819-3.085-1.011.335zm18.243-.695l-.906.182-.886.179-.892.193-1.809.399-1.796.431-.504.126.673 2.7.404-.105 1.757-.4 1.746-.383 1.759-.364 1.759-.33.07-.014-1.313-2.625-.062.011zm40.018 2.758l.216.037.167.027 1.509-2.625-1.387-.268-.505 2.829zm-78.838-2.83l-.998.471-1.035.472-1.136.556-1.414.698-1.802.927-1.78.934 2.329 2.516 2.029-.792 1.068-.567 1.214-.646 1.228-.602 2.48-1.2.419-.187-2.146-2.773-.456.193zm117.287 2.345l.675.298 1.266.559 1.272.583 1.254.617.631.306.605.339.62.314.522.301 3.025.588.92-1.601-.114-.063-.528-.356-.588-.346-.648-.367-1.352-.76-1.465-.79-1.539-.801-1.561-.812-1.139-.583-1.856 2.574zm-8.531 1.203l.974.37 1.063.421 1.319-3.336-.301-.14-.031.027-.182-.124-.265-.125-1.647-.653-.615-.247-.315 3.807zm-98.102-3.678l-1.701.7-1.208.582 1.208 3.086 1.369-.566 1.108-.456-.344-3.514-.432.168zm29.975-.128l-.863.162 1.319 2.627.415-.069-.489-2.785-.382.065zm36.643 2.812l.07.009.647.108.504-2.813-.936-.162-.729-.116.444 2.974zm-33.95-3.243l-.891.134-.567.088.494 2.792.743-.122.511-2.928-.29.036zm23.016 1.968l.934.061 1.67.146 1.67.161 1.667.173 1.679.231 1.692.237.721.12-.433-2.963-.124-.013-1.726-.247-1.71-.214-1.698-.186-1.686-.179-1.703-.131-.879-.061-.074 2.865zm-1.979-.127l1.11.071.075-2.877-1.171-.056-.014 2.862zm-10.151-2.897l-.922.052-.912.055-.915.056-.901.059-1.808.162-1.819.193-.907.096-.911.125-.595.083-.51 2.922 1.394-.182 1.779-.209 1.78-.182L97.64 46l.882-.075.908-.059.884-.053.898-.046.839-.031-.108-2.853-.838.033zm60.278 2.854l.896.39 1.098.492 1.881-2.611-.646-.326-1.984-.866-1.245 2.921zM50.728 42.866l-.104.045-.094.04-.099.052-.076.045-.105.042-.083.042-.091.042-.101.041-.094.052-.09.051-.094.037-.092.04-.096.052-.083.04-.19.083-.086.056-.094.042-.092.037-.085.052-.101.033-.089.045-.097.047-.086.054-.1.036-.09.042-.085.035-.083.044 2.157 2.771.022-.007 1.246-.579.828-.365-1.589-3.097-.084.05zm53.127-.042l-.92.036-.117.007.101 2.85.092-.011 1.333-.019-.005-.555-.016-1.562-.022-.753-.446.007zm28.938 2.3l.698.148 1.806.433 1.83.468 1.383.364.083-.42.367-1.597.162-.729-1.364-.343-.372-.092-1.484-.373-1.849-.438-.584-.125-.676 2.704zm15.878.592l1.068.354 1.363.472 1.36.502 1.38.483.974.372.321-3.817-.431-.16-1.87-.707-1.885-.665-1.035-.363-1.245 3.529zm-85.629-3.225l-1.834.653-1.842.691-.545.205.341 3.502.887-.372 1.432-.541 1.418-.536 1.425-.512.92-.32-1.098-3.145-1.104.375zm65.92 1.818l.934.184 1.775.378.29.059.653-2.698-.391-.086-1.795-.381-1.466 2.544zm-47.711-2.623l-.924.188-.917.216-.914.21-1.847.438-1.442.377.318 1.236.397 1.58.056.2 1.438-.393 1.801-.466 1.826-.438 1.089-.234-.668-2.961-.213.047zm-43.142.311l-2.09 1.192-2.028 1.162 1.261 2.251 2.071-1.169 2.068-1.179.943-.506.557-.312-1.261-2.291-1.521.852zm44.195-.527l.664 2.933.781-.168.902-.171.731-.141-1.411-2.778-1.667.325zm90.706 1.838l.147.083 1.571.844 1.443.812 1.428.811 1.2.699.364-.245.962-1.741-.419-.236-.705-.432-.743-.453-.729-.449-1.529-.938-1.624-.965-.14-.077-1.226 2.287zm-26.868-2.253l.132.307.108.314.11.321.076.357.042.458-.539 2.058 1.785.574 1.25-3.54-.045-.01-1.885-.625-1.117-.356.083.142zm-79.37.215l-1.815.579 1.102 3.135 1.154-.384 1.054-.346-.421-1.579.014-.218.022-.172.038-.16.027-.157.038-.17.038-.147.045-.154.061-.148.061-.144.074-.133.068-.15.083-.139.027-.026-1.67.513zm-19.33-.116l-1.391.645-1.399.668-1.46.733-.767.388-.815.452-.859.468-.948.505-2.053 1.167-2.067 1.178.155.278 2.133.512 2.141-1.131 1.811-.938 1.418-.696 1.169-.556 1.019-.477 1.011-.469 1.137-.518 1.091-.51.099-1.486-.336-.696-1.089.483zm76.15 2.201l1.014.153 1.74.3 1.73.324 1.45-2.547-.929-.181-1.809-.317-1.794-.303-1.781-.273-.034-.012.413 2.856zm41.37-.422l1.05.526 1.566.791 1.559.811 1.543.807 1.499.788 1.361.771.657.377.59.353.541.356.263.171 2.413-1.589-.833-.491-1.43-.803-1.443-.804-1.539-.834-.844-.436-.871-.457-.934-.463-.99-.484-1.086-.501-1.143-.541-1.236-.563-.708-.308.015 2.523zm-8.92.581l.861.331 1.493.588 1.223-2.954-1.973-.908-.004.008-1.303-.496-.297 3.431zM55.726 40.743l-1.084.485 1.208 3.064 1.386-.566.656-.251-.341-3.42-1.825.688zm63.652 2.025v.004l1.728.222 1.604.223-.44-2.835-.851-.128-1.687-.209-.354 2.723zm-28.86-2.642l-.945.123-1.849.261-1.86.296-.995.177 1.392 2.774.205-.043.913-.161.896-.152.911-.144.905-.142.583-.088.525-2.984-.681.083zm87.918 2.418l.28.171.713.44.719.433.4.229 1.411-2.573-.997-.651-1.04-.659-1.486 2.61zM32.099 40.952l1.479 2.637 1.903-1.086-1.524-2.639-1.858 1.088zm62.151-1.244l-.922.087-.95.104-.285.034-.512 2.969.324-.036.917-.122.916-.106 1.568-.172-.206-2.844-.85.086zm17.02 2.382l1.29.071 1.688.112 1.712.146 1.719.157.839.109.356-2.731-.994-.113-1.769-.167-1.766-.146-1.749-.122-1.322-.069-.004 2.753zm-7.556-2.889l-1.893.027-.958.049-.957.022-.951.065-.94.042-.934.061-.958.083-.171.004.209 2.837 1.232-.119.917-.054.898-.059.913-.059.94-.052.922-.022.913-.032.945-.029.456-.014-.032-1.564-.01-1.195-.541.009zm33.99 3.339l.251.063 1.371.348.016-.068.026-.132.023-.113.017-.103.032-.135.008-.116.03-.124.024-.125.014-.124.029-.119.025-.135.033-.116.034-.126.041-.127.04-.135.063-.117.058-.123.056-.093.136-.25.174-.223.195-.195.2-.174.214-.171.242-.132.252-.124.044-.01-1.749-.472-.828-.212-1.071 3.683zm-61.437-3.873l-1.917.463-1.158.29.174.089.158.101.157.099.155.134.154.117.124.139.134.15.112.141.11.162.087.164.092.179.078.191.277 1.187 1.44-.369.79-.19-.678-3.121-.289.074zm54.604 2.307l1.541.326 1.834.415 1.858.428.756.183 1.075-3.694-.238-.056-1.907-.438-1.908-.426-1.03-.216-1.981 3.478zM82.06 37.429l-1.939.386-1.921.402-.807.191.682 3.097.23-.048.912-.212.917-.214 1.872-.393 1.562-.301-1.468-2.908h-.04zm-35.459.138l-.715.321-.713.345-.759.364-1.364.691-.723.386-.745.404-1.188.637 1.261 2.311.369-.195.779-.405 1.472-.734 1.405-.671 1.396-.64 1.082-.482-1.174-2.518-.383.186zm118.392 1.91l1.019.456 1.249.565 1.162.532 1.07.512.997.487 1.752.882 1.249-2.326-.925-.52-.973-.525-1.03-.557-1.09-.545-1.181-.567-1.246-.573-.936-.422-1.117 2.601zm-77.855-2.89h-.094l-.117.026-.116.021-.094.009-.11.017-.204.032-.121.015-.104.014-.115.019-.108.02-.104.016-.101.016-.107.015-.122.021-.101.014-.105.013-.104.023-.107.012-.108.022-.124.016-.202.031-.114.016-.112.021-.104.031-.096.011-.224.041-1.018.184 1.455 2.921 1.259-.226 1.876-.301.045-.007-.391-3.079-.108.016zm39.585 3.603l.207.049 1.832.313 1.233.231 1.971-3.481-.936-.172-.958-.178-.943-.161-.711-.112-1.051-.153-.644 3.664zm17.877-.63l.936.292 1.91.593 1.903.628 1.888.663 1.887.666 1.897.714.182.074.294-3.422-1.19-.447-1.489-.548-1.432-.513-1.414-.487-1.392-.474-1.383-.453-1.393-.411-.209-.063-.995 3.188zm-76.113-3.117l-1.412.402-1.441.44-1.465.471-1.5.478-1.564.539-1.654.583-1.061.382.339 3.406.334-.122 1.844-.697 1.86-.653 1.868-.63 1.872-.597 1.901-.593.112-.017.113-.039.108-.029.099-.033.118-.025.099-.033.108-.036.121-.03.101-.036.104-.023.11-.036.115-.036.111-.023.101-.038-.969-3.11-.472.135zm22.612-.4l-1.117.15-1.167.15-.122.022-.058.005-.07.018h-.059l-.125.012-.061.021-.057.002-.061.019-.099.007.397 3.079.959-.146.949-.122.929-.113.007-.005.559-3.187-.804.088zm31.95 3.566l.277.045 1.809.27.727.13.65-3.665-.561-.094v.049l-.527-.134-1.12-.148-1.154-.131-.659-.081.558 3.759zm-80.927-4.203l-.739.359-.759.381-.783.421-.819.425-.545.309-.328.186-.886.494-.96.537-1.589.914 1.503 2.644 1.455-.833 1.426-.799-.047-.036 1.024-.496 1.081-.597.757-.409.729-.388.917-.45-1.272-2.732-.165.07zm128.154 2.465l.7.346 1.019.556.994.543.94.527.871.505 1.645.976 1.255.774 1.492-2.63-.485-.32-.81-.481-.849-.495-.884-.519-.943-.507-.964-.532-1.025-.537-1.086-.553-.583-.281-1.287 2.628zm-68.98-2.687l-1.138.059-1.129.067-1.142.076-1.14.103-1.14.082-1.127.111-1.12.108-.55.061-.572 3.191.054-.009.931-.094 1.894-.184.94-.079.964-.074.948-.061.943-.045.953-.059.959-.031.842-.037-.12-3.197-.25.012zm12.143 3.409l.983.073 1.757.148 1.789.165 1.764.193 1.807.226.606.082-.55-3.718-.761-.08-1.153-.127-2.3-.175-1.159-.09-1.146-.06-1.16-.056-.301-.021-.176 3.44zm-3.255-3.544l.207.213.224.249.182.303.176.312.148.338.182.411-.025 1.598 1.291.068.181-3.432-1.142-.031-1.145-.03h-.279zm-5.449 0l-1.147.044-1.142.028h-.034l.112 3.229 1.176-.011.543-.019-.012-.974h-.137l.104-.433-.104-.431h.205l.067-.197.11-.261.137-.238.14-.217.184-.223.2-.195.125-.105-.527.003zm-69.866.18l-.247.177-.514.275-.554.29-.543.292-.586.317-.597.314-.595.336-.637.356-.271.169 1.364 2.435.051-.038.166-.092L32 40l.086-.045.067-.042.101-.061.063-.056.099-.045.085-.042.065-.054.097-.047.074-.056.092-.052.083-.042.074-.052.086-.049.094-.047.078-.049.085-.047.072-.054.085-.052.081-.038.084-.049.096-.049.081-.045.083-.042.082-.04.087-.047.081-.041 1.71-.997.976-.532.761-.42-1.199-2.395-1.54.816zm18.142.013l.854 2.197 1.392-.586.708-.275-.795-2.228-2.159.892zm123.424 1.573l.156.087.877.526.874.484.81.504.801.489.172.122.369.19-.025.034.966.611.953.624 1.418-2.587-.541-.332-.55-.362-.579-.372-.576-.357-.609-.365-.64-.35-.513-.301-2.114-1.113-1.249 2.468zm-18.899-.024l2.128.902.235-.205.938-2.293-.321-.155-.692-.312-.705-.314-.565-.233-1.018 2.61zM45.039 34.16l-.734.294-1.232.524 1.277 2.7.442-.225.727-.346.723-.323.372-.171-1.228-2.59-.347.137zm88.278 2.548l.76.15 1.905.427 1.915.45 1.917.491 1.905.517 1.923.539.13.038.995-3.182-.395-.117-1.461-.408-1.498-.402-1.571-.383-1.631-.388-1.735-.388-1.47-.313-1.689 2.969zm-55.403-2.574l-3.413.786-1.583.372-1.508.39-1.479.369-.148.042.974 3.102.117-.042.09-.023.115-.042.094-.019.099-.036.113-.021.109-.033.091-.021.109-.033.094-.026.113-.027.101-.029.103-.028.101-.038 1.948-.492 1.908-.464 1.95-.451 1.947-.404 1.754-.348-1.517-3-2.282.516zm88.542 1.948l.945.422 1.263.582.828.403 1.293-2.627-.99-.456-1.256-.585-.917-.415-1.166 2.676zm-37.64-.227l.454.085.943.16.976.174.957.19.271.054 1.701-2.966-.769-.16.038.184-3.897-.689-.674 2.968zm-47.12-2.57l-.631.15 1.52 3.015 1.275-.24 1.523-.253-.478-3.217-3.209.545zm-53.318.999l1.521 2.705.277-.148.628-.364.617-.339.599-.318.58-.32.566-.303.457-.219-1.38-2.831-3.865 2.137zm64.197-2.455l-.359.063-.497.105v-.039l-2.947.462.408 3.005.696-.09 1.122-.153 1.067-.125.556-3.238-.046.01zm87.903 3.01l.27.166.633.359.628.379.59.357.57.376.572.357.483.312 1.699-3.094-3.914-2.231-1.531 3.019zm-58.124.12l.886.104 1.174.134.731.112.505-3.117-2.542-.346v.05l-.508-.124-.738-.092.492 3.279zm-78.877-4.021l-.415.181-.42.188-.415.177-.425.195-.415.177-.414.197-.412.193-.425.197-.415.195-.421.214-.412.214-.423.204-.087.047-.096.049-.101.049-.09.058-.083.034-.092.069-.079.05-.104.049-.078.049-.085.049-.094.054-.094.056-.088.056-.099.047-.026.02 1.209 2.364.236-.139.827-.435.798-.418.768-.394.747-.353.124-.056.103-.05.092-.049.089-.044.097-.036.08-.047.086-.032.073-.036.081-.04.083-.025.092-.047.089-.033.072-.041.107-.032.099-.05.124-.051.715-.318.762-.296.294-.103-1.154-2.462-.385.155zm64.884 3.222l.964.009 1.147.012 1.171.035 1.167.025 1.154.056 1.167.06 1.155.056 1.162.105 2.302.171 1.17.114.544.061-.493-3.288-.329-.047-1.968-.2-.98-.104-.969-.078-.974-.077-.962-.069-.974-.065-1.942-.092-.949-.021-.975-.036-.946-.007-.644-.013v3.393zm-2.222-3.404l-.944.026-.952.025-.932.029-.958.054-.943.042-.929.049-.922.063-.936.073-1.834.188-.931.099-.913.107-.912.112-.518.063-.562 3.29.314-.049 1.115-.124 1.147-.092 1.158-.099 1.125-.083 1.143-.092 1.155-.068 1.138-.054 1.163-.054 1.149-.041 1.158-.042 2.312-.021h.254l.125-.024h.086v-3.38h-1.356zm27.007 1.715l1.674.341 1.837.393 1.744.391 1.652.393 1.555.384 1.533.414 1.458.398 1.443.416 1.402.421 1.403.456 1.402.476 1.428.494 1.432.508 1.505.559 1.543.574 1.269.487 1.501-1.253-2.66-1.13-1.651-.653-1.656-.616-1.646-.601-1.672-.585-1.666-.546-1.682-.514-1.71-.511-1.722-.48-.865-.225-.875-.213-1.79-.417-.905-.205-.901-.197-.929-.193-.907-.177-1.898-.369-1.089-.177.443 1.957zm13.806.498l1.298.397 1.679.561 1.68.576 1.659.606 1.667.626 1.657.66.15.069 1.01-2.625-.139-.042-.794-.313-.802-.32-.819-.31-1.717-.608-1.771-.605-1.828-.602-1.857-.574-.304-.094-.769 2.598zm-66.736-2.343l-1.983.384-1.901.383-1.832.386-1.769.406-1.748.41-1.714.451-1.688.442-1.677.494-1.656.513-.854.274-.828.276-.847.29-.849.303-.846.317-.882.307-.868.324-.891.339-1.8.733-1.394.582.023.099 1.636 1.427 1.566-.583 1.746-.642 1.661-.588 1.576-.537 1.501-.503 1.486-.449 1.441-.444 1.44-.421 1.463-.388 1.472-.376 1.515-.38 1.578-.379 3.429-.79.142-.031.133-.036.132-.025.137-.029.124-.025.123-.038.122-.023.134-.013.108-.037.127-.034.12-.017.111-.037.117-.02.121-.03.105-.02.105-.021.113-.031.103-.028.123-.026.097-.016.122-.033.097-.025.116-.012.104-.028.103-.022.117-.025.108-.029.097-.025.109-.024.207-.042.566-2.182-1.649.324zm87.731 1.979l.953.424 1.265.582 1.221.57 1.169.569 1.057.559 1.044.541.994.539.02.012 1.244-2.448-.684-.371-.833-.417-.88-.425-.907-.438-.934-.429-.983-.446-1.003-.466-1.043-.456-.659-.29-1.041 2.39zM66.749 30.326l-.861.249-.841.26-.856.251-.863.263-1.694.567-1.719.611-1.735.637-1.78.675-.426.184.802 2.225.298-.122.897-.339.869-.343.89-.312.844-.317.862-.29.857-.303.837-.271.855-.292 1.685-.499 1.676-.498.471-.126-.622-2.34-.446.13zm87.362 1.225l1.385.491.842.32.805.317.792.311.769.319.758.307.7.324.72.316.287.14 1.051-2.599-1.358-.571-1.743-.706-1.764-.703-1.775-.668-.635-.225-.834 2.627zM58.609 29.03l-1.797.678-1.815.698-1.844.743-1.493.631 1.037 2.653 3.387-1.378 1.788-.691 1.747-.642.536-.191-.943-2.702-.603.201zm47.318-1.041l-1.116.03-1.111.013-1.14.046-1.115.047-1.124.062-1.096.054-1.094.07-1.107.094-1.077.092-1.082.099-1.07.123-1.045.11-1.03.142-.691.099 1.334 1.912.359-.047v-.061h.44l.752-.103.934-.124.919-.099.925-.108.938-.083.927-.101.932-.068.938-.069.94-.063.951-.035.952-.041.962-.034.938-.022.954-.021h1.922l.977.021.957.002.969.036.954.025.981.042.974.045.988.061.991.08.959.069.988.079.993.105 1.982.206.202.025h.816v.108l.651.083 1.396-1.686v-.064l-.567-.105-.858-.135-.913-.112-.9-.12-.942-.1-.97-.093-.981-.089-.996-.081-1.028-.065-1.044-.081-1.048-.035-1.066-.047-1.08-.046-1.084-.013-1.09-.03h-3.33zm-28.361-.236l-1.927.397-1.85.418-1.819.402-1.769.439-1.735.449-.436.122.63 2.333.391-.094 1.714-.451 1.75-.419 1.803-.411 1.844-.391 1.901-.388.626-.117-.457-2.425-.666.136zm58.127 2.425l.153.02.929.19.929.187.917.195.924.212 1.796.423.875.226.864.224 1.74.479 1.304.383.77-2.585-.787-.241-1.907-.534-1.935-.507-1.941-.472-1.937-.444-1.892-.419-.251-.052-.551 2.715zM52.6 27.297l-.927.369-.916.357-.487.217 1.074 2.74 1.482-.624.801-.328-1.023-2.732H52.6zm-16.134 2.627l1.257 2.761.354-.183.418-.207.422-.224.418-.209.428-.198.428-.2.414-.197.433-.195.406-.182.438-.202.415-.184.425-.179.417-.185.345-.14-1.322-2.785-5.696 2.709zm123.684.082l1.048.42 1.355.577 1.203-2.972-.513-.179-.856-.336-.854-.317-.285-.111-1.098 2.918zm-80.604-2.65l-.465.101.456 2.413.515-.099 1.743-.327-.438-2.42-1.811.332zm52.981 2.246l1.42.245.892.16.551-2.715-.774-.152-.915-.167-.635-.125-.539 2.754zm36.8-.188l.664.301 1.053.463 1.007.468.985.44.938.435.917.438.891.438.424.2 1.261-3.148-6.817-3.084-1.323 3.049zm-76.083-4.055l-1.059.12-1.048.15-.487.06.266 2.521.691-.099 1.032-.134 1.061-.112.487-.061-.282-2.516-.661.071zm27.211 2.42l.245.024.91.132.903.122.884.134.525.082.31-2.732-.359-.062-.871-.12-.904-.117-.938-.125-.44-.04-.265 2.702zm20.808-.057l1.206.296 1.959.506 1.923.543 1.932.566 1.856.581 1.846.602 1.308.459.837-2.644-.355-.132-1.79-.63-.919-.29-.92-.303-.914-.276-.92-.281-.921-.273-.917-.265-.922-.245-.922-.254-.938-.245-.936-.24-.889-.208-.604 2.733zm-70.012-2.467l-1.847.456-1.822.499-1.807.509-1.809.529-1.769.559-1.778.602-.381.134.932 2.69.393-.136 1.701-.572.872-.27.861-.25.854-.256.861-.249 1.73-.485 1.752-.448 1.791-.437 1.822-.419h.014l-.628-2.873-1.742.417zm35.746-.717l-1.161.012-2.35.062-1.169.052-1.171.049-1.153.065-1.15.065-1.155.09-1.12.101-1.808.154.284 2.525.814-.075 1.1-.097 1.104-.096 1.115-.074 1.093-.059 1.133-.059 1.12-.042 1.141-.04 1.126-.014 1.122-.036h1.71l-.092-2.59-.533.007zm1.398-.016l.079 2.601h.805l1.077.036 1.1.014 1.092.04 1.067.042 1.059.042 1.051.075 1.033.069 1.007.084.99.092.846.083.26-2.71-.659-.056-1.033-.09-1.035-.065-1.075-.065-1.089-.049-1.086-.052-1.12-.029-1.136-.033-1.146-.012-1.157-.016h-.93zm24.828 1.479l.633.112.927.182.936.182.956.186 1.907.425 1.834.428.608-2.729-.128-.028-.94-.204-.943-.193-.941-.179-.943-.175-.943-.173-.931-.146-.934-.146-.619-.094-.479 2.552zm-54.198-2.427l-2.018.407-1.961.409-1.209.273.635 2.862.986-.218 1.933-.391 1.995-.39 1.825-.351-.532-2.926-1.654.325zm70.102 2.486l.375.116.902.282.932.304.917.289 1.811.629 1.813.659 1.794.678 1.665.653 1.095-2.888-.588-.209-.797-.318-.819-.308-1-.341-2.011-.715-.019.015-1.557-.558-1.352-.458-1.376-.447-.904-.278-.881 2.895zm-85.45-2.66l-1.371.421-1.331.416-.936.313-2.915 1.057v.007l-.359.13-1.454.512-.9.338-.9.348-.109.036 1.028 2.731.255-.106 1.825-.708 1.811-.67 1.816-.632L61.922 27l1.788-.573 1.816-.543.108-.026-.916-2.77-1.041.312zm-14.93.927l1.214 3.102.471-.193.927-.38.924-.361.912-.359.908-.35.919-.348 1.4-.504-1.181-3.064-6.494 2.457zm109.386.675l.386.146.817.299.814.314.835.299.851.33.863.317.864.339.51.19 1.261-3.1-5.948-2.267-1.253 3.133zm-58.298-3.961l-1.154.079-1.187.076-1.154.074-1.117.101-1.123.098-1.091.115-1.084.13-1.038.124-.627.099.308 2.891.449-.061 1.048-.148 1.085-.123 1.098-.117 1.12-.101 1.12-.113 1.143-.08 1.148-.101 1.161-.07 1.012-.06-.219-2.853-.898.04zm14.754 2.725l.429.026 1.095.056 1.073.064 1.059.07 1.03.101.988.08.99.097.949.117.921.117.895.123.315.059.312-2.733-.474-.086-.871-.111-.92-.124-.938-.114-.99-.11-1.014-.089-1.03-.089-1.073-.077-1.082-.063-1.091-.062-.431-.025-.142 2.773zm-7.18-2.93h-.421l-2.375.028-1.2.036-1.199.044-.612.016.193 2.861.498-.029 1.165-.049 2.371-.054 1.157-.011 1.181-.026h1.178l1.148.026 1.154.011 1.131.023.943.031.137-2.783-.963-.036-1.162-.041-1.171-.02-2.289-.028h-.864zm-30.61-.639l-.877.188-.889.187-.88.186-.442.106v.02l-3.573.764v-.014l-1.007.249-1.385.357-1.371.368-.824.247.906 2.774.889-.256 1.837-.494 1.855-.465 1.894-.446 1.924-.424 1.972-.417.592-.11-.473-2.839-.148.019zm60.328 2.929l.167.038.936.172.95.178.945.198.958.214.924.209.945.218.96.24.934.247.921.248.932.261.934.266.667.202.887-2.912-1.02-.308-1.367-.41-1.4-.371-.964-.251-.005.018-2.5-.614v.15l-.559-.284-.35-.085-.478-.108-.879-.177-1.823-.386-.108-.03-.607 3.077zm-57.635-3.447l-.911.174-.79.16.476 2.836.588-.125 1.667-.326-.521-2.816-.509.097zm54.363 2.928l.579.077.955.136.896.166.606-3.098-.903-.162-1.519-.254-.614 3.135zm-40.72-4.791l-.945.115-.945.132-.899.11-.47.067.296 2.839.593-.097 1.072-.132 1.075-.115.491-.06-.222-2.866-.046.007zm51.495 2.912l.991.252 1.389.375 1.401.415 1.386.414 1.374.438 1.376.438 1.374.476.974.336 1.026-3.242-10.545-2.956-.746 3.054zm-23.246-.099l.155.015.952.115.924.125.889.128.44.076.365-3.117-.499-.04-.993-.097-.973-.124-.994-.105-.266 3.024zm-62.528.021l.931 3.062.927-.303 1.345-.418 1.367-.426 1.357-.397 1.362-.386 1.383-.384 1.392-.357 1.007-.24-.778-3.227-10.293 3.076zm48.579-3.464l-1.74.024-1.736.023-1.717.049-1.7.067-3.909.157-.541.04-1.009.084-.983.092-.066.007.23 2.863.873-.08 1.143-.097 1.155-.089 1.183-.075 1.176-.074 1.193-.061 1.197-.045 1.209-.042 1.201-.042 2.395-.012h.543v-2.789h-.097zm.96-.005v2.794l2.175.012 1.189.026 1.171.047 1.126.05 1.137.042 1.098.056 1.106.07 1.084.087 1.03.076.999.094.29-3.004-.155-.007-1.002-.083-.503-.027-.51-.031h-.581v.022l-3.597-.163-1.758-.014-1.768-.042-1.756-.012-.775.007zm26.221 1.43l1.522.264.95.173.931.177 1.821.397.884.169.474.121.668-3.07-6.663-1.329-.587 3.098zm-61.811-1.856l.699 3.267.46-.101.892-.195.891-.177.877-.205.909-.16.894-.174.919-.183.505-.094-.602-3.303-6.444 1.325zM89.412 13.9l.379 3.483.44-.068.924-.123.924-.11.961-.13.991-.091.976-.085 1.011-.094.563-.04-.208-3.245-6.961.503zm28.662 2.621h.579l.532.032.52.036 1.015.061 1.012.099 1.004.094.98.135.969.08.516.056.375-3.222-7.411-.494-.091 3.123zm-17.276-3.247l.153 3.178 1.263-.032 1.717-.047 1.745-.033 1.743-.009-.009-.033h1.119l-.005.021.648-.005 1.771.017 1.761.028 1.322.026-.024-3.208-13.204.097zM47.952 125.746h118.546V86.085H47.952v39.661zm59.295-36.573l19.525 32.871H87.674l19.573-32.871z%22%2F%3E%3Cpath fill%3D%22%23FED406%22 d%3D%22M107.247 89.175l19.525 32.868H87.675l19.572-32.868zm-59.293 36.57h118.545V86.087H47.954v39.658z%22%2F%3E%3Cpath fill%3D%22%23EC2427%22 d%3D%22M91.37 120.008h31.706L107.24 93.347z%22%2F%3E%3Cdefs%3E%3Cpath id%3D%22a%22 d%3D%22M83.521 165.333c-1.997 1.67-3.525 4.621-5.137 7.287-2.524 5.681-18.348 4.791-20.636 14.539 3.798 1.78 9.89 2.244 14 2.939 1.364.223 2.261.574 3.491 1.22 3.248 1.874 6.096 4.274 9.047 6.587 3.011 2.302 5.965 4.325 9.746 5.067 4.669.958 9.495 2.117 13.588 4.637.395.258 1.013.763 1.531.662 1.23-.228 1.15 1.01.256 1.268-.595.168-1.162-.273-1.637-.574-4.113-2.593-8.963-3.748-13.671-4.736-3.841-.746-6.852-2.797-9.914-5.146-2.936-2.29-5.769-4.684-9.013-6.539-1.183-.63-2.027-.958-3.333-1.183-3.914-.655-10.736-1.155-14.381-2.966h-.02c-2-1.024-5.797-2.524-8.495-2.43 4.758 24.798 29.641 43.574 58.226 43.669 24.757-.216 45.539-14.196 54.428-31.303-.487.036-1.313.119-1.807.165-4.084.374-7.925 1.063-11.874 2.17-3.488 1.053-5.974 3.615-9.446 4.753-2.862.948-11.672 1.711-13.517 2.907-1.06.698-11.234 10.664-15.09 10.331-1.592-.129-.458-1.587-.014-1.475 3.61.48 13.27-9.067 14.495-9.89 1.879-1.24 11.894-2.059 14.046-3.078 3.295-1.587 5.86-3.826 9.346-4.876a66.765 66.765 0 0112.094-2.198c.585-.055 1.822-.089 2.416-.184 2.588-5.179 3.607-9.545 3.878-15.01-2.444-1.219-5.034-2.197-7.143-2.909-18.543-6.386-25.806 9.692-33.804 17.019v.014c-2.072 2.876-4.001 4.261-7.897 6.464-1.38.771-1.043-.919-.628-.997 1.99-1.167 6.56-3.795 7.559-6.243-1.307-2.243-5.393-6.047-12.162-10.618-1.769-.243-8.413-8.93-15.808-12.671-2.469-4.02-4.461-7.805-8.459-8.055a8.608 8.608 0 00-.554-.014c-1.43.001-2.639.513-3.707 1.397%22%2F%3E%3C%2Fdefs%3E%3CclipPath id%3D%22b%22%3E%3Cuse xlink%3Ahref%3D%22%23a%22%2F%3E%3C%2FclipPath%3E%3Cpath clip-path%3D%22url(%23b)%22 fill%3D%22%2307AB4D%22 d%3D%22M48.946 163.937h117.182v65.697H48.946z%22%2F%3E%3Cdefs%3E%3Cpath id%3D%22c%22 d%3D%22M103.845 158.512c-.144 1.235-.909-5.646-3.712-9.192-3.523-2.455-5.372-5.179-5.814-9.222-1.291 1.971-2.395 4.599-.44 9.256 1.64 2.681 4.584 6.987 3.617 10.91-5.456-3.943-10.882-7.873-16.327-11.824 4.13 5.224 8.262 10.439 12.395 15.65-3.736-1.249-2.886-2.892-6.52-4.139-3.272.287-10.258-.625-11.48-2.43.803 3.369 3.26 5.68 7.093 7.076l.137-.14c1.331-1.094 2.834-1.663 4.438-1.663.212 0 .424.009.648.036 4.253.248 6.448 3.863 8.772 7.667l.393.652c4.506 2.352 8.629 6.36 11.654 9.291 1.432 1.389 3.041 2.955 3.549 3.13a.853.853 0 01.428.166 77.169 77.169 0 016.362 4.756c2.801 1.201 5.588 2.392 8.387 3.604.021-.037.049-.064.07-.086-2.733-3.555-5.473-7.099-8.198-10.659 1.701.97 3.039 1.325 4.344 1.881 4.383 3.027 7.076 3.289 9.188 2.669a48.367 48.367 0 012.747-2.783c-6.503-.021-4.019-2.738-11.71-6.41 6.115-.848 12.247-1.677 18.382-2.497-6.813-.882-13.638-1.764-20.463-2.664 1.729-2.954 5.402-2.414 9.756-4.49 2.281-1.123 2.817-4.688 7.711-6.298-3.14-.03-6.302-.726-9.532 2.518-2.533 1.461-4.948 1.293-7.035 1.116-.92-.073-1.78-.156-2.554-.088 3.44-4.81 6.872-9.596 10.325-14.409-5.13 3.767-10.255 7.515-15.368 11.272.705-3.31.492-4.125 2.435-7.023 2.851-4.532-.21-9.385 2.594-11.585-.866-.093-4.501.677-5.821 7.336-1.271 3.982-2.625 6.479-5.17 8.881-.927-6.648-1.863-13.294-2.792-19.932l-2.489 19.667z%22%2F%3E%3C%2Fdefs%3E%3CclipPath id%3D%22d%22%3E%3Cuse xlink%3Ahref%3D%22%23c%22%2F%3E%3C%2FclipPath%3E%3Cpath clip-path%3D%22url(%23d)%22 fill%3D%22%23FED406%22 d%3D%22M75.564 138.846h66.686v53.252H75.564z%22%2F%3E%3Cpath fill%3D%22%23FFF%22 d%3D%22M76.311 237.028l.541.259c.805.377 1.211.067 1.569-.7.352-.744.269-1.249-.517-1.619l-.491-.239-1.102 2.299zm-1.771 3.738l.513.241c.966.457 1.317-.099 1.712-.911.388-.839.447-1.344-.426-1.758l-.536-.255-1.263 2.683zm2.208-7.735l1.746.829c1.553.74 1.637 2.033 1.122 3.124l-.146.308c-.419.894-.877 1.079-1.562 1.146.435.549.458 1.171.042 2.049l-.219.466c-.694 1.461-1.773 1.954-3.325 1.21l-1.638-.769 3.98-8.363zM81.467 235.208l3.69 1.416-.442 1.168-2.458-.939-.969 2.533 2.143.818-.445 1.165-2.138-.814-.973 2.536 2.453.947-.466 1.223-3.699-1.405zM85.755 236.814l1.265.394-2.344 7.574 2.511.78-.402 1.266-3.77-1.167zM89.667 245.31c-.155.615.182 1.008.651 1.118.468.117.94-.085 1.082-.705l1.129-4.75c.148-.618-.187-1.004-.653-1.104-.463-.117-.945.08-1.089.698l-1.12 4.743zm-.167-5.044c.346-1.473 1.632-1.945 2.676-1.69 1.05.245 1.99 1.24 1.64 2.71l-1.125 4.738c-.339 1.473-1.633 1.94-2.682 1.69-1.046-.246-1.988-1.24-1.639-2.706l1.13-4.742zM97.394 239.699l1.317.168-.496 3.938 1.633.197.494-3.931 1.322.165-1.16 9.182-1.319-.165.512-4.084-1.623-.207-.514 4.091-1.318-.168zM103.475 247.448c-.028.627.371.953.851.972.482.023.911-.257.94-.894l.233-4.885c.025-.639-.372-.956-.859-.977-.477-.021-.903.25-.941.9l-.224 4.884zm-1.101-4.949c.076-1.514 1.259-2.207 2.338-2.164 1.07.056 2.179.864 2.109 2.368l-.229 4.888c-.068 1.5-1.25 2.202-2.328 2.149-1.082-.048-2.188-.854-2.12-2.365l.23-4.876zM109.224 244.616l.75-.019c.924-.034 1.048-.556 1.025-1.479-.033-.935-.211-1.436-1.185-1.408l-.685.019.095 2.887zm-1.463-4.088l2.128-.069c1.573-.05 2.378.841 2.437 2.646.033 1.057-.238 1.849-1.075 2.352l1.569 4.169-1.407.043-1.356-3.901-.798.021.134 3.952-1.324.049-.308-9.262zM113.089 240.275l.891 9.217 1.32-.131-.898-9.212zM116.237 248.102l1.441-7.134-2.337.357-.197-1.234 3.774-.565.151 1.039-1.47 7.243 2.518-.379.189 1.238-3.89.586zM122.206 246.042c.142.62.61.822 1.08.712.473-.117.812-.498.666-1.121l-1.097-4.759c-.142-.615-.62-.811-1.093-.703-.463.099-.801.494-.651 1.112l1.095 4.759zm-2.392-4.46c-.343-1.467.603-2.455 1.659-2.703 1.049-.245 2.331.229 2.674 1.7l1.103 4.759c.332 1.468-.606 2.469-1.663 2.712-1.048.239-2.334-.241-2.668-1.706l-1.105-4.762zM124.415 238.245l1.213-.388 3.622 4.683.028-.009-1.731-5.309 1.264-.403 2.871 8.801-1.19.385-3.65-4.665-.024.012 1.724 5.283-1.264.418zM131.352 237.13l-1.411.6-.487-1.144 4.042-1.709.48 1.144-1.406.591 3.121 7.37-1.221.515zM134.021 234.6l3.516-1.783.567 1.109-2.343 1.188 1.23 2.428 2.044-1.034.567 1.11-2.041 1.026 1.234 2.433 2.331-1.195.604 1.183-3.523 1.794zM37.28 193.641l-1.387-.877 1.31-.508 1.392.875.476 1.239-8.62 3.366-.487-1.24zM39.563 198.894l-.565-1.342-.97.409-.464-1.077 2.145-.888 1.513 3.644-1.217.508-8.184.983-.536-1.304zM37.033 202.52l1.63 3.559-1.208.544-1.624-3.551zM43.036 206.774l-1.474-.724 1.236-.652 1.484.724.614 1.182-8.213 4.279-.611-1.177zM38.885 213.033l5.081-.476c.507-.057.723-.202 1.149-.479.395-.26.859-.561.505-1.107-.214-.323-.56-.418-.912-.184l-.63.423-.727-1.114.604-.399c.92-.598 2.167-.372 2.776.556.76 1.155.167 2.241-.864 2.919-.752.499-.961.595-1.854.694l-4.208.429 1.314 1.994-1.113.728-2.164-3.3 1.043-.684zM44.291 215.541l2.41 3.086-1.05.823-2.408-3.087zM51.093 218.311l-1.593-.382 1.071-.907 1.595.382.857 1.006-7.053 5.983-.862-1.02zM54.535 222.958a.654.654 0 00.035-.917c-.232-.245-.651-.28-.91-.039l-1 .914a.652.652 0 00-.03.914c.223.251.642.29.905.044l1-.916zm-2.675 2.455c.268-.239.268-.657.038-.921a.67.67 0 00-.916-.03l-1.34 1.233a.654.654 0 00-.033.912c.219.253.645.285.916.041l1.335-1.235zm2.15-4.888a1.876 1.876 0 011.531.625 1.82 1.82 0 01.489 1.585c-.085.553-.238.861-.983 1.555-.799.734-1.098.972-1.898.848.071.778-.188 1.077-1.223 2.017-.833.767-1.122.909-1.603.987-.532.078-1.167-.078-1.689-.639-.52-.558-.619-1.201-.489-1.731.11-.471.285-.758 1.11-1.519 1.033-.95 1.343-1.191 2.121-1.05-.056-.815.202-1.084 1-1.821.745-.682 1.071-.811 1.634-.857M55.718 226.651a.658.658 0 000 .935.653.653 0 00.931-.021l1.204-1.227a.646.646 0 000-.924.65.65 0 00-.931.012l-1.204 1.225zm-.747 1.713v-.051c-.112-.009-.274-.096-.477-.301a1.353 1.353 0 01-.386-1.213c.092-.42.285-.69 1.315-1.736.844-.865 1.07-1.013 1.538-1.127.642-.182 1.299.022 1.823.525.506.508.699 1.16.558 1.803-.106.482-.257.713-1.102 1.564-.806.829-1.03.965-1.51 1.188l-4.504 2.104-1.06-1.049 3.805-1.707zM59.211 230.321c.597.517.875.595 1.327.08l.776-.911c.24-.28.235-.644-.065-.917-.356-.301-.743-.136-.92.073l-.492.57-1.002-.864.506-.583c.712-.824 1.968-.882 2.794-.177.534.464.675 1.072.663 1.434-.009.551-.126.916-.898 1.812-.828.965-1.009 1.077-1.883.935.292.914.097 1.145-.763 2.134-.794.924-1.03 1.08-1.5 1.204-.564.156-1.176.099-1.787-.435-.642-.542-1.151-1.67-.198-2.768l.492-.576.997.873-.447.521c-.27.309-.274.703.031.968.306.259.673.206.969-.139l.867-1.008c.466-.544.421-.781-.232-1.342l.765-.884zM152.576 229.06l-.377 1.606-.913-1.081.377-1.6 1.007-.86 6.018 7.042-1.011.865zM159.399 231.901l-1.272-4.94c-.134-.491-.31-.682-.651-1.061-.318-.348-.691-.756-1.169-.324-.294.257-.32.613-.038.928l.516.556-.986.896-.491-.547a1.997 1.997 0 01.111-2.825c1.023-.928 2.191-.513 3.023.404.601.659.742.845.969 1.723l1.091 4.086 1.766-1.612.892.976-2.924 2.655-.837-.915zM164.795 224.433l-2.772 2.762-.938-.94 2.771-2.763zM162.883 219.23l-.115 1.645-1.07-.911.115-1.641.854-1.007 7.053 5.963-.856 1.013zM170.199 220.52l-2.448-4.469c-.256-.446-.467-.577-.898-.864-.391-.26-.854-.571-1.212-.019-.216.317-.159.671.193.903l.635.413-.731 1.109-.609-.404c-.915-.606-1.198-1.84-.592-2.766.752-1.15 1.991-1.038 3.029-.36.741.496.923.641 1.361 1.422l2.063 3.691 1.315-1.994 1.11.729-2.172 3.31-1.044-.701zM170.367 214.803l2.116-3.3 1.113.726-2.112 3.296zM170.74 207.445l.162 1.651-1.202-.723-.17-1.635.669-1.142 7.969 4.686-.669 1.155zM177.172 204.342a.668.668 0 00-.877.275.665.665 0 00.278.877l1.623.843c.314.163.705.023.869-.284a.665.665 0 00-.279-.873l-1.614-.838zm-3.227-1.67a.661.661 0 00-.879.271.668.668 0 00.28.882l1.197.613c.32.17.722.032.875-.277a.648.648 0 00-.275-.866l-1.198-.623zm-2.11 1.321c-.245-.517-.22-1.132.059-1.663a1.875 1.875 0 011.315-.992c.557-.107.9-.073 1.804.397.972.496 1.289.698 1.441 1.493.722-.338 1.08-.187 2.331.457 1.001.517 1.235.751 1.47 1.167.263.479.336 1.132-.024 1.805-.348.687-.918 1.006-1.463 1.059-.477.063-.802-.007-1.803-.523-1.25-.652-1.579-.852-1.712-1.631-.749.324-1.094.177-2.058-.319-.899-.469-1.127-.736-1.36-1.25M176.995 200.286a.645.645 0 00.867-.328.654.654 0 00-.348-.859l-1.573-.685a.647.647 0 00-.86.326.635.635 0 00.339.859l1.575.687zm1.86.085l-.038.017c.021.116 0 .298-.11.556a1.379 1.379 0 01-1.002.792c-.428.066-.738-.012-2.088-.6-1.104-.486-1.319-.632-1.604-1.026-.388-.535-.438-1.229-.155-1.893.299-.652.842-1.068 1.491-1.169.485-.076.738-.012 1.854.464 1.04.469 1.25.622 1.627.987l3.563 3.445-.583 1.362-2.955-2.935zM176.985 193.797l-.487 1.378 1.011.342-.392 1.106-2.181-.768 1.315-3.728 1.247.437 6.733 4.769-.472 1.327z%22%2F%3E%3Cdefs%3E%3Cpath id%3D%22e%22 d%3D%22M125.1 194.579c.509-.489 1.005-1.053 1.51-1.602l-4.877-2.097c1.504 1.427 2.646 2.688 3.367 3.699m3.15-3.439c.393-.457.781-.898 1.178-1.355.709-.824 1.434-1.692 2.187-2.538-.214.035-.402.066-.638.066-2.267 0-4.845-1.003-7.891-3.082-.072-.034-.152-.066-.232-.099l5.396 7.008zm-80.296-63.286l.004 49.512c.072 2.591.35 5.083.776 7.516.059-.012.108-.042.171-.042l.28-.007c2.43 0 5.461 1.048 7.496 1.95 1.637-6.054 7.415-8.05 12.655-10.126 3.507-1.388 7.132-2.529 8.004-4.5.35-.588.627-1.057.917-1.531 1.082-1.845 2.208-3.71 3.535-5.161-3.998-1.59-6.488-4.148-7.33-7.689a1.146 1.146 0 011.103-1.4c.365 0 .715.182.941.506.588.877 5.019 1.988 9.157 1.988.473 0 .899-.021 1.278-.048.032-.007.059-.007.104-.007.124 0 .253.014.362.064.301.097.579.204.828.31l-7.947-10.048a1.117 1.117 0 01.07-1.484 1.11 1.11 0 01.812-.347c.223 0 .46.071.663.216L96.54 158.17c-.202-2.705-1.982-5.579-3.246-7.609l-.383-.625c-2.236-5.272-.927-8.344.464-10.447.211-.331.568-.506.945-.506.096 0 .172.007.278.025.46.115.792.503.851.972.395 3.605 1.947 6.04 5.334 8.415a.98.98 0 01.24.224c1.03 1.295 1.785 2.974 2.352 4.554l1.832-14.472c.073-.561.548-.99 1.113-.99h.007c.565 0 1.044.411 1.122.974l2.472 17.575c1.38-1.725 2.349-3.741 3.291-6.695 1.267-6.392 4.856-8.135 6.764-8.135l.261.005c.429.055.779.36.922.76h.023c0 .012-.002.012-.009.012.007.021.024.037.024.048.129.441-.024.919-.381 1.208-.896.691-.909 1.884-.84 3.921.057 2.136.133 4.784-1.494 7.37-1.134 1.693-1.457 2.548-1.722 3.797l13.018-9.555a1.13 1.13 0 01.68-.221c.281 0 .566.106.788.329.399.397.449 1.013.122 1.458l-9.069 12.672c.132.007.256.009.37.016.68.063 1.398.126 2.149.126 1.66 0 2.954-.316 4.215-1.003 2.525-2.494 5.108-2.818 7.294-2.818.534 0 1.066.009 1.602.034.442.019.889.037 1.343.037a1.147 1.147 0 011.108.96 1.132 1.132 0 01-.774 1.245c-2.693.9-3.903 2.441-4.979 3.817-.769.962-1.481 1.888-2.583 2.42-1.757.839-3.371 1.264-4.784 1.647-1.204.321-2.211.581-3.021 1.026l18.156 2.366c.56.062.98.539.99 1.106 0 .572-.43 1.052-.99 1.133a2577.87 2577.87 0 00-15.034 2.025c1.572 1.045 2.47 1.966 3.215 2.72 1.263 1.312 1.851 1.906 5.094 1.906.285 0 .938-.019.948-.019.066 0 .127.034.19.051 3.782-3.211 8.26-5.586 14.091-5.586 2.657 0 5.503.515 8.45 1.534 1.764.593 4.356 1.55 6.908 2.791.105-1.121.2-2.258.238-3.402 0-16.495.004-33.005.004-49.512H47.954z%22%2F%3E%3C%2Fdefs%3E%3CclipPath id%3D%22f%22%3E%3Cuse xlink%3Ahref%3D%22%23e%22%2F%3E%3C%2FclipPath%3E%3Cpath clip-path%3D%22url(%23f)%22 fill%3D%22%230C73BB%22 d%3D%22M47.954 127.854h118.545v66.725H47.954z%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M109.087 209.611c-.307 0-.637-.06-.915-.248-.882-.588-8.248-3.93-11.127-4.364-2.976-.45-7.785-2.099-9.537-3.272-1.712-1.151-6.717-4.816-10.351-7.738-3.083-2.474-5.252-2.685-6.99-2.851-.251-.032-.489-.048-.712-.078-.29-.036-.642-.062-1.057-.092-2.081-.156-5.959-.443-11.767-2.747-6.306-2.501-8.894-1.947-8.918-1.934a.731.731 0 01-.873-.53.714.714 0 01.516-.875c.115-.03 2.963-.726 9.812 1.991 5.595 2.219 9.192 2.489 11.338 2.652.445.032.819.06 1.13.102.209.027.432.046.665.068 1.832.175 4.344.418 7.762 3.161 3.607 2.898 8.558 6.536 10.252 7.666 1.437.965 5.936 2.591 8.939 3.048 3.122.471 10.765 3.955 11.722 4.592.074.027.379-.01.596-.088a.723.723 0 01.912.457.72.72 0 01-.442.919c-.118.037-.511.161-.955.161M109.803 218.784a.725.725 0 01-.711-.59.726.726 0 01.579-.843c.025-.005 2.655-.517 5.195-2.407 1.604-1.192 3.811-3.053 5.579-4.545 1.253-1.055 2.334-1.969 2.977-2.458 1.833-1.396 7.223-2.288 9.46-2.609 2.458-.349 5.414-.933 9.336-3.396 3.949-2.487 8.339-3.535 15.063-4.607 6.012-.963 6.162-.577 6.389 0 .139.352.004.756-.33.98a.724.724 0 01-.945-.119c-.48.002-1.746.066-4.885.563-6.684 1.072-10.764 2.047-14.521 4.41-3.967 2.491-7.105 3.211-9.904 3.604-3.258.466-7.507 1.351-8.783 2.331-.616.462-1.686 1.369-2.925 2.411-1.788 1.505-4.008 3.379-5.65 4.599-2.824 2.097-5.672 2.644-5.792 2.667-.046.009-.091.009-.132.009M116.297 203.046a.724.724 0 01-.266-1.396c3.025-1.206 5.96-4.098 7.717-5.82.409-.406.75-.744 1.013-.976.608-.545 2.635-2.89 4.589-5.156 2.363-2.729 4.798-5.552 5.873-6.56 1.863-1.748 8.553-7.424 16.587-6.886 7.706.496 15.128 4.816 15.44 4.99.346.2.457.648.251.992a.722.722 0 01-.983.258c-.077-.044-7.449-4.318-14.801-4.798-7.441-.489-13.753 4.853-15.508 6.495-1.019.955-3.54 3.875-5.763 6.451-2.17 2.511-4.042 4.684-4.725 5.29-.247.221-.569.542-.96.926-1.832 1.808-4.901 4.83-8.196 6.137a.73.73 0 01-.268.053%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M124.979 195.851a.724.724 0 01-.651-.416c-.004-.012-.806-1.636-2.192-2.715-.404-.319-1.23-.974-2.26-1.792-2.74-2.175-7.328-5.826-8.279-6.449-1.357-.887-7.825-6.755-8.1-7.003-1.306-1.354-3.074-2.52-4.641-3.546-1.896-1.247-3.27-2.147-3.6-3.149-.864-2.591-4.025-6.337-7.713-6.633-3.584-.306-5.503 2.57-7.467 6.043-1.948 3.434-3.7 5.177-6.266 6.227-.689.278-1.362.482-2.074.689-1.712.512-3.844 1.152-7.924 3.353-5.485 2.956-6.188 7.157-6.2 7.194a.719.719 0 01-.825.604.722.722 0 01-.605-.822c.036-.2.828-4.956 6.941-8.252 4.212-2.271 6.421-2.929 8.196-3.462.706-.211 1.319-.393 1.948-.649 1.907-.774 3.506-1.989 5.548-5.593 1.611-2.846 4.053-7.166 8.844-6.778 4.506.368 8.015 4.764 8.97 7.626.173.523 1.684 1.516 3.023 2.397 1.626 1.063 3.469 2.278 4.85 3.717 1.813 1.64 6.84 6.137 7.889 6.828 1.007.659 5.448 4.189 8.388 6.525 1.02.813 1.843 1.47 2.248 1.779 1.658 1.296 2.571 3.156 2.604 3.241a.728.728 0 01-.334.967.776.776 0 01-.318.069%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M82.646 165.997a.636.636 0 01-.222-.041c-.451-.145-4.415-1.473-5.701-3.503-2.327-3.675-2.627-4.802-2.356-5.507a.932.932 0 01.521-.533c.579-.228 1.272.078 2.654.742.853.411 1.822.875 2.514.996 1.03.182 3.229.336 4.838.448 1.282.094 2.024.149 2.321.2 2.197.39 5.303 3.203 6.428 4.674a.716.716 0 01-.142 1.01.713.713 0 01-1.01-.131c-1.108-1.453-3.874-3.838-5.521-4.125-.247-.043-1.185-.107-2.181-.179-1.726-.124-3.878-.282-4.983-.471-.887-.151-1.95-.666-2.891-1.116-.327-.156-.718-.347-1.045-.484.224.553.771 1.642 2.075 3.702.855 1.354 3.84 2.549 4.919 2.9a.73.73 0 01.469.917.714.714 0 01-.687.501%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M134.958 183.383c-1.587 0-3.573-.316-4.572-1.725-1.133-1.594-4.784-3.597-6.094-4.237a.723.723 0 01.264-1.371c.08-.003 7.968-.545 10.515-1.091.534-.117 1.776-.28 3.218-.469.604-.083 1.357-.177 2.1-.28-2.286-.377-5.296-.8-7.138-1.029-2.728-.345-5.065-.581-6.944-.783-4.544-.482-4.716-.498-4.892-1.142a.794.794 0 01.294-.809c.435-.316 2.034-.861 5.465-1.963.853-.273 1.555-.494 1.835-.598.117-.048.261-.094.422-.146 1.066-.354 3.054-1.007 4.345-3.085 1.256-2.017 3.243-2.975 4.556-3.606.15-.075.314-.151.471-.229-1.028-.136-2.969-.133-4.862.046-.9.076-2.269 1.066-3.372 1.86-.727.533-1.416 1.024-2.014 1.33-1.408.693-6.712.675-7.766.668a.709.709 0 01-.637-.399.718.718 0 01.067-.753c2.87-3.854 7.063-9.536 9.237-12.642-1.672 1.116-3.824 2.652-4.749 3.367l-8.829 6.823a.722.722 0 01-1.141-.758c.041-.156 1.007-3.743 2.116-5.494 1.003-1.58 2.058-3.544 1.838-6.932-.171-2.724.532-4.212 1.039-5.08-.754.177-1.878.583-2.565 1.075-.842.61-2.089 2.693-3.039 6.729-.76 3.199-4.02 7.673-4.156 7.864a.735.735 0 01-.772.275.722.722 0 01-.531-.63c-.021-.153-1.727-16.188-2.178-18.34l-.036-.184a6.79 6.79 0 00-.094.944c-.086 2.069-2.054 17.307-2.135 17.956-.049.37-.377.676-.745.63a.725.725 0 01-.697-.683c0-.034-.202-3.454-.968-6.009-.565-1.878-2.425-3.516-3.923-4.83-.457-.406-.888-.78-1.236-1.127-1.079-1.06-1.627-3.122-2.078-4.782-.101-.372-.222-.824-.334-1.188-.604 1.137-1.335 3.567-1.126 5.65.164 1.67 1.351 3.716 2.307 5.354.468.811.911 1.575 1.183 2.214.828 1.92 1.438 5.565 1.47 5.719a.732.732 0 01-.326.729.721.721 0 01-.798-.007c-.189-.131-4.693-3.188-6.365-4.816-1.122-1.103-5.521-4.106-8.265-5.853.618.854 1.331 1.804 1.874 2.52l.574.768c1.578 2.108 5.992 7.729 6.035 7.784a.722.722 0 11-1.137.891c-.044-.055-4.466-5.689-6.059-7.807l-.574-.763c-3.573-4.745-3.664-5.053-3.485-5.59a.746.746 0 01.532-.487c.339-.08.653-.158 5.558 3.131 2.29 1.541 5.063 3.493 5.959 4.368 1.009.99 3.231 2.6 4.711 3.649-.247-1.183-.616-2.696-1.033-3.658-.238-.559-.658-1.286-1.107-2.063-1.023-1.762-2.295-3.958-2.493-5.931-.285-2.848.91-6.564 2.049-7.504a.952.952 0 01.894-.188c.687.224.927 1.105 1.352 2.706.383 1.41.901 3.342 1.703 4.125.332.331.734.685 1.169 1.063 1.636 1.444 3.674 3.233 4.358 5.505.092.319.186.652.263.983.605-4.791 1.397-11.274 1.445-12.524.103-2.387.828-2.949 1.423-2.992.767-.049 1.286.608 1.575 2.002.37 1.778 1.513 12.125 1.988 16.523 1.001-1.548 2.393-3.925 2.817-5.735.904-3.808 2.215-6.568 3.608-7.57 1.095-.783 3.654-1.72 4.623-1.336a.91.91 0 01.59.677c.087.448-.13.8-.383 1.213-.442.71-1.183 1.911-1.018 4.532.236 3.646-.848 5.902-2.058 7.797-.471.74-.924 1.911-1.278 2.942l7.021-5.425c1.632-1.266 7.032-5.35 8.037-4.851a.81.81 0 01.435.691c0 .279 0 .799-10.045 14.276 2.307-.03 5.002-.186 5.663-.512.494-.253 1.134-.713 1.813-1.206 1.371-.99 2.794-2.021 4.091-2.134 1.679-.156 5.675-.402 6.636.501.222.206.339.484.334.765-.019.797-.776 1.162-1.823 1.667-1.232.595-2.915 1.399-3.958 3.068-1.562 2.518-3.968 3.313-5.117 3.696-.144.046-.271.085-.375.124-.294.11-1.016.34-1.896.622-.722.232-1.82.583-2.813.916.515.058 1.082.117 1.656.18 1.888.197 4.229.445 6.975.79 11.007 1.371 11.052 1.814 11.113 2.43.089.917-.433 1.011-6.07 1.746-1.351.172-2.623.342-3.104.445-1.731.374-5.661.729-8.249.935 1.562.917 3.542 2.242 4.443 3.515 1.001 1.407 4.307 1.146 5.386.946a.715.715 0 01.842.574.723.723 0 01-.579.845 12.49 12.49 0 01-2.256.202M128.234 192.819a.725.725 0 01-.567-.269l-8.227-10.365a.727.727 0 01.031-.939.733.733 0 01.929-.124c.03.027 3.27 2.11 6.298 3.739 2.823 1.516 5.837 1.018 5.871 1.013a.72.72 0 01.254 1.419c-.146.03-3.53.606-6.812-1.155a100.94 100.94 0 01-2.883-1.635l5.666 7.146a.73.73 0 01-.11 1.02.76.76 0 01-.45.15%22%2F%3E%3Cpath fill%3D%22%23010101%22 d%3D%22M127.271 193.597a.855.855 0 01-.326-.066l-8.227-3.383a.867.867 0 01-.471-1.13.863.863 0 011.131-.476l8.225 3.383c.444.18.657.687.473 1.133a.88.88 0 01-.805.539M253.031 89.717h6.901c6.145 0 10.35-3.697 10.35-11.625 0-7.614-3.016-11.962-10.779-11.962h-6.472v23.587zm-15.525-35.106h27.174c15.739 0 21.129 11.627 21.129 23.26 0 16.09-9.81 23.373-24.475 23.373h-8.304v30.975h-15.525V54.611zM309.571 88.525h6.472c7.444 0 11.648-3.26 11.648-11.636 0-7.17-3.779-10.757-10.786-10.757h-7.335v22.393zm-15.518-33.92h28.669c12.727 0 20.487 6.746 20.487 20.004 0 10.322-4.092 17.287-12.825 19.132v.215c10.565 1.41 12.186 7.285 12.397 23.695.116 8.155.541 12.397 3.451 13.914v.649h-16.824c-1.502-2.166-1.832-5.104-1.938-8.146l-.428-14.893c-.221-6.086-2.914-9.787-9.167-9.787h-8.304v32.826h-15.518V54.605zM394.404 54.607v12.831h-27.502v18.256h25.883V98.52h-25.883v20.871h28.579v12.825h-44.098V54.607zM402.982 54.607h43.022v12.831h-27.495v18.256h25.876V98.52h-25.876v33.696h-15.527zM497.645 54.607v12.831h-27.499v18.256h25.882V98.52h-25.882v20.871h28.569v12.825h-44.098V54.607zM506.258 54.606h15.528v77.608h-15.528zM579.505 54.607v12.831h-16.817v64.778h-15.532V67.438h-16.823V54.607zM603.653 54.607v54.133c0 7.722 1.84 13.482 9.054 13.482 7.228 0 9.059-5.76 9.059-13.482V54.607h15.533v54.133c0 19.785-11.969 25-24.592 25-12.611 0-24.587-4.242-24.587-25V54.607h15.533zM661.346 88.525h6.464c7.443 0 11.649-3.26 11.649-11.636 0-7.17-3.778-10.757-10.779-10.757h-7.334v22.393zm-15.522-33.92h28.678c12.72 0 20.48 6.746 20.48 20.004 0 10.322-4.098 17.287-12.825 19.132v.215c10.559 1.41 12.18 7.285 12.4 23.695.105 8.155.533 12.397 3.442 13.914v.649h-16.813c-1.522-2.166-1.837-5.104-1.945-8.146l-.427-14.893c-.221-6.086-2.922-9.787-9.164-9.787h-8.306v32.826h-15.521V54.605zM724.367 102.98h15.098l-7.449-34.893h-.213l-7.436 34.893zm-2.046-48.375h19.189l20.382 77.617h-16.174l-3.556-16.41h-20.489l-3.559 16.41h-16.181l20.388-77.617zM248.842 204.011h4.405c5.438 0 9.139-1.984 9.139-8.574 0-6.589-3.702-8.491-8.663-8.491h-4.882v17.065zm0-25.005h3.225c6.228 0 9.057-2.139 9.057-7.458 0-5.389-2.601-7.382-8.185-7.382h-4.097v14.84zm-11.337-23.253h18.976c9.285 0 15.983 3.488 15.983 14.364 0 6.106-2.917 10.797-8.507 12.384v.156c6.223.875 10.243 5.641 10.243 13.177 0 8.889-4.334 16.588-17.566 16.588h-19.129v-56.669zM311.744 155.751v9.367h-20.076v13.335h18.893v9.373h-18.893v15.234h20.861v9.359h-32.197v-56.668zM318.757 212.419v-56.668h11.334v47.312h20.076v9.356zM372.544 205.125c6.691 0 7.794-5.798 7.794-21.039 0-15.156-1.104-21.034-7.794-21.034-6.694 0-7.794 5.878-7.794 21.034 0 15.242 1.101 21.039 7.794 21.039m0-50.483c17.004 0 19.129 12.223 19.129 29.444 0 17.229-2.125 29.442-19.129 29.442s-19.138-12.214-19.138-29.442c.001-17.221 2.135-29.444 19.138-29.444M415.14 155.751h11.332v21.67h13.225v-21.67h11.341v56.668h-11.341v-25.152h-13.225v25.152H415.14zM476.432 205.125c6.693 0 7.795-5.798 7.795-21.039 0-15.156-1.102-21.034-7.795-21.034-6.692 0-7.793 5.878-7.793 21.034 0 15.242 1.1 21.039 7.793 21.039m0-50.483c17.006 0 19.133 12.223 19.133 29.444 0 17.229-2.127 29.442-19.133 29.442-17.005 0-19.128-12.214-19.128-29.442 0-17.221 2.123-29.444 19.128-29.444M513.169 180.517h4.729c5.428 0 8.503-2.382 8.503-8.489 0-5.241-2.758-7.863-7.878-7.863h-5.354v16.352zm-11.337-24.764h20.946c9.291 0 14.952 4.924 14.952 14.603 0 7.538-2.985 12.621-9.366 13.965v.163c7.713 1.036 8.897 5.319 9.061 17.309.071 5.951.389 9.049 2.513 10.161v.469H527.66c-1.109-1.581-1.334-3.732-1.415-5.951l-.316-10.873c-.161-4.442-2.125-7.139-6.693-7.139h-6.065v23.963h-11.337v-56.67zM543.978 155.755h11.335v56.669h-11.335zM561.585 204.086l20.71-38.968h-19.29v-9.367h32.356v8.652l-21.024 38.657h21.342v9.359h-34.094zM618.516 205.125c6.695 0 7.795-5.798 7.795-21.039 0-15.156-1.1-21.034-7.795-21.034-6.684 0-7.791 5.878-7.791 21.034 0 15.242 1.107 21.039 7.791 21.039m0-50.483c17.001 0 19.137 12.223 19.137 29.444 0 17.229-2.136 29.442-19.137 29.442-17.003 0-19.135-12.214-19.135-29.442 0-17.221 2.132-29.444 19.135-29.444M656.947 155.751l13.701 38.816h.164v-38.816h10.394v56.668h-12.915l-13.86-39.674h-.155v39.674h-10.388v-56.668zM723.467 155.751v9.367h-12.28v47.301h-11.342v-47.301h-12.277v-9.367zM761.945 155.751v9.367h-20.864v13.335h18.894v9.373h-18.894v15.234h20.864v9.359h-32.196v-56.668z%22%2F%3E%3C%2Fsvg%3E\");background-size:auto 100%;background-repeat:no-repeat;margin-top:10px;float:right}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-0ed16698";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var __vue_component__$5 = __vue_component__$4;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: "Breadcrumb",

  data() {
    return {
      localBreadcrumbs: this.crumbs()
    };
  },

  props: {
    siglaSistema: {
      type: String,
      default: () => {
        return "SIGLA";
      }
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    $route() {
      this.localBreadcrumbs = this.crumbs();
    }

  },
  computed: {
    hasRouter() {
      return !!this.$router;
    },

    hasRouterCrumbs() {
      return !!this.$router && this.localBreadcrumbs.length > 0;
    }

  },
  methods: {
    crumbs() {
      if (this.$router && this.breadcrumbs.length == 0) return this.$route.meta.breadcrumbs || [];
      return this.breadcrumbs;
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', {
    staticStyle: {
      "--bs-breadcrumb-divider": "'>'"
    },
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [!_vm.hasRouterCrumbs && _vm.localBreadcrumbs.length ? _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.siglaSistema))]) : _vm.hasRouterCrumbs ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.siglaSistema))]) : [_vm._v(_vm._s(_vm.siglaSistema))]], 2), _vm._v(" "), _vm._l(_vm.localBreadcrumbs, function (crumb, i) {
    return _c('li', {
      key: i,
      class: {
        'breadcrumb-item': true
      }
    }, [!_vm.hasRouter && i != _vm.localBreadcrumbs.length - 1 && crumb.link ? _c('a', {
      attrs: {
        "href": crumb.link
      }
    }, [_vm._v(_vm._s(crumb.label))]) : _vm.hasRouter && i != _vm.localBreadcrumbs.length - 1 && crumb.link ? _c('router-link', {
      attrs: {
        "to": crumb.link
      }
    }, [_vm._v("\n        " + _vm._s(crumb.label))]) : [_vm._v(_vm._s(crumb.label))]], 2);
  })], 2)]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var __vue_component__$3 = __vue_component__$2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "piwebLoading",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    mensagem: {
      type: String,
      default: "CARREGANDO"
    },
    subMensagem: {
      type: String,
      default: "Por favor, aguarde alguns minutos..."
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.loading ? _c('div', {
    staticClass: "bg-dark text-center",
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "spinner-border text-white loader mb-3",
    attrs: {
      "role": "status"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row blink_me"
  }, [_c('div', {
    staticClass: "col-2 col-xs-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-xs-12"
  }, [_vm.mensagem ? _c('h3', {
    staticClass: "text-center text-white px-4"
  }, [_vm._v("\n        " + _vm._s(_vm.mensagem) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.subMensagem ? _c('p', {
    staticClass: "text-center text-white px-4"
  }, [_vm._v("\n        " + _vm._s(_vm.subMensagem) + "\n      ")]) : _vm._e()])])]) : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-6798c9c8_0", {
    source: "#loader[data-v-6798c9c8]{position:fixed;width:100vw;height:100vh;top:0;left:0;right:0;bottom:0;--bs-bg-opacity:0.4;z-index:1200}.loader[data-v-6798c9c8]{width:3rem;height:3rem;margin-top:40vh;z-index:1100}.blink_me[data-v-6798c9c8]{animation:blinker-data-v-6798c9c8 2s linear infinite}@keyframes blinker-data-v-6798c9c8{50%{opacity:.1}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-6798c9c8";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var __vue_component__$1 = __vue_component__;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PiwebTopo: __vue_component__$7,
  PiwebRodape: __vue_component__$5,
  PiwebBreadcrumb: __vue_component__$3,
  PiwebLoading: __vue_component__$1
});

const defaultValues = {
  urlBase: '',
  nomeArq: 'env.json',
  options: {
    mode: "no-cors",
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
};

const getEnv = (values = {}) => {
  let v = { ...defaultValues,
    ...values
  };
  return new Promise((resolve, reject) => {
    fetch(`${v.urlBase}/${v.nomeArq}`, v.options).then(data => {
      if (data.status == 200) {
        resolve(data.json());
      } else {
        reject({});
      }
    }).catch(err => {
      reject(err);
    });
  });
};

// Import vue components
const defaultOptions = {}; // install function executed by Vue.use()

const install = (Vue, options = {}) => {
  ({ ...defaultOptions,
    ...options
  });
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
  Vue.mixin({
    methods: {
      getEnv: getEnv
    }
  });
}; // Create module definition for Vue.use()

export { __vue_component__$3 as PiwebBreadcrumb, __vue_component__$1 as PiwebLoading, __vue_component__$5 as PiwebRodape, __vue_component__$7 as PiwebTopo, install as default };
